import 'axios';
import React, { useEffect, useState, Component, useMemo, createContext, useContext, useRef, memo, useCallback } from 'react';
import '@bugsnag/js';
import '@bugsnag/plugin-react';
import { errorHandler, ApiNotFoundError, ApiAvailabilityError, ApiValidationError } from '../errors/index.js';
import { getSpaces, getAgeGroups, getInvoiceContacts, getSpaceTypes, getYears, getCustomerBookings, getCustomerRecurringBookingAvailableDates, updateCustomerRecurringBooking, getSlots, updateCustomerSpaceBooking, postCustomerSpaceBooking, getRecurringSlots, updateCustomerRecurringSpaceBooking, postCustomerRecurringSpaceBooking, getFees, updateBookingFee, postBookingFee, updateBankHoliday, postBankHoliday, postInvoiceContact, updateCustomer, updateSpaceBooking, postSpaceBooking, updateSchoolBooking, postSchoolBooking, postSchoolBookings, updateFaq, postFaq, createPartner, postSpaceRates } from '../api/index.js';
import { useSchools, useSteps, useBankHolidays, useCustomers } from '../hooks/index.js';
import { WebAuth } from 'auth0-js';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { keyframes, css as css$17, jsx, ClassNames } from '@emotion/core';
import { Route, Redirect, NavLink, Link as Link$1, withRouter } from 'react-router-dom';
import { w as withTheme, t as theme } from '../theme-f3bad038.js';
export { w as withTheme } from '../theme-f3bad038.js';
import { useTheme } from 'emotion-theming';
import ReactSelect from 'react-select';
import MaskedInput from 'react-text-mask';
import { dateFromDatetime, ukDateFromDatetime, ukDateStringIsValid, dateFromUkDateString, isWithinNBusinessDays, getShortDateString, getTodaysDate, dateIsBefore, dateIsAfter, getYear as getYear$1, getMonth as getMonth$1, getDaysInMonth, getDay, subDays, addDays, format, setDay, setMonth, subMonths, addMonths, setYear, subYears, addYears, dateIsSame } from 'school-space-utils/date';
import { capitalise, slugify, getPluralNoun, convertCamelCaseToSentenceCase } from 'school-space-utils/string';
import { isEmpty, partition, throttle } from 'lodash';
import { decodeDiscount, encodeDiscount, getDiscountedHourlyRate } from 'school-space-utils/discount';
import { Editor } from 'react-draft-wysiwyg';
import { convertFromHTML, ContentState, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { Editor as Editor$1 } from '@tinymce/tinymce-react';
import ReactModal from 'react-modal';
import { frequencyIsFortnightly, datesAreOnAlternateWeeks, getRecurrenceOptions } from 'school-space-utils/recurrence';
import { formatToIso, calculateDurationInMinutes, formatToHoursMinutes } from 'school-space-utils/time';
import { useTable, useFilters, useSortBy, usePagination, useRowSelect } from 'react-table';
import S3FileUpload from 'react-s3';
class Auth {
  constructor(auth0Config, baseUrl) {
    const {
      domain,
      clientID,
      tenancy,
      realm,
      oAuth
    } = auth0Config;
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.handleAuthResult = this.handleAuthResult.bind(this);
    this.checkAuthentication = this.checkAuthentication.bind(this);
    this.fetchUser = this.fetchUser.bind(this);
    this.setUser = this.setUser.bind(this);
    this.user = null;
    this.realm = realm;
    this.oAuth = oAuth;
    this.baseUrl = baseUrl;
    this.auth0 = new WebAuth({
      domain,
      clientID,
      responseType: 'token id_token',
      audience: `https://${tenancy}.eu.auth0.com/userinfo`,
      scope: 'openid profile email',
      redirectUri: `${baseUrl}/callback`
    });
  }
  login(email) {
    if (this.oAuth) {
      return this.auth0.authorize({
        connection: 'google-oauth2',
        hd: 'school-space.org'
      });
    }
    return this.auth0.authorize({
      realm: this.realm,
      ...(email && {
        email
      })
    });
  }
  logout() {
    this.user = null;
    this.auth0.logout({
      returnTo: this.baseUrl
    });
  }
  setUser(data) {
    this.user = {
      ...(this.user || {}),
      ...data
    };
  }
  parseAuthHash() {
    return new Promise((resolve, reject) => {
      return this.auth0.parseHash((error, authResult) => {
        if (error) {
          return reject(new Error(`Error parsing auth hash: ${error.description}`));
        }
        if (!authResult || !authResult.idToken) {
          return reject(new Error('Invalid URL authentication result hash'));
        }
        return resolve(authResult);
      });
    });
  }
  checkAuthSession() {
    return new Promise((resolve, reject) => {
      return this.auth0.checkSession({}, (error, authResult) => {
        if (error) {
          return reject(new Error(`Error checking auth session: ${error.description}`));
        }
        return resolve(authResult);
      });
    });
  }
  async handleAuthResult() {
    const {
      idToken,
      idTokenPayload
    } = await this.parseAuthHash();
    this.setApiToken(idToken);
    await this.fetchUser(idTokenPayload);
  }
  async checkAuthentication() {
    if (this.user) {
      return;
    }
    const {
      idToken,
      idTokenPayload
    } = await this.checkAuthSession();
    this.setApiToken(idToken);
    await this.fetchUser(idTokenPayload);
  }
}

/** @jsx jsx */
const loadingAnimation = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;
const style = {
  wrapper: _ref => {
    let {
      fullScreen,
      fullHeight
    } = _ref;
    return theme => ({
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      maxWidth: '100vw',
      height: '100%',
      width: '100%',
      fontSize: theme.font.scale.medium,
      marginTop: theme.layout.baseline * 4,
      ...(fullScreen && {
        height: '100vh',
        background: theme.colors.white,
        marginTop: 0
      }),
      ...(fullHeight && {
        height: '100%',
        marginTop: 0,
        flexGrow: 1
      })
    });
  },
  loader: css$17`
        display: inline-block;
        position: relative;
        width: 64px;
        height: 64px;
    `,
  ring: css$17`
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 51px;
        height: 51px;
        margin: 6px;
        border: 6px solid #559ad4;
        border-radius: 50%;
        animation: ${loadingAnimation} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #559ad4 transparent transparent transparent;
    `,
  ring2: css$17`
        animation-delay: -0.45s;
    `,
  ring3: css$17`
        animation-delay: -0.3s;
    `,
  ring4: css$17`
        animation-delay: -0.15s;
    `
};
const Loading = _ref2 => {
  let {
    fullScreen,
    fullHeight
  } = _ref2;
  return jsx("div", {
    css: style.wrapper({
      fullScreen,
      fullHeight
    })
  }, jsx("div", {
    css: style.loader
  }, jsx("div", {
    css: style.ring
  }), jsx("div", {
    css: [style.ring, style.ring2]
  }), jsx("div", {
    css: [style.ring, style.ring3]
  }), jsx("div", {
    css: [style.ring, style.ring4]
  })));
};
Loading.propTypes = {
  fullScreen: PropTypes.bool,
  fullHeight: PropTypes.bool
};
Loading.defaultProps = {
  fullScreen: false,
  fullHeight: false
};
const AuthCallback = _ref => {
  let {
    auth,
    history
  } = _ref;
  useEffect(() => {
    const handleAuth = async () => {
      try {
        await auth.handleAuthResult();
        history.replace('/');
      } catch (error) {
        errorHandler.report(error);
        auth.logout();
      }
    };
    handleAuth();
  }, [auth, history]);
  return /*#__PURE__*/React.createElement(Loading, {
    fullScreen: true
  });
};
AuthCallback.propTypes = {
  auth: PropTypes.objectOf(PropTypes.any).isRequired,
  history: ReactRouterPropTypes.history.isRequired
};
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
const UserContext = /*#__PURE__*/React.createContext({});
const UserProvider = UserContext.Provider;
const UserConsumer = UserContext.Consumer;
const ProtectedRoute = _ref => {
  let {
    auth,
    component: Component,
    exact,
    path,
    ...rest
  } = _ref;
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  useEffect(() => {
    const checkUserIsAuthenticated = async () => {
      try {
        await auth.checkAuthentication();
        setIsAuthenticated(true);
      } catch (error) {
        errorHandler.report(error);
        setIsAuthenticated(false);
      }
    };
    checkUserIsAuthenticated();
  }, [auth, path]);
  if (isAuthenticated === null) {
    return jsx(Loading, {
      fullScreen: true
    });
  }
  return jsx(Route, _extends({}, rest, {
    render: props => isAuthenticated ? jsx(UserProvider, {
      value: auth.user
    }, jsx(Component, _extends({}, props, rest))) : jsx(Redirect, {
      to: "/login"
    })
  }));
};
ProtectedRoute.propTypes = {
  auth: PropTypes.objectOf(PropTypes.any).isRequired,
  component: PropTypes.elementType.isRequired,
  exact: PropTypes.bool,
  path: PropTypes.string.isRequired
};
ProtectedRoute.defaultProps = {
  exact: false
};
const withAuth = (WrappedComponent, auth) => class WithAuth extends Component {
  constructor(props) {
    super(props);
    this.logout = this.logout.bind(this);
  }
  login(email) {
    auth.login(email);
  }
  logout() {
    auth.logout();
  }
  render() {
    return /*#__PURE__*/React.createElement(WrappedComponent, {
      auth: auth,
      login: this.login,
      logout: this.logout
    });
  }
};

/** @jsx jsx */
const getColumnWidth = function () {
  let columnSpan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  let totalColumns = arguments.length > 1 ? arguments[1] : undefined;
  let gutterWidth = arguments.length > 2 ? arguments[2] : undefined;
  return `calc(${100 * (columnSpan / totalColumns)}% - ${gutterWidth}px)`;
};
const getColumnOffset = function () {
  let offsetSpan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let totalColumns = arguments.length > 1 ? arguments[1] : undefined;
  let gutterWidth = arguments.length > 2 ? arguments[2] : undefined;
  return `calc(${100 * (offsetSpan / totalColumns)}% + ${gutterWidth / 2}px)`;
};
const css = _ref => {
  let {
    s = [],
    m = [],
    l = [],
    alignRight
  } = _ref;
  return _ref2 => {
    let {
      grid: {
        columns,
        gutter
      },
      helpers
    } = _ref2;
    return {
      width: getColumnWidth(s[0], columns.s, gutter.s),
      marginLeft: getColumnOffset(s[1], columns.s, gutter.s),
      marginRight: getColumnOffset(s[2], columns.s, gutter.s),
      ...(m && {
        [helpers.mq('m')]: {
          width: getColumnWidth(m[0], columns.m, gutter.m),
          marginLeft: getColumnOffset(m[1], columns.m, gutter.m),
          marginRight: getColumnOffset(m[2], columns.m, gutter.m)
        }
      }),
      ...(l && {
        [helpers.mq('l')]: {
          width: getColumnWidth(l[0], columns.l, gutter.l),
          marginLeft: getColumnOffset(l[1], columns.l, gutter.l),
          marginRight: getColumnOffset(l[2], columns.l, gutter.l)
        }
      }),
      ...(alignRight && {
        textAlign: 'right'
      })
    };
  };
};
const Column = _ref3 => {
  let {
    styles,
    children,
    ...props
  } = _ref3;
  return jsx("div", {
    css: withTheme([css(props), styles])
  }, children);
};
Column.propTypes = {
  styles: PropTypes.oneOfType([PropTypes.func, PropTypes.objectOf(PropTypes.any)]),
  children: PropTypes.node.isRequired
};
Column.defaultProps = {
  styles: null
};

/** @jsx jsx */
const css$1 = _ref => {
  let {
    verticalAlign = 'center'
  } = _ref;
  return theme => ({
    display: 'flex',
    alignItems: verticalAlign,
    flexWrap: 'wrap',
    marginLeft: -theme.grid.gutter.s / 2,
    marginRight: -theme.grid.gutter.s / 2,
    [theme.helpers.mq('m')]: {
      marginLeft: -theme.grid.gutter.m / 2,
      marginRight: -theme.grid.gutter.m / 2
    },
    [theme.helpers.mq('l')]: {
      marginLeft: -theme.grid.gutter.l / 2,
      marginRight: -theme.grid.gutter.l / 2
    }
  });
};
const Row = _ref2 => {
  let {
    children,
    styles,
    ...props
  } = _ref2;
  return jsx("div", {
    css: withTheme([css$1(props), styles])
  }, children);
};
Row.propTypes = {
  styles: PropTypes.oneOfType([PropTypes.func, PropTypes.objectOf(PropTypes.any)]),
  children: PropTypes.node.isRequired
};
Row.defaultProps = {
  styles: null
};

/** @jsx jsx */
const css$2 = {
  label: _ref => {
    let {
      inline
    } = _ref;
    return theme => ({
      color: theme.colors.secondaryDark,
      fontWeight: 'bold',
      ...(!inline && {
        marginBottom: theme.layout.baseline / 2
      })
    });
  },
  column: {
    display: 'flex',
    flexDirection: 'column'
  }
};
const FieldSet = _ref2 => {
  let {
    label,
    labelInline,
    children,
    styles
  } = _ref2;
  return labelInline ? jsx("fieldset", null, jsx(Row, {
    verticalAlign: "baseline"
  }, jsx(Column, {
    s: [1],
    m: [2],
    l: [2]
  }, jsx("legend", {
    css: css$2.label({
      inline: true
    })
  }, label)), jsx(Column, {
    s: [5],
    m: [10],
    l: [10]
  }, children))) : jsx("div", {
    css: css$2.column,
    role: "group"
  }, jsx("legend", {
    css: css$2.label({})
  }, label), jsx("div", {
    css: styles
  }, children));
};
FieldSet.propTypes = {
  label: PropTypes.string.isRequired,
  labelInline: PropTypes.bool,
  children: PropTypes.node.isRequired,
  styles: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.any), PropTypes.func])
};
FieldSet.defaultProps = {
  labelInline: false,
  styles: {}
};

/** @jsx jsx */
const css$3 = {
  label: {
    maxWidth: '100%'
  },
  text: _ref => {
    let {
      inline
    } = _ref;
    return theme => ({
      color: theme.colors.secondaryDark,
      fontWeight: 'bold',
      ...(!inline && {
        marginBottom: theme.layout.baseline / 2,
        width: '100%'
      })
    });
  }
};
const Label = _ref2 => {
  let {
    id,
    htmlFor,
    text,
    inline,
    children
  } = _ref2;
  return inline ? jsx("label", {
    id: id,
    htmlFor: htmlFor,
    css: css$3.label
  }, jsx(Row, {
    verticalAlign: "baseline"
  }, jsx(Column, {
    s: [1],
    m: [2],
    l: [2]
  }, jsx("div", {
    css: css$3.text({
      inline: true
    })
  }, text)), jsx(Column, {
    s: [5],
    m: [10],
    l: [10]
  }, children))) : jsx("label", {
    id: id,
    htmlFor: htmlFor,
    css: css$3.label
  }, jsx("div", {
    css: css$3.text({
      inline: false
    })
  }, text), children);
};
Label.propTypes = {
  id: PropTypes.string,
  htmlFor: PropTypes.string,
  text: PropTypes.string.isRequired,
  inline: PropTypes.bool,
  children: PropTypes.node.isRequired
};
Label.defaultProps = {
  id: '',
  inline: false,
  htmlFor: ''
};

/** @jsx jsx */
const getSizeCss = (size, theme) => {
  switch (size) {
    case 'small':
      return {
        width: theme.layout.inputWidths.small * 2
      };
    case 'medium':
      return {
        width: theme.layout.inputWidths.medium
      };
    case 'large':
      return {
        width: theme.layout.inputWidths.large
      };
    default:
      return {
        width: '100%'
      };
  }
};
const css$4 = _ref => {
  let {
    options: {
      size
    },
    theme,
    overrides
  } = _ref;
  return {
    container: provided => ({
      ...provided,
      marginBottom: theme.layout.baseline,
      ...getSizeCss(size, theme),
      ...overrides.container
    }),
    control: (provided, state) => ({
      ...provided,
      minHeight: theme.layout.lineHeight + 2,
      color: theme.colors.black,
      borderColor: theme.colors.grey,
      borderRadius: theme.borders.radius.low,
      outline: 'none',
      '&:hover': {
        borderColor: state.isFocused ? 'transparent' : theme.colors.secondary
      },
      ...(state.isFocused && {
        ...theme.styles.focused
      }),
      ...overrides.control
    }),
    indicatorsContainer: provided => ({
      ...provided,
      color: theme.colors.grey,
      ...overrides.indicatorsContainer
    }),
    indicatorSeparator: provided => ({
      ...provided,
      backgroundColor: theme.colors.grey
    }),
    indicatorContainer: provided => ({
      ...provided,
      ...overrides.indicatorContainer
    }),
    menu: provided => ({
      ...provided,
      borderColor: theme.colors.grey,
      borderRadius: theme.borders.radius.low,
      boxShadow: theme.shadows.medium,
      zIndex: 100,
      ...overrides.menu
    }),
    option: (provided, state) => ({
      ...provided,
      ...(state.isFocused && {
        backgroundColor: theme.colors.greyLighter,
        '&:active': {
          backgroundColor: theme.colors.greyLight
        }
      }),
      ...(state.isSelected && {
        color: theme.colors.white,
        backgroundColor: theme.colors.primaryLight,
        '&:active': {
          backgroundColor: theme.colors.primary
        }
      }),
      ...(state.isDisabled && theme.styles.disabled),
      ...overrides.option
    }),
    placeholder: provided => ({
      ...provided,
      ...theme.styles.placeholder
    }),
    multiValueLabel: provided => ({
      ...provided,
      backgroundColor: theme.colors.greyLight
    }),
    multiValueRemove: provided => ({
      ...provided,
      backgroundColor: theme.colors.greyLight,
      '&:hover': {
        color: theme.colors.errorLight,
        backgroundColor: theme.colors.errorLighter
      }
    })
  };
};
const Select = _ref2 => {
  let {
    name,
    label,
    labelInline,
    value,
    placeholder,
    onChange,
    onScrollBottom,
    onClose,
    options,
    isDisabled,
    isLoading,
    isClearable,
    isSearchable,
    isMulti,
    maxMenuHeight,
    size,
    styles
  } = _ref2;
  const theme = useTheme();
  const labelId = `${name}-label`;
  const SelectWithProps = () => jsx(ReactSelect, {
    id: name,
    name: name,
    value: value,
    placeholder: placeholder,
    onChange: onChange,
    "aria-label": label || name,
    options: options,
    getOptionLabel: option => option.name,
    getOptionValue: option => option.id,
    "aria-labelledby": labelId,
    styles: css$4({
      options: {
        size
      },
      overrides: styles(theme),
      theme
    }),
    maxMenuHeight: maxMenuHeight,
    isDisabled: isDisabled,
    isLoading: isLoading,
    isClearable: isClearable,
    isSearchable: isSearchable,
    isMulti: isMulti,
    menuPortalTarget: document.body,
    onMenuScrollToBottom: onScrollBottom,
    onMenuClose: onClose
  });
  return label ? jsx(Label, {
    id: labelId,
    htmlFor: name,
    text: label,
    inline: labelInline
  }, jsx(SelectWithProps, null)) : jsx(SelectWithProps, null);
};
Select.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelInline: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.any), PropTypes.arrayOf(PropTypes.object)]),
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
  isMulti: PropTypes.bool,
  styles: PropTypes.func,
  size: PropTypes.string,
  maxMenuHeight: PropTypes.number,
  onScrollBottom: PropTypes.func,
  onClose: PropTypes.func
};
Select.defaultProps = {
  value: null,
  label: '',
  labelInline: false,
  placeholder: 'Select...',
  options: [],
  isDisabled: false,
  isLoading: false,
  isClearable: false,
  isSearchable: false,
  isMulti: false,
  styles: () => ({}),
  size: 'medium',
  maxMenuHeight: null,
  onScrollBottom: () => {},
  onClose: () => {}
};
const getStateCss = (state, theme) => {
  switch (state) {
    case 'warning':
      return {
        color: theme.colors.error,
        border: `1px solid ${theme.colors.errorLight}`
      };
    default:
      return {
        color: theme.colors.black,
        border: `1px solid ${theme.colors.grey}`,
        '&:focus': {
          borderColor: theme.colors.secondary
        }
      };
  }
};
const getSizeCss$1 = (size, theme) => {
  switch (size) {
    case 'small':
      return {
        width: theme.layout.inputWidths.small
      };
    case 'medium':
      return {
        width: theme.layout.inputWidths.medium
      };
    case 'large':
      return {
        width: theme.layout.inputWidths.large
      };
    default:
      return {
        width: '100%'
      };
  }
};
const css$5 = _ref => {
  let {
    size,
    state
  } = _ref;
  return theme => ({
    padding: `0 ${theme.layout.baseline * 3 / 4}px`,
    marginBottom: theme.layout.baseline,
    height: theme.layout.lineHeight + 2,
    fontSize: 'inherit',
    outline: 'none',
    borderRadius: theme.borders.radius.low,
    maxWidth: '100%',
    ...getStateCss(state, theme),
    ...getSizeCss$1(size, theme),
    '&::placeholder': {
      ...theme.styles.placeholder
    },
    '&:disabled': {
      ...theme.styles.disabled
    }
  });
};
const InputField = _ref => {
  let {
    type,
    name,
    value,
    placeholder,
    onChange,
    required,
    disabled,
    size,
    state,
    inputAttributes
  } = _ref;
  return jsx("input", _extends({
    css: css$5({
      size,
      state
    }),
    type: type,
    id: name,
    name: name,
    value: value,
    placeholder: placeholder,
    onChange: event => onChange(event.target.value),
    "aria-label": name,
    disabled: disabled
  }, inputAttributes, required && {
    required: true,
    'aria-required': true
  }));
};
InputField.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  borderless: PropTypes.bool,
  disabled: PropTypes.bool,
  state: PropTypes.string,
  size: PropTypes.string,
  inputAttributes: PropTypes.objectOf(PropTypes.any)
};
InputField.defaultProps = {
  type: 'text',
  placeholder: null,
  required: false,
  borderless: false,
  disabled: false,
  state: null,
  size: null,
  inputAttributes: {}
};

// const updatedAdminBooking = [
//     {
//         id: 'new-sale-did-not-convert-pending-booking',
//         name: 'New sale - did not convert pending booking'
//     },
//     {
//         id: 'new-sale-customer-cancelled-within-first-6-weeks',
//         name: 'New sale - customer cancelled within first 6 weeks'
//     },
//     {
//         id: 'booking-cancellation-start-date-of-booking-pushed-back',
//         name: 'Booking cancellation- start date of booking pushed back'
//     },
//     {
//         id: 'booking-cancellation-alternate-booking-made',
//         name: 'Booking cancellation- alternate booking made'
//     },
//     { id: 'booking-cancellation-change-to-space', name: 'Booking cancellation- change to space' },
//     {
//         id: 'booking-cancellation-ooh-alternate-booking-made',
//         name: 'Booking cancellation- OOH alternate booking made'
//     },
//     {
//         id: 'booking-cancellation-ooh-full-cancellation',
//         name: 'Booking cancellation- OOH full cancellation'
//     },
//     {
//         id: 'booking-cancellation-holidays-planned-customer-break',
//         name: 'Booking cancellation - holidays/planned customer break'
//     },
//     {
//         id: 'booking-cancellation-staffing',
//         name: 'Booking Cancellation - Staffing'
//     },
//     {
//         id: 'chrun-too-many-cancellations',
//         name: 'Churn - too many cancellations made by School Space'
//     },
//     { id: 'chrun-school-space-restrictions', name: 'Churn - School Space restrictions/policies' },
//     {
//         id: 'chrun-unsuitable/found-more-suitable-venue',
//         name: 'Churn - unsuitable/found a more suitable venue'
//     },
//     { id: 'chrun-service-complaint-cc', name: 'Churn - service complaint CCs' },
//     { id: 'chrun-service-complaint-head-office', name: 'Churn - service complaint head office' },
//     { id: 'chrun-complaint-school', name: 'Churn - complaint - school' },
//     { id: 'chrun-change-to-space-by-school', name: 'Churn - change to space by school' },
//     { id: 'chrun-price-to-high', name: 'Churn - price to high' },
//     { id: 'chrun-the-quality-of-space', name: 'Churn - the quality of space' },
//     { id: 'chrun-low-attendence', name: 'Churn - low attendance' },
//     { id: 'chrun-other', name: 'Churn - other' },
//     { id: 'other-in-month', name: 'Other - In month' },
//     { id: 'other-pre-booking', name: 'Other - pre-booking ' }
// ];

const updatedCustomerBooking = [{
  id: 'break-for-holiday',
  name: 'Break for holiday'
}, {
  id: 'low-attendees',
  name: 'Low attendees'
}, {
  id: 'found-another-venue',
  name: "I've found another venue"
}, {
  id: 'booked-space-no-longer-suitable',
  name: 'Booked space no longer suitable'
}, {
  id: 'timings-are-no-longer-suitable',
  name: 'Timings are no longer suitable'
}, {
  id: 'school-space-policies',
  name: 'School Space policies'
}, {
  id: 'unsatisfied-with-the-school',
  name: 'Unsatisfied with the school'
}, {
  id: 'unsatisfied-with-school-space-service',
  name: 'Unsatisfied with School Space service'
}];
const customerBooking = [{
  id: 'low-attendees',
  name: 'Low attendees'
}, {
  id: 'break-for-holiday',
  name: 'Break for holiday'
}, {
  id: 'space-not-suitable',
  name: 'Space not suitable'
}, {
  id: 'timings-not-suitable',
  name: 'Timings not suitable'
}, {
  id: 'price-too-high',
  name: 'Price too high'
}, {
  id: 'covid-restrictions',
  name: 'COVID restrictions'
}];
const customerRebooking = [{
  id: 'too-early',
  name: 'Too early in the year to confirm'
}, {
  id: 'covid-19',
  name: 'Uncertainty due to COVID-19'
}, {
  id: 'price-too-high',
  name: 'Price too high'
}, {
  id: 'change-to-terms',
  name: 'Change in Terms & Conditions'
}, {
  id: 'space-not-suitable',
  name: 'Space not suitable'
}, {
  id: 'timings-not-suitable',
  name: 'Timings not suitable'
}, {
  id: 'no-longer-operating',
  name: 'No longer running classes'
}];
const customerOneOff = [...customerBooking, {
  id: 'lack-of-equipment',
  name: 'Lack of equipment'
}, {
  id: 'found-alternate-venue',
  name: 'Found alternate venue'
}];
const adminReasons = [{
  id: 'covid-school-decision',
  name: 'COVID - School decision'
}, {
  id: 'covid-staffing',
  name: 'COVID - Staffing'
}, {
  id: 'school-clash-short',
  name: 'School clash (< 2 weeks)'
}, {
  id: 'school-clash-mid',
  name: 'School clash (2 weeks - 2 months)'
}, {
  id: 'school-clash-long',
  name: 'School clash (> 2 months)'
}, {
  id: 'booking-error',
  name: 'Booking error'
}, {
  id: 'adverse-weather',
  name: 'Adverse weather'
}];
const updatedAdminReasons = [{
  id: 'Customer Cancellation',
  name: 'Customer Cancellation'
}, {
  id: 'School: OofH',
  name: 'School : OofH'
}, {
  id: 'Bad Debt',
  name: 'Bad Debt'
}, {
  id: 'School:Issue with Space',
  name: 'School : Issue with Space'
}, {
  id: 'School Space:Delayed start',
  name: 'School Space : Delayed start'
}, {
  id: 'School Space: Our Error(customer service)',
  name: 'School Space : Our Error(customer service)'
}, {
  id: 'School Space: Our Error(staffing)',
  name: 'School Space : Our Error(staffing)'
}, {
  id: 'School Space: Mis-sell',
  name: 'School Space : Mis-sell'
}, {
  id: 'No Fault:Adverse Weather',
  name: 'No Fault : Adverse Weather'
}, {
  id: 'school-space:discount-given-for-other-reason',
  name: 'School Space : Discount given for other reason'
}];
const adminBooking = [...customerBooking, ...adminReasons];
const adminOneOff = [...customerOneOff, ...adminReasons];

// eslint-disable-next-line import/prefer-default-export
const getCancellationReasons = cancellationType => {
  let options;
  switch (cancellationType) {
    case 'adminOneOff':
      options = adminOneOff;
      break;
    case 'adminBooking':
      options = adminBooking;
      break;
    case 'customerOneOff':
      options = customerOneOff;
      break;
    case 'customerBooking':
      options = customerBooking;
      break;
    case 'customerRebooking':
      options = customerRebooking;
      break;
    case 'updatedCustomerBooking':
      options = updatedCustomerBooking;
      break;
    case 'updatedAdminBooking':
      options = updatedAdminReasons; // updatedAdminBooking;
      break;
    default:
      options = [];
      break;
  }
  return [...options, {
    id: 'other',
    name: 'Other (please specify)'
  }];
};

/** @jsx jsx */
const css$6 = {
  container: theme => ({
    maxWidth: theme.layout.baseline * 22
  }),
  description: theme => ({
    height: theme.layout.baseline * 3
  })
};
const selectCss = theme => ({
  container: {
    marginBottom: theme.layout.baseline / 2
  }
});
const CancellationPicker = _ref => {
  let {
    value,
    description,
    onChange,
    onDescriptionChange,
    cancellationType
  } = _ref;
  const options = useMemo(() => getCancellationReasons(cancellationType), [cancellationType]);
  const showDescription = value === 'other';
  return jsx(FieldSet, {
    label: "Cancellation reason",
    styles: css$6.container
  }, jsx(Select, {
    name: "cancellation-reason",
    placeholder: "Select a reason",
    value: options.find(option => option.id === value),
    onChange: onChange,
    options: options,
    styles: selectCss
  }), jsx("div", {
    css: css$6.description
  }, showDescription && jsx(InputField, {
    name: "cancellation-description",
    value: description,
    placeholder: "Tell us why you're cancelling",
    onChange: onDescriptionChange,
    required: true
  })));
};
CancellationPicker.propTypes = {
  value: PropTypes.string,
  description: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onDescriptionChange: PropTypes.func.isRequired,
  cancellationType: PropTypes.string.isRequired
};
CancellationPicker.defaultProps = {
  value: null,
  description: ''
};
const SpacePicker = _ref => {
  let {
    schoolId,
    siteId,
    space,
    setSpace,
    ...selectProps
  } = _ref;
  const [spaces, setSpaces] = useState([]);
  const [visibleSpaces, setVisibleSpaces] = useState([]);
  const [page, setPage] = useState(1);
  const pageSize = 50;
  useEffect(() => {
    const fetchSpaces = async () => {
      try {
        const data = await getSpaces({
          schoolId,
          siteId
        });
        if (Array.isArray(data)) {
          setSpaces(data);
          setVisibleSpaces(data.slice(0, pageSize));
          setPage(1);
        } else {
          setSpaces([]);
          setVisibleSpaces([]);
        }
      } catch (err) {
        console.error('Error fetching spaces:', err);
        setSpaces([]);
        setVisibleSpaces([]);
      }
    };
    fetchSpaces();
  }, [schoolId, siteId]);
  const loadMoreSpaces = () => {
    const nextPage = page + 1;
    const start = page * pageSize;
    const end = start + pageSize;
    const nextBatch = spaces.slice(start, end);
    if (nextBatch.length > 0) {
      setVisibleSpaces([...nextBatch]);
      setPage(nextPage);
    }
  };
  return /*#__PURE__*/React.createElement(Select, _extends({
    name: "space",
    label: "Space",
    placeholder: "Select a space",
    value: space.id ? space : null,
    onChange: newSpace => setSpace(newSpace),
    options: visibleSpaces,
    onScrollBottom: () => {
      if (visibleSpaces.length < spaces.length) {
        loadMoreSpaces();
      }
    },
    onClose: () => {
      if (spaces.length > pageSize) {
        setVisibleSpaces(spaces.slice(0, pageSize));
        setPage(1);
      }
    }
  }, selectProps));
};
SpacePicker.propTypes = {
  schoolId: PropTypes.string.isRequired,
  siteId: PropTypes.string,
  space: PropTypes.objectOf(PropTypes.any),
  setSpace: PropTypes.func.isRequired
};
SpacePicker.defaultProps = {
  space: {},
  siteId: null
};

/** @jsx jsx */
const css$7 = {
  button: _ref => {
    let {
      active,
      disabled,
      highlighted
    } = _ref;
    return theme => ({
      height: theme.layout.lineHeight,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0,
      border: `1px solid ${theme.colors.grey}`,
      borderRadius: theme.borders.radius.low,
      backgroundColor: theme.colors.white,
      '&:disabled': {
        ...(!highlighted && {
          borderColor: theme.colors.greyLight,
          color: theme.colors.greyLight
        })
      },
      ...(active && {
        borderColor: theme.colors.secondary,
        backgroundColor: theme.colors.secondary,
        color: theme.colors.white
      }),
      ...(highlighted && {
        borderColor: theme.colors.secondaryLight,
        backgroundColor: theme.colors.secondaryLight,
        color: theme.colors.white
      }),
      '&:hover': {
        ...(!disabled && {
          borderColor: theme.colors.secondary
        })
      }
    });
  }
};
const PickerButton = _ref2 => {
  let {
    value,
    active,
    disabled,
    highlighted,
    handleClick,
    ariaLabel
  } = _ref2;
  return jsx("button", {
    type: "button",
    css: css$7.button({
      active,
      disabled,
      highlighted
    }),
    onClick: () => handleClick(value),
    disabled: disabled,
    "aria-pressed": active,
    "aria-label": ariaLabel
  }, value);
};
PickerButton.propTypes = {
  value: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  highlighted: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired
};
PickerButton.defaultProps = {
  disabled: false
};

/** @jsx jsx */
const css$8 = {
  container: {
    flexBasis: 0,
    flexGrow: 1,
    overflowY: 'scroll',
    padding: 4,
    margin: '0 -4px'
  },
  grid: _ref => {
    let {
      numColumns
    } = _ref;
    return theme => ({
      ...theme.styles.grid({
        gap: 6,
        numColumns
      })
    });
  }
};
const TimePicker = _ref2 => {
  let {
    name,
    labelId,
    timesPerHour,
    times,
    setTime,
    loading
  } = _ref2;
  console.log({
    times
  });
  return jsx("div", {
    css: css$8.container
  }, loading ? jsx(Loading, {
    fullHeight: true
  }) : jsx("ul", {
    "aria-labelledby": labelId,
    css: css$8.grid({
      numColumns: timesPerHour
    })
  }, times.map(_ref3 => {
    let {
      time,
      selectable,
      selected,
      highlighted
    } = _ref3;
    return jsx("li", {
      key: `time-${time}`
    }, jsx(PickerButton, {
      value: time,
      handleClick: setTime,
      active: selected,
      highlighted: highlighted,
      disabled: !selectable,
      ariaLabel: `Pick ${name}: ${time}`
    }));
  })));
};
TimePicker.propTypes = {
  timesPerHour: PropTypes.number.isRequired,
  times: PropTypes.arrayOf(PropTypes.object).isRequired,
  setTime: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  labelId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};

/** @jsx jsx */
const css$9 = {
  button: _ref => {
    let {
      active,
      disabled,
      placeholder
    } = _ref;
    return theme => ({
      width: '100%',
      marginBottom: theme.layout.baseline,
      height: theme.layout.lineHeight + 2,
      border: `1px solid ${theme.colors.grey}`,
      borderRadius: theme.borders.radius.low,
      backgroundColor: 'transparent',
      textAlign: 'left',
      padding: `0 ${theme.layout.baseline * 3 / 4}px`,
      ...(active && {
        borderColor: theme.colors.secondary
      }),
      ...(disabled && theme.styles.disabled),
      ...(placeholder && theme.styles.placeholder),
      '&:disabled': {
        backgroundColor: 'transparent'
      },
      '&:hover': {
        cursor: 'pointer'
      }
    });
  }
};
const PickerField = _ref2 => {
  let {
    id,
    label,
    placeholder,
    value,
    active,
    disabled,
    onClick
  } = _ref2;
  return jsx(Label, {
    htmlFor: id,
    text: label
  }, jsx("button", {
    id: id,
    type: "button",
    css: css$9.button({
      active,
      placeholder: !value,
      disabled
    }),
    onClick: onClick,
    "aria-label": `Open ${label} picker`,
    "aria-expanded": active,
    disabled: disabled
  }, active ? value || placeholder : value));
};
PickerField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string,
  active: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
PickerField.defaultProps = {
  value: null
};
const pickers = {
  startTime: 'startTime',
  endTime: 'endTime'
};
const timeIsHighlighted = (timeIndex, startTimeIndex, endTimeIndex, endTime) => {
  if (timeIndex === startTimeIndex) {
    return true;
  }
  if (!endTime) {
    return false;
  }
  if (timeIndex > startTimeIndex && timeIndex < endTimeIndex) {
    return true;
  }
  return false;
};
const endTimeIsSelectable = (timeIndex, startTimeIndex, times) => {
  if (timeIndex <= startTimeIndex) {
    return false;
  }
  for (let i = timeIndex - 1; i > startTimeIndex; i -= 1) {
    if (!times[i].available) {
      return false;
    }
  }
  return timeIndex > startTimeIndex;
};
const startTimeIsValid = (times, startTime) => {
  const startOption = times.find(_ref => {
    let {
      time
    } = _ref;
    return time === startTime;
  });
  return startOption && startOption.available;
};
const endTimeIsValid = (times, startTime, endTime) => {
  if (!endTime) {
    return false;
  }
  const startTimeIndex = times.findIndex(_ref2 => {
    let {
      time
    } = _ref2;
    return time === startTime;
  });
  const endTimeIndex = times.findIndex(_ref3 => {
    let {
      time
    } = _ref3;
    return time === endTime;
  });
  if (endTimeIndex <= startTimeIndex) {
    return false;
  }
  for (let i = startTimeIndex + 1; i < endTimeIndex; i += 1) {
    if (!times[i].available) {
      return false;
    }
  }
  return true;
};
const addStatesToTimes = (times, pickingStartTime, startTime, endTime) => {
  const value = pickingStartTime ? startTime : endTime;
  const startTimeIndex = times.findIndex(_ref4 => {
    let {
      time
    } = _ref4;
    return time === startTime;
  });
  const endTimeIndex = times.findIndex(_ref5 => {
    let {
      time
    } = _ref5;
    return time === endTime;
  });
  return times.map((_ref6, timeIndex) => {
    let {
      time,
      available
    } = _ref6;
    return {
      time,
      selected: time === value,
      selectable: pickingStartTime ? available : endTimeIsSelectable(timeIndex, startTimeIndex, times),
      highlighted: pickingStartTime ? false : timeIsHighlighted(timeIndex, startTimeIndex, endTimeIndex, endTime)
    };
  });
};
const getTimesFromSlots = slots => {
  const times = slots.length > 0 ? [...slots, {
    startTime: slots[slots.length - 1].endTime,
    available: false
  }] : [];
  return times.map(_ref7 => {
    let {
      startTime,
      available
    } = _ref7;
    return {
      time: startTime,
      available
    };
  });
};

/** @jsx jsx */
const css$a = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  row: () => ({
    display: 'flex',
    justifyContent: 'space-between'
  }),
  field: theme => ({
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  }),
  timePicker: theme => ({
    ...theme.styles.flexColumnGrow
  })
};
const StartEndTimesPicker = _ref => {
  let {
    getSlots,
    space: {
      bookingStartIncrement
    },
    times: {
      startTime,
      endTime
    },
    setTimes,
    spaceUnavailable,
    setSpaceUnavailable,
    canSwitchToCustomTimes,
    switchToCustomTimes
  } = _ref;
  const [fetching, setFetching] = useState(false);
  const [timesOptions, setTimesOptions] = useState([]);
  const [picker, setPicker] = useState(pickers.startTime);
  const pickingStartTime = picker === pickers.startTime;
  const timesOptionsWithStates = useMemo(() => addStatesToTimes(timesOptions, pickingStartTime, startTime, endTime), [timesOptions, pickingStartTime, startTime, endTime]);
  useEffect(() => {
    setFetching(true);
    getSlots().then(slots => {
      setSpaceUnavailable(slots.length === 0);
      setTimesOptions(getTimesFromSlots(slots));
    }).catch(error => console.log(error)).finally(() => setFetching(false));
  }, [setFetching, setSpaceUnavailable, getSlots]);
  useEffect(() => {
    if (timesOptions.length === 0) {
      return;
    }
    const resetStartTime = startTime && !startTimeIsValid(timesOptions, startTime);
    const resetEndTime = endTime && !endTimeIsValid(timesOptions, startTime, endTime);
    if (resetStartTime || resetEndTime) {
      if (canSwitchToCustomTimes) {
        switchToCustomTimes();
      } else {
        setTimes({
          startTime: resetStartTime ? null : startTime,
          endTime: resetEndTime ? null : endTime
        });
      }
    }
    if (resetStartTime) {
      setPicker(pickers.startTime);
    }
  }, [setTimes, startTime, endTime, timesOptions, switchToCustomTimes, canSwitchToCustomTimes]);
  const pickStartTime = newStartTime => {
    setTimes({
      startTime: newStartTime,
      endTime: endTimeIsValid(timesOptions, newStartTime, endTime) ? endTime : null
    });
    setPicker(pickers.endTime);
  };
  const pickEndtime = time => setTimes({
    startTime,
    endTime: time
  });
  return jsx("div", {
    css: css$a.container
  }, jsx("div", {
    css: css$a.row
  }, jsx("div", {
    css: css$a.field
  }, jsx(PickerField, {
    id: pickers.startTime,
    label: "Start time",
    placeholder: "Select time below",
    value: startTime,
    active: pickingStartTime,
    showPlaceholder: !startTime,
    onClick: () => setPicker(pickers.startTime),
    disabled: false
  })), jsx("div", {
    css: css$a.field
  }, jsx(PickerField, {
    id: pickers.endTime,
    label: "End time",
    placeholder: "Select time below",
    value: endTime,
    active: !pickingStartTime,
    showPlaceholder: !endTime,
    onClick: () => setPicker(pickers.endTime),
    disabled: !startTime
  }))), jsx("div", {
    css: css$a.timePicker
  }, spaceUnavailable ? jsx("p", null, "This space is not available to be booked on this day, please try another space.") : jsx(TimePicker, {
    name: pickingStartTime ? 'start time' : 'end time',
    labelId: picker,
    time: pickingStartTime ? startTime : endTime,
    timesPerHour: 60 / bookingStartIncrement,
    times: timesOptionsWithStates,
    setTime: pickingStartTime ? pickStartTime : pickEndtime,
    loading: fetching
  })));
};
StartEndTimesPicker.propTypes = {
  getSlots: PropTypes.func.isRequired,
  space: PropTypes.objectOf(PropTypes.any).isRequired,
  times: PropTypes.objectOf(PropTypes.string).isRequired,
  setTimes: PropTypes.func.isRequired,
  spaceUnavailable: PropTypes.bool.isRequired,
  setSpaceUnavailable: PropTypes.func.isRequired,
  canSwitchToCustomTimes: PropTypes.bool.isRequired,
  switchToCustomTimes: PropTypes.func.isRequired
};

/** @jsx jsx */
const TimeField = _ref => {
  let {
    name,
    value,
    onChange
  } = _ref;
  return jsx(InputField, {
    type: "time",
    name: name,
    value: value,
    onChange: onChange
  });
};
TimeField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

/** @jsx jsx */
const css$b = {
  container: () => ({}),
  row: () => ({
    display: 'flex',
    justifyContent: 'space-between'
  }),
  field: theme => ({
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const CustomStartEndTimesPicker = _ref => {
  let {
    times: {
      startTime,
      endTime
    },
    setTimes
  } = _ref;
  const pickTimes = (newStartTime, newEndTime) => setTimes({
    startTime: newStartTime,
    endTime: newEndTime
  });
  return jsx("div", {
    css: css$b.container
  }, jsx("div", {
    css: css$b.row
  }, jsx("div", {
    css: css$b.field
  }, jsx(Label, {
    htmlFor: "startTime",
    text: "Start time"
  }, jsx(TimeField, {
    name: "startTime",
    value: startTime,
    onChange: newStartTime => pickTimes(newStartTime, endTime)
  }))), jsx("div", {
    css: css$b.field
  }, jsx(Label, {
    htmlFor: "endTime",
    text: "End time"
  }, jsx(TimeField, {
    name: "endTime",
    value: endTime,
    onChange: newEndTime => pickTimes(startTime, newEndTime)
  })))));
};
CustomStartEndTimesPicker.propTypes = {
  times: PropTypes.objectOf(PropTypes.string).isRequired,
  setTimes: PropTypes.func.isRequired
};

/* eslint-disable react/button-has-type */
const getStateCss$1 = (state, theme) => {
  switch (state) {
    case 'secondary':
      return {
        color: theme.colors.secondaryDark,
        backgroundColor: theme.colors.white,
        boxShadow: theme.shadows.short,
        '&:hover': {
          color: theme.colors.secondary
        }
      };
    case 'ghost':
      return {
        color: theme.colors.secondaryDark,
        backgroundColor: 'transparent',
        border: `1px solid ${theme.colors.secondaryDark}`,
        '&:hover': {
          color: theme.colors.secondary,
          borderColor: theme.colors.secondary
        }
      };
    case 'ghost-warning':
      return {
        color: theme.colors.errorLight,
        backgroundColor: 'transparent',
        border: `1px solid ${theme.colors.errorLight}`,
        '&:hover': {
          color: theme.colors.error,
          borderColor: theme.colors.error
        }
      };
    case 'warning':
      return {
        color: theme.colors.white,
        backgroundColor: theme.colors.errorLight,
        border: `1px solid ${theme.colors.errorLight}`,
        '&:hover': {
          backgroundColor: theme.colors.error,
          borderColor: theme.colors.error
        }
      };
    case 'text':
      return {
        color: theme.colors.secondary,
        backgroundColor: 'transparent',
        lineHeight: 'initial',
        minHeight: 'initial',
        padding: theme.layout.baseline / 4,
        '&:hover': {
          color: theme.colors.secondaryDark
        }
      };
    default:
      return {
        color: theme.colors.white,
        backgroundColor: theme.colors.primaryLight,
        border: `1px solid ${theme.colors.primaryLight}`,
        '&:hover': {
          backgroundColor: theme.colors.primary,
          borderColor: theme.colors.primary
        }
      };
  }
};
const getSizeCss$2 = (size, theme) => {
  switch (size) {
    case 'large':
      return {
        paddingTop: theme.layout.baseline * 1.5,
        paddingBottom: theme.layout.baseline * 1.5,
        fontSize: theme.font.scale.medium
      };
    case 'small':
      return {
        width: 'auto',
        minHeight: theme.layout.lineHeight + 2,
        padding: `${theme.layout.baseline / 2}px ${theme.layout.baseline * 0.75}px`
      };
    default:
      return {
        paddingTop: theme.layout.baseline / 2,
        paddingBottom: theme.layout.baseline / 2,
        fontSize: 'inherit',
        [theme.helpers.mq('s')]: {
          paddingTop: theme.layout.baseline * 0.75,
          paddingBottom: theme.layout.baseline * 0.75
        },
        [theme.helpers.mq('m')]: {
          paddingTop: theme.layout.baseline,
          paddingBottom: theme.layout.baseline
        }
      };
  }
};
const css$c = (state, size, disabled) => theme => ({
  width: '100%',
  maxWidth: theme.layout.baseline * 12,
  border: 'none',
  borderRadius: theme.borders.radius.low,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  ...getSizeCss$2(size, theme),
  ...(disabled ? {
    backgroundColor: theme.colors.greyLight,
    border: `1px solid ${theme.colors.greyLight}`
  } : getStateCss$1(state, theme)),
  '&:focus': {
    ...theme.styles.focused
  },
  '&:hover': {
    cursor: 'pointer'
  }
});
const Button = _ref => {
  let {
    children,
    state,
    size,
    type,
    onClick,
    disabled,
    focusable,
    actionWillUnmountComponent,
    styles
  } = _ref;
  const [loading, setLoading] = useState(false);
  const clickAction = async () => {
    if (!loading) {
      setLoading(true);
      await onClick();
      return !actionWillUnmountComponent && setLoading(false);
    }
    return null;
  };
  return jsx(React.Fragment, null, jsx("button", {
    css: withTheme([css$c(state, size, disabled), styles]),
    disabled: disabled,
    tabIndex: focusable ? undefined : -1,
    onClick: clickAction,
    type: type
  }, loading ? 'Loading...' : children));
};
Button.propTypes = {
  children: PropTypes.node.isRequired,
  state: PropTypes.oneOf(['primary', 'secondary', 'ghost', 'warning', 'ghost-warning', 'text']),
  size: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  focusable: PropTypes.bool,
  actionWillUnmountComponent: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit']),
  styles: PropTypes.oneOfType([PropTypes.func, PropTypes.objectOf(PropTypes.any)])
};
Button.defaultProps = {
  state: 'primary',
  size: null,
  disabled: false,
  focusable: true,
  actionWillUnmountComponent: false,
  type: 'button',
  styles: null
};
const DeviceContext = /*#__PURE__*/createContext({
  isMobile: null,
  supportsDatePicker: null
});

/** @jsx jsx */
const DatePicker = _ref => {
  let {
    name,
    label,
    labelInline,
    value,
    min,
    max,
    placeholder,
    onChange,
    required,
    disabled,
    state
  } = _ref;
  const {
    supportsDatePicker
  } = useContext(DeviceContext);
  const DateInput = () => jsx(InputField, {
    type: "date",
    size: "medium",
    state: state,
    name: name,
    value: value && dateFromDatetime(value),
    placeholder: placeholder,
    onChange: onChange,
    disabled: disabled,
    required: required,
    inputAttributes: {
      ...(min && {
        min: dateFromDatetime(min)
      }),
      ...(max && {
        max: dateFromDatetime(max)
      })
    }
  });
  const TextInput = () => jsx(MaskedInput, {
    id: name,
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    key: name,
    css: css$5({
      size: 'medium',
      state
    }),
    placeholder: "dd/mm/yyyy",
    placeholderChar: "-",
    keepCharPositions: true,
    defaultValue: value && ukDateFromDatetime(value),
    onChange: _ref2 => {
      let {
        target: {
          value: date
        }
      } = _ref2;
      if (date.length === 0) {
        return onChange(null);
      }
      if (date.length === 10 && ukDateStringIsValid(date)) {
        return onChange(dateFromUkDateString(date));
      }
      return null;
    },
    disabled: disabled
  });
  const Input = supportsDatePicker ? jsx(DateInput, null) : jsx(TextInput, null);
  return label ? jsx(Label, {
    htmlFor: name,
    text: label,
    inline: labelInline
  }, Input) : Input;
};
DatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  labelInline: PropTypes.bool,
  value: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  state: PropTypes.string
};
DatePicker.defaultProps = {
  value: null,
  min: null,
  max: null,
  placeholder: null,
  required: false,
  disabled: false,
  state: null,
  labelInline: false
};

/** @jsx jsx */
const css$d = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  row: () => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between'
  }),
  customTimesToggle: theme => ({
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.layout.baseline / 2
  }),
  timesPicker: theme => ({
    ...theme.styles.flexColumnGrow
  })
};
const SpaceBooker = _ref => {
  let {
    getSlots,
    schoolId,
    siteId,
    space,
    setSpace,
    times,
    setTimes,
    date,
    setDate,
    spaceUnavailable,
    setSpaceUnavailable,
    isAdmin,
    isRepeatBooking
  } = _ref;
  const [useCustomTimes, setUseCustomTimes] = useState(false);
  const [hasChosenSlots, setHasChosenSlots] = useState(false);
  return jsx("div", {
    css: css$d.container
  }, jsx("div", {
    css: css$d.row
  }, jsx(SpacePicker, {
    schoolId: schoolId,
    siteId: siteId,
    setSpace: setSpace,
    space: space,
    isSearchable: isAdmin,
    labelInline: !setDate
  }), setDate && jsx(DatePicker, {
    name: "date",
    label: "Date",
    value: date,
    min: "2019-09-01",
    onChange: setDate
  })), space.id && date && jsx("div", {
    css: css$d.timesPicker
  }, isAdmin && jsx("div", {
    css: css$d.customTimesToggle
  }, jsx(Button, {
    styles: css$d,
    state: "text",
    size: "small",
    onClick: () => {
      setHasChosenSlots(true);
      setUseCustomTimes(!useCustomTimes);
    }
  }, useCustomTimes ? 'Use slots' : 'Use custom times')), useCustomTimes ? jsx(CustomStartEndTimesPicker, {
    setTimes: setTimes,
    times: times
  }) : jsx(StartEndTimesPicker, {
    getSlots: getSlots,
    space: space,
    setTimes: setTimes,
    times: times,
    spaceUnavailable: spaceUnavailable,
    setSpaceUnavailable: setSpaceUnavailable,
    canSwitchToCustomTimes: isAdmin && !hasChosenSlots,
    switchToCustomTimes: () => setUseCustomTimes(true)
  })), space.id && isRepeatBooking && jsx("div", {
    css: css$d.timesPicker
  }, isAdmin && jsx("div", {
    css: css$d.customTimesToggle
  }, jsx(Button, {
    styles: css$d,
    state: "text",
    size: "small",
    onClick: () => {
      setHasChosenSlots(true);
      setUseCustomTimes(!useCustomTimes);
    }
  }, useCustomTimes ? 'Use slots' : 'Use custom times')), useCustomTimes ? jsx(CustomStartEndTimesPicker, {
    setTimes: setTimes,
    times: times
  }) : jsx(StartEndTimesPicker, {
    getSlots: getSlots,
    space: space,
    setTimes: setTimes,
    times: times,
    spaceUnavailable: spaceUnavailable,
    setSpaceUnavailable: setSpaceUnavailable,
    canSwitchToCustomTimes: isAdmin && !hasChosenSlots,
    switchToCustomTimes: () => setUseCustomTimes(true)
  })));
};
SpaceBooker.propTypes = {
  date: PropTypes.string,
  schoolId: PropTypes.string.isRequired,
  siteId: PropTypes.string,
  space: PropTypes.objectOf(PropTypes.any),
  setSpace: PropTypes.func.isRequired,
  getSlots: PropTypes.func.isRequired,
  times: PropTypes.objectOf(PropTypes.string).isRequired,
  setTimes: PropTypes.func.isRequired,
  setDate: PropTypes.func,
  spaceUnavailable: PropTypes.bool.isRequired,
  setSpaceUnavailable: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
  isRepeatBooking: PropTypes.bool
};
SpaceBooker.defaultProps = {
  date: null,
  siteId: null,
  space: {},
  isAdmin: false,
  setDate: null,
  isRepeatBooking: false
};
const css$e = _ref => {
  let {
    size
  } = _ref;
  return theme => ({
    maxWidth: theme.layout.baseline * 8,
    height: theme.layout.baseline * 2,
    padding: `0 ${theme.layout.baseline}px`,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    fontSize: theme.font.scale.small,
    borderRadius: theme.borders.radius.medium,
    ...(size === 'small' && {
      width: theme.layout.baseline * 5.5,
      height: theme.layout.baseline * 1.25,
      marginTop: theme.layout.baseline * 0.125,
      marginBottom: theme.layout.baseline * 0.125,
      padding: 0,
      lineHeight: `${theme.layout.baseline * 1.25}px`,
      borderRadius: theme.borders.radius.low
    })
  });
};
const Status = _ref2 => {
  let {
    label,
    size,
    style,
    onClick
  } = _ref2;
  return jsx("div", _extends({
    css: withTheme([css$e({
      size
    }), style])
  }, onClick && {
    onClick,
    onKeyPress: onClick,
    role: 'button'
  }), jsx("span", null, label));
};
Status.propTypes = {
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'large']),
  style: PropTypes.func,
  onClick: PropTypes.func
};
Status.defaultProps = {
  size: 'large',
  style: null,
  onClick: null
};
const getStateLabel = state => capitalise(state);
const getStateStyle = state => theme => {
  switch (state) {
    case 'prospective':
      return {
        color: theme.colors.secondaryDark,
        border: `1px solid ${theme.colors.greyDark}`
      };
    case 'amending':
      return {
        color: theme.colors.secondaryDark,
        backgroundColor: theme.colors.warning
      };
    case 'pending':
      return {
        color: theme.colors.secondaryDark,
        backgroundColor: theme.colors.primaryLighter
      };
    case 'unreserved':
    case 'unconfirmed':
      return {
        color: theme.colors.error,
        backgroundColor: theme.colors.errorLighter
      };
    case 'unavailable':
    case 'cancelled':
      return {
        color: theme.colors.greyDark,
        backgroundColor: theme.colors.greyLight
      };
    default:
      return {
        color: theme.colors.white,
        backgroundColor: theme.colors.secondaryDark
      };
  }
};
const AdminBookingStatus = _ref => {
  let {
    state,
    size,
    onClick
  } = _ref;
  const label = getStateLabel(state);
  const style = getStateStyle(state);
  return jsx(Status, _extends({
    label: label,
    size: size,
    style: style
  }, onClick && {
    onClick
  }));
};
AdminBookingStatus.propTypes = {
  state: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'large']),
  onClick: PropTypes.func
};
AdminBookingStatus.defaultProps = {
  size: 'large',
  onClick: null
};
const getStateLabel$1 = state => {
  switch (state) {
    case 'prospective':
      return 'Needs review';
    default:
      return capitalise(state);
  }
};
const getStateStyle$1 = state => theme => {
  switch (state) {
    case 'prospective':
      return {
        color: theme.colors.secondaryDark,
        backgroundColor: theme.colors.warningLight
      };
    case 'cancelled':
      return {
        color: theme.colors.greyDark,
        backgroundColor: theme.colors.greyLight
      };
    default:
      return {
        color: theme.colors.white,
        backgroundColor: theme.colors.secondaryDark
      };
  }
};
const BookingStatus = _ref => {
  let {
    state,
    size,
    onClick
  } = _ref;
  const label = getStateLabel$1(state);
  const style = getStateStyle$1(state);
  return jsx(Status, _extends({
    label: label,
    size: size,
    style: style
  }, onClick && {
    onClick
  }));
};
BookingStatus.propTypes = {
  state: PropTypes.oneOf(['prospective', 'cancelled']).isRequired,
  size: PropTypes.oneOf(['small', 'large']),
  onClick: PropTypes.func
};
BookingStatus.defaultProps = {
  size: 'large',
  onClick: null
};

/** @jsx jsx */
const css$f = theme => ({
  width: '100%',
  height: 1,
  backgroundColor: theme.colors.greyLight,
  [theme.helpers.print]: {
    display: 'none'
  }
});
const Divider = () => jsx("div", {
  css: css$f
});

/** @jsx jsx */
const css$g = height => theme => ({
  width: '100%',
  height: height * theme.layout.baseline,
  [theme.helpers.print]: {
    display: 'none'
  }
});
const Spacer = _ref => {
  let {
    height
  } = _ref;
  return jsx("div", {
    css: css$g(height)
  });
};
Spacer.propTypes = {
  height: PropTypes.number
};
Spacer.defaultProps = {
  height: 1
};

/** @jsx jsx */
const css$h = {
  wrapper: theme => ({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    alignItems: 'baseline',
    paddingBottom: theme.layout.baseline,
    [theme.helpers.mq('m')]: {
      flexWrap: 'noWrap',
      paddingBottom: theme.layout.baseline / 2
    }
  }),
  time: theme => ({
    order: '1',
    width: '50%',
    [theme.helpers.mq('m')]: {
      width: theme.layout.baseline * 8
    }
  }),
  site: theme => ({
    order: '2',
    width: '50%',
    [theme.helpers.mq('m')]: {
      width: theme.layout.baseline * 8
    }
  }),
  space: hasSite => theme => ({
    order: hasSite ? '4' : '2',
    width: '50%',
    [theme.helpers.mq('m')]: {
      order: '3',
      width: 'auto',
      flexGrow: '1'
    }
  }),
  type: hasSite => theme => ({
    order: '3',
    width: '50%',
    ...(!hasSite && {
      marginLeft: '50%'
    }),
    marginTop: theme.layout.baseline / 2,
    lineHeight: `${theme.layout.baseline * 1.25}px`,
    color: theme.colors.grey,
    [theme.helpers.mq('m')]: {
      order: '4',
      width: 'auto',
      marginLeft: 0,
      textAlign: 'right'
    }
  }),
  organisation: theme => ({
    display: 'block',
    [theme.helpers.mq('m')]: {
      display: 'initial'
    }
  })
};
const AgendaEvent = _ref => {
  let {
    event
  } = _ref;
  const {
    site,
    space,
    startTime,
    endTime,
    event: type,
    organisation
  } = event;
  return jsx("div", {
    css: css$h.wrapper
  }, jsx("div", {
    css: css$h.time
  }, jsx("b", null, `${startTime} - ${endTime}`)), site && jsx("div", {
    css: css$h.site
  }, jsx("b", null, site)), jsx("div", {
    css: css$h.space(site)
  }, space), jsx("div", {
    css: css$h.type(site)
  }, type, "\xA0", organisation && jsx("span", {
    css: css$h.organisation
  }, "(", organisation, ")")));
};
AgendaEvent.propTypes = {
  event: PropTypes.objectOf(PropTypes.any).isRequired
};

/** @jsx jsx */
const css$i = (level, size) => theme => ({
  color: theme.colors.secondaryDark,
  fontSize: theme.font.scale[size],
  fontWeight: 'normal',
  ...(level === '1' || level === '2' ? {
    fontFamily: theme.font.family.heading
  } : {
    fontWeight: 'bold'
  })
});
const Heading = _ref => {
  let {
    children,
    styles,
    level,
    size
  } = _ref;
  const HeadingTag = `h${level}`;
  return jsx(HeadingTag, {
    css: withTheme([css$i(level, size), styles])
  }, children);
};
Heading.propTypes = {
  children: PropTypes.node.isRequired,
  styles: PropTypes.oneOfType([PropTypes.func, PropTypes.objectOf(PropTypes.any)]),
  level: PropTypes.string,
  size: PropTypes.string
};
Heading.defaultProps = {
  level: '1',
  size: 'default',
  styles: null
};

/** @jsx jsx */
const css$j = {
  date: theme => ({
    marginBottom: theme.layout.baseline / 2
  })
};
const Agenda = _ref => {
  let {
    eventsByDate,
    fallbackMessage
  } = _ref;
  return !isEmpty(eventsByDate) ? Object.entries(eventsByDate).map(_ref2 => {
    let [date, eventsOnDate] = _ref2;
    return jsx("div", {
      key: date
    }, jsx(Heading, {
      styles: css$j.date,
      level: "3"
    }, date), jsx(Divider, null), jsx(Spacer, null), eventsOnDate.map(event => jsx(AgendaEvent, {
      event: event,
      key: `${event.date}-${event.startTime}-${event.space}-${event.event}`
    })), jsx(Spacer, {
      height: 0.5
    }));
  }) : jsx("p", null, fallbackMessage);
};
Agenda.propTypes = {
  eventsByDate: PropTypes.objectOf(PropTypes.any),
  fallbackMessage: PropTypes.string
};
Agenda.defaultProps = {
  eventsByDate: {},
  fallbackMessage: 'No events found'
};
const css$k = {
  container: isClickable => theme => ({
    marginTop: theme.layout.baseline * 0.5,
    padding: `${theme.layout.baseline * 1.5}px ${theme.layout.baseline * 1.5}px`,
    maxWidth: theme.layout.baseline * 45,
    backgroundColor: theme.colors.warningLighter,
    ...(isClickable && {
      cursor: 'pointer'
    })
  }),
  title: theme => ({
    margin: 0,
    paddingBottom: theme.layout.baseline * 0.5
  }),
  description: {
    margin: 0
  }
};
const Banner = _ref => {
  let {
    title,
    message,
    ariaLabel,
    styles,
    onClick
  } = _ref;
  return jsx("div", _extends({
    css: withTheme([css$k.container(!!onClick), styles])
  }, onClick && {
    onClick,
    onKeyPress: onClick,
    role: 'button',
    'aria-label': ariaLabel,
    tabIndex: '0'
  }), title && jsx(Heading, {
    styles: css$k.title,
    level: "3"
  }, title), message && jsx("p", {
    css: css$k.description
  }, message));
};
Banner.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  ariaLabel: PropTypes.string.isRequired,
  styles: PropTypes.oneOfType([PropTypes.func, PropTypes.objectOf(PropTypes.any)]),
  onClick: PropTypes.func
};
Banner.defaultProps = {
  title: null,
  message: null,
  styles: null,
  onClick: null
};

/** @jsx jsx */
const wrapper = theme => ({
  marginBottom: theme.layout.baseline,
  boxShadow: theme.shadows.medium,
  borderRadius: theme.borders.radius.high,
  [theme.helpers.mq('l')]: {
    marginBottom: theme.layout.baseline * 1.5
  }
});
const Card = _ref => {
  let {
    children,
    styles
  } = _ref;
  return jsx("div", {
    css: withTheme([wrapper, styles])
  }, children);
};
Card.propTypes = {
  children: PropTypes.node.isRequired,
  styles: PropTypes.oneOfType([PropTypes.func, PropTypes.objectOf(PropTypes.any)])
};
Card.defaultProps = {
  styles: null
};
const css$l = _ref => {
  let {
    rounded
  } = _ref;
  return () => ({
    ...(rounded && {
      borderRadius: '50%'
    })
  });
};
const Image = _ref2 => {
  let {
    src,
    title,
    onClick,
    styles,
    ...props
  } = _ref2;
  return jsx("img", _extends({
    css: withTheme([css$l(props), styles]),
    src: src,
    alt: title,
    draggable: "false"
  }, onClick && {
    onClick
  }));
};
Image.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  styles: PropTypes.oneOfType([PropTypes.func, PropTypes.objectOf(PropTypes.any)])
};
Image.defaultProps = {
  onClick: null,
  styles: null
};

/** @jsx jsx */
const css$m = {
  wrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: theme => ({
    width: theme.layout.baseline * 2.5,
    marginRight: theme.layout.baseline * 0.5
  }),
  name: theme => ({
    marginTop: 0,
    marginBottom: theme.layout.baseline * 0.25
  }),
  email: theme => ({
    color: theme.colors.greyDark,
    fontSize: theme.font.scale.small,
    minHeight: theme.layout.baseline
  })
};
const Contact = _ref => {
  let {
    name,
    email,
    avatar
  } = _ref;
  return jsx("div", {
    css: css$m.wrapper
  }, avatar && jsx("span", {
    css: css$m.avatar
  }, jsx(Image, {
    rounded: true,
    src: avatar,
    title: `User avatar for ${name}`
  })), jsx("div", null, jsx(Heading, {
    styles: css$m.name,
    level: "3"
  }, name), email && jsx("div", {
    css: css$m.email
  }, email)));
};
Contact.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string,
  avatar: PropTypes.string
};
Contact.defaultProps = {
  avatar: null,
  email: null
};
const css$n = (asButton, highlighted) => theme => ({
  color: highlighted ? theme.colors.secondary : theme.colors.secondaryDark,
  '&:hover': {
    color: theme.colors.secondary
  },
  '&.active': {
    color: theme.colors.secondary
  },
  ...(asButton && {
    display: 'block',
    width: '100%',
    paddingTop: theme.layout.baseline,
    paddingBottom: theme.layout.baseline,
    paddingLeft: theme.layout.baseline * 2.5,
    paddingRight: theme.layout.baseline * 2.5,
    fontSize: 'inherit',
    backgroundColor: 'transparent',
    color: theme.colors.secondaryDark,
    border: `1px solid ${theme.colors.secondaryDark}`,
    borderRadius: theme.borders.radius.low,
    '&:hover': {
      color: theme.colors.secondary,
      borderColor: theme.colors.secondary
    }
  })
});
const Link = _ref => {
  let {
    children,
    url,
    isExternal,
    opensInNewTab,
    asButton,
    highlighted,
    isNavLink,
    ...props
  } = _ref;
  const linkProps = {
    css: css$n(asButton, highlighted),
    ...(isExternal ? {
      href: url
    } : {
      to: url
    }),
    ...(opensInNewTab && {
      target: '_blank',
      rel: 'noopener noreferrer'
    }),
    ...props
  };
  if (isExternal) {
    return jsx("a", linkProps, children);
  }
  if (isNavLink) {
    return jsx(NavLink, _extends({}, linkProps, {
      activeClassName: "active"
    }), children);
  }
  return jsx(Link$1, linkProps, children);
};
Link.propTypes = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string.isRequired,
  isExternal: PropTypes.bool,
  opensInNewTab: PropTypes.bool,
  asButton: PropTypes.bool,
  highlighted: PropTypes.bool,
  isNavLink: PropTypes.bool
};
Link.defaultProps = {
  isExternal: false,
  opensInNewTab: false,
  asButton: false,
  highlighted: true,
  isNavLink: false
};
var _circle, _g;
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends$1({
  viewBox: "0 0 90 90"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  fill: "#549AD4",
  cx: 45,
  cy: 45,
  r: 45
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.998 45.186c-1.2.001-1.391-1.708-.793-2.155.389-.341 1.574-.308 1.908-.353.335-.022 1.228-.33 1.339-.575.468-.958.467-1.831.467-2.879 0-1.404-.725-3.499-2.173-6.286-1.427-2.764-2.14-4.97-2.14-6.62 0-1.359.267-2.575.802-3.645.602-1.226 1.46-2.106 2.575-2.641.557-.245 1.058-.368 1.505-.368.936 0 1.638.257 2.106.769.223.223.334.468.334.736 0 .446-.323.836-.969 1.17a.66.66 0 01-.301.067c-.134 0-.223-.011-.268-.034-.246-.089-.413-.134-.502-.134-.134 0-.268.067-.401.201-1.204 1.204-1.806 2.675-1.806 4.413 0 .647.1 1.249.301 1.806.044.112.278.602.702 1.471.423.869 1.036 2.106 1.839 3.711 1.07 2.14 1.605 3.957 1.605 5.45 0 1.226-.301 2.407-.903 3.544-.201.379-.702.869-1.505 1.471-.645.47-2.889.909-3.722.881zM30.33 45.878c-.936-.201-1.862-.585-2.775-1.154a15.888 15.888 0 01-2.508-1.922 15.123 15.123 0 01-1.939-2.19c-.535-.746-.892-1.399-1.07-1.956a14.2 14.2 0 01-.669-3.227 32.967 32.967 0 01-.134-2.692c0-1.872.284-3.477.852-4.815.568-1.337 1.209-2.396 1.923-3.176 1.092-1.204 2.106-2.084 3.043-2.641.936-.557 1.761-.836 2.474-.836.624 0 1.133-.066 1.646.313.36.39.293.59.293.991 0 .313-.078.597-.234.853-.156.257-.435.429-.836.518-.513.089-1.031.212-1.555.368s-1.142.546-1.856 1.17a8.226 8.226 0 00-1.12 1.237 8.524 8.524 0 00-.986 1.739c-.29.669-.524 1.433-.702 2.29-.179.858-.267 1.811-.267 2.859 0 1.917.624 3.901 1.872 5.952a29.465 29.465 0 001.939 2.173c.245.245.49.485.736.719.245.234.624.485 1.137.752.178.089.412.184.702.284.289.1.523.184.702.251.356.201.535.479.535.836 0 .356-.117.68-.351.97-.234.289-.485.401-.752.334h-.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.011 34.409c-.245.869-.451 1.956-.619 3.26-.167 1.304.075 4.264-.318 4.564-.12.092-.669.167-.869.167-.201 0-.407-.022-.619-.067a1.364 1.364 0 01-.585-.284 1.73 1.73 0 01-.451-.585c-.123-.245-.184-.568-.184-.97 0-.178.017-.406.05-.685.034-.279.05-.473.05-.585 0-.245.033-.674.1-1.287l.234-2.156c.089-.824.195-1.722.318-2.692.122-.97.228-1.934.318-2.892.089-.958.167-1.861.234-2.708.067-.847.1-1.56.1-2.14v-.401c0-.267.122-.423.368-.468.245-.045 1.42.005 2.023.552.153.139.217.368.284.602.067.234.111.485.134.752.022.267.034.524.034.769 0 .179-.023.446-.067.802-.045.357-.089.741-.134 1.154l-.134 1.237c-.045.413-.033 1.304-.033 1.593 0 .198 1.204.363 1.805.363h.401c.289 0 .535-.011.736-.033.201-.022.345-.034.435-.034h.134c.289-1.204.552-2.546.786-4.029.234-1.482.462-3.171.685-5.066.111-.757.345-1.148.702-1.17h.301c.423 0 .774.062 1.053.184.278.123.451.307.518.552a37.173 37.173 0 01-.184 2.223c-.1.948-.217 2.006-.351 3.176a1590.602 1590.602 0 00-.836 7.457 96.28 96.28 0 00-.318 3.394 36.038 36.038 0 00-.117 2.574 27.669 27.669 0 00.067 1.973c0 .156-.05.306-.15.451a.452.452 0 01-.385.217c-.892 0-1.51-.251-1.856-.752-.346-.502-.518-1.232-.518-2.19 0-.134.005-.312.017-.535l.034-.719.033-.719c.011-.223.017-.401.017-.535 0-.178.017-.457.05-.836.033-.379.072-.78.117-1.204l.193-1.891c.028-.262-3.43-.787-3.603-.383zM21.236 74.008c-.669-.29-1.079-.688-1.079-1.133 0-.268-.046-1.189 1.212-1.14a.665.665 0 00.669-.401 6.772 6.772 0 00.702-3.009c0-1.404-.725-3.499-2.173-6.286-1.427-2.764-2.14-4.97-2.14-6.62 0-1.359.267-2.575.802-3.645.602-1.226 1.46-2.106 2.575-2.641.557-.245 1.058-.368 1.505-.368.936 0 1.638.257 2.106.769.223.223.334.468.334.736 0 .446-.323.836-.969 1.17a.66.66 0 01-.301.067c-.134 0-.223-.011-.268-.034-.246-.089-.413-.134-.502-.134-.134 0-.268.067-.401.201-1.204 1.204-1.806 2.675-1.806 4.413 0 .647.1 1.249.301 1.806.044.112.278.602.702 1.471.423.869 1.036 2.106 1.839 3.711 1.07 2.14 1.605 3.957 1.605 5.45 0 1.226-.301 2.407-.903 3.544-.201.379-.619.887-1.421 1.489-.647.468-1.256.684-1.768.684-.223-.001-.466-.033-.621-.1zM29.661 72.604a26.61 26.61 0 01-.251-2.29 37.295 37.295 0 01-.083-2.558c0-1.181.067-2.942.201-5.283s.201-4.113.201-5.316c0-1.717-.076-3.128-.271-4.56a.063.063 0 00-.058-.055c-.145-.008-.556-.043-.741-.184-.215-.163-.145-1.883.122-1.883.223-.044.748-.072.948-.072.178 0 .39.011.635.033.245.022.512.056.802.1 2.897.468 5.082 1.739 6.554 3.812.468.669.702 1.427.702 2.274 0 .802-.179 1.572-.535 2.307-.847 1.828-3.236 5.267-5.651 6.119-.089.379-.134.903-.134 1.572 0 .424.312 5.12-.413 6.774-.14.32-.545.431-.864.289-.446-.199-1.105-.574-1.164-1.079zm6.052-16.517c0-.802-1.256-2.443-3.544-2.809.089 1.538.156 2.892.201 4.062a80.19 80.19 0 01.067 3.026v.836c0 .245-.011.48-.034.702 2.573-1.937 3.087-3.722 3.31-5.55v-.267zM37.819 72.002c0-.869.245-1.906.736-3.109.669-1.627 1.068-3.234 1.087-3.402 0 0-.616.25-.905.026-.312-.245.063-1.584.152-1.674.089-.134.34-.17.702-.301.33-.119.6-.296.6-.296.401-1.092 1.072-3.237 1.941-6.291.379-1.337.73-2.502 1.053-3.494a39.13 39.13 0 01.919-2.558c.134-.312.511-.468.934-.468.312 0 .492.1.738.301.624.535 1.526 4.703 1.571 5.149.557 2.63 1.125 5.021 1.705 7.172a87.29 87.29 0 001.772 5.835c.134.379.201.691.201.936 0 .446-.19.836-.568 1.17-.163.143-.961.691-1.535.374-.682-.376-1.15-1.7-1.307-2.547-.29-1.694-.658-3.109-1.103-4.246l-2.274.201c-.869.112-1.995.412-1.995.412-.112.357-.295 1.226-.462 1.828a48.668 48.668 0 00-.552 2.24c-.379 1.649-.747 2.886-1.103 3.711-.658.869-2.307.129-2.307-.669v-.3zm8.125-9.496c-.045-.446-.1-.897-.167-1.354a18.38 18.38 0 00-.268-1.421 58.832 58.832 0 01-.318-1.337c-.1-.446-.206-.891-.318-1.338a71.675 71.675 0 00-1.739 5.55c.358-.066 1.294-.1 2.81-.1zM61.324 74.978c-.936-.201-1.862-.585-2.775-1.154a15.833 15.833 0 01-2.508-1.923 15.123 15.123 0 01-1.939-2.19c-.535-.746-.892-1.399-1.07-1.956a14.2 14.2 0 01-.669-3.227 32.967 32.967 0 01-.134-2.692c0-1.872.284-3.477.852-4.815.568-1.337 1.209-2.396 1.923-3.176 1.092-1.204 2.106-2.084 3.043-2.641.936-.557 1.764-.764 2.474-.836 1.596-.161 1.939.903 1.939 1.304 0 .313-.078.597-.234.853-.156.257-.435.429-.836.518-.513.089-1.031.212-1.555.368s-1.142.546-1.856 1.17a8.226 8.226 0 00-1.12 1.237 8.524 8.524 0 00-.986 1.739c-.29.669-.524 1.433-.702 2.29-.179.858-.267 1.811-.267 2.859 0 1.917.624 3.901 1.872 5.952a29.465 29.465 0 001.939 2.173c.245.245.49.485.736.719.245.234.624.485 1.137.752.178.089.412.184.702.284.289.1.523.184.702.251.356.201.535.479.535.836 0 .356-.117.68-.351.97-.234.289-.485.401-.752.334h-.1zM62.972 61.024c0-.712 1.304-.365 1.349-.544.022-.089.035-.27.08-.783.045-.512.07-1.696.137-2.699-1.362.61-1.809-.265-1.809-.979.022-.646.412-1.159 1.17-1.538 0 0 9.767-3.257 10.479-2.72.242.129.543.558.633.803.089.245.223.669.223.78 0 .201-.078.346-.234.435-.424.178-.936.362-1.538.552-.602.19-1.304.396-2.106.619-.802.223-1.505.43-2.106.619-.602.19-1.115.374-1.538.552-.089.268-.173.725-.251 1.371a37.981 37.981 0 00-.239 2.74c.356.134 6.229-.6 6.404-.122.169.461.21 2.033-.102 2.033-.468.089-5.624.476-6.248.698-.424 1.561-.546 5.027-.368 5.45.466.866 5.775.972 5.975.805.201-.167.279-.605.681-.63.803-.051.901.231 1.057 1.189 0 .045.077.698.077.742 0 .312-.095.585-.284.819-.19.234-.494.385-1.419.385-.201 0-7.584-.431-8.275-1.407-1.053-1.487-.699-6.907-.654-7.286 0 0-.408.04-.753.019a.472.472 0 01-.438-.506l.097-1.397zM69.48 43.061a.936.936 0 01-.19-.565v-.421c0-.958.028-2.056.083-3.293.056-1.237.151-2.625.284-4.163.335-3.7.502-6.386.502-8.058 0-.579-.011-1.131-.033-1.655a38.282 38.282 0 00-.07-1.188.648.648 0 01.329-.632c.218-.113.466-.17.745-.17.847 0 1.337.312 1.471.936 0 .223.005.457.017.702.011.246.017.513.017.803 0 .869-.022 1.856-.067 2.959a169.412 169.412 0 01-.201 3.762 91.918 91.918 0 00-.217 4.113c-.033 1.204-.05 2.252-.05 3.143v.936c.579-.223 1.393-.691 2.441-1.404.557-.379 1.031-.696 1.421-.953.39-.256 1.279-.692 1.548-.778.895-.285 1.377.271 1.578.627.134.267.201.491.201.669a.84.84 0 01-.201.568l-3.912 2.775a38.45 38.45 0 01-2.123 1.404c-.658.401-1.276.724-1.856.97a.89.89 0 01-.401.1c-.313 0-.602-.201-.869-.602l-.447-.585zM54.736 36.282c-.26.802-.587 1.546-.979 2.234a9.751 9.751 0 01-1.303 1.806 6.123 6.123 0 01-1.573 1.24 4.412 4.412 0 01-1.79.535c-.434.032-.934-.053-1.498-.258a5.099 5.099 0 01-1.623-.986 6.52 6.52 0 01-1.356-1.692c-.387-.675-.61-1.48-.67-2.414-.047-.734-.287-2.487.726-5.448.314-.919.984-2.144 2.362-3.599 3.965-4.188 6.803.189 7.088.737.285.55 1.573 3.27.616 7.845zm-3.644-7.361c-1.353-.442-3.45.512-4.569 4.493-.092.327-.757 5.961 1.856 6.265 2.251.262 3.238-2.409 3.507-2.951 1.401-2.817 1.087-7.192-.794-7.807zM66.568 39.493c-.351.727-.889 1.291-1.4 1.806a6.503 6.503 0 01-1.691 1.24 5.005 5.005 0 01-1.924.535c-.467.032-1.004-.053-1.61-.258a5.564 5.564 0 01-1.744-.986 6.646 6.646 0 01-1.457-1.692c-.415-.675-.655-1.48-.72-2.414-.051-.734.035-1.593.241-2.58.265-1.27 1.073-4.6 2.968-6.406 4.758-4.534 7.421.128 7.727.676.306.549 1.849 5.436-.39 10.079zm-2.925-10.064c-1.451-.451-3.767 1.021-4.968 5.001-.099.327-.714 3.905 1.024 5.754.659.702 1.936.587 2.48.47 3.985-.856 4.798-10.188 1.464-11.225z"
}))));
var _circle$1, _g$1;
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2.apply(null, arguments);
}
const SvgLogoDark = props => /*#__PURE__*/React.createElement("svg", _extends$2({
  viewBox: "0 0 60 60"
}, props), _circle$1 || (_circle$1 = /*#__PURE__*/React.createElement("circle", {
  fill: "#424546",
  cx: 30,
  cy: 30,
  r: 30
})), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.665 30.124c-.8.001-.928-1.139-.529-1.437.259-.227 1.049-.205 1.272-.235.223-.015.818-.22.893-.383.312-.639.311-1.221.311-1.92 0-.936-.483-2.333-1.449-4.191-.951-1.842-1.427-3.314-1.427-4.413 0-.906.178-1.716.535-2.43.401-.817.973-1.404 1.716-1.761.371-.163.706-.245 1.003-.245.624 0 1.092.171 1.404.513a.685.685 0 01.223.49c0 .298-.216.557-.646.78a.44.44 0 01-.201.045.459.459 0 01-.178-.022 1.25 1.25 0 00-.334-.089c-.089 0-.178.045-.267.134-.802.802-1.204 1.783-1.204 2.942 0 .431.067.832.201 1.204.03.075.186.401.468.981.282.58.691 1.404 1.226 2.474.713 1.427 1.07 2.638 1.07 3.633 0 .817-.201 1.605-.602 2.363-.134.253-.468.58-1.003.981-.43.312-1.926.605-2.482.586zM20.22 30.585a5.806 5.806 0 01-1.85-.769 10.575 10.575 0 01-1.672-1.282 10.125 10.125 0 01-1.293-1.46c-.357-.498-.595-.932-.713-1.304a9.446 9.446 0 01-.446-2.151 21.675 21.675 0 01-.089-1.794c0-1.248.189-2.318.568-3.21.379-.892.806-1.597 1.282-2.118.728-.802 1.404-1.389 2.028-1.761.624-.371 1.174-.557 1.65-.557.416 0 .755-.044 1.097.208.24.26.196.393.196.661 0 .208-.052.398-.156.568-.104.171-.29.286-.557.345a9.19 9.19 0 00-1.037.245c-.349.104-.762.364-1.237.78a5.453 5.453 0 00-.747.825 5.703 5.703 0 00-.658 1.159 7.9 7.9 0 00-.468 1.527 9.387 9.387 0 00-.178 1.906c0 1.278.416 2.601 1.248 3.968a18.755 18.755 0 001.783 1.928c.163.156.416.323.758.501.119.059.275.123.468.189.193.067.349.123.468.167.237.134.357.319.357.557 0 .237-.078.453-.234.646-.156.193-.323.267-.502.223h-.066z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.341 22.94c-.164.58-.301 1.304-.412 2.173-.111.869.05 2.842-.212 3.043-.08.061-.446.112-.58.112s-.271-.015-.412-.045a.92.92 0 01-.39-.189 1.173 1.173 0 01-.301-.39c-.082-.163-.123-.379-.123-.646 0-.119.011-.271.033-.457.022-.186.034-.316.034-.39 0-.163.022-.449.067-.858l.156-1.438c.059-.55.13-1.148.212-1.794.081-.646.152-1.289.212-1.928.059-.639.111-1.241.156-1.806s.067-1.04.067-1.427v-.267c0-.178.081-.282.245-.312.163-.03.947.003 1.349.368.102.093.145.245.189.401.045.156.074.323.089.502.015.178.022.349.022.513 0 .119-.015.298-.045.535-.03.238-.06.494-.089.769l-.089.825c-.03.275-.022.869-.022 1.062 0 .132.802.242 1.204.242h.267c.193 0 .357-.007.49-.022.134-.015.23-.022.29-.022h.089a34.64 34.64 0 00.524-2.686 88.04 88.04 0 00.457-3.377c.074-.505.23-.765.468-.78h.201c.282 0 .516.041.702.123.186.082.301.204.345.368-.015.357-.056.851-.123 1.482-.067.632-.145 1.337-.234 2.118l-.279 2.463c-.097.862-.189 1.698-.279 2.508-.089.81-.16 1.564-.212 2.262a24.042 24.042 0 00-.078 1.716 18.444 18.444 0 00.044 1.315.521.521 0 01-.1.301c-.067.096-.153.145-.256.145-.595 0-1.007-.167-1.237-.502-.23-.334-.345-.821-.345-1.46 0-.089.003-.208.011-.357l.022-.479.022-.479c.007-.149.011-.267.011-.357 0-.119.011-.304.034-.557.022-.253.048-.52.078-.802.03-.282.103-1.001.129-1.261.019-.178-2.286-.528-2.401-.258zM14.157 49.339c-.446-.193-.719-.458-.719-.756 0-.178-.03-.793.808-.76a.444.444 0 00.446-.267 4.514 4.514 0 00.468-2.006c0-.936-.483-2.333-1.449-4.191-.951-1.842-1.427-3.314-1.427-4.413 0-.906.178-1.716.535-2.43.401-.817.973-1.404 1.716-1.761.371-.163.706-.245 1.003-.245.624 0 1.092.171 1.404.513a.685.685 0 01.223.49c0 .298-.216.557-.646.78a.44.44 0 01-.201.045.459.459 0 01-.178-.022 1.25 1.25 0 00-.334-.089c-.089 0-.178.045-.267.134-.802.802-1.204 1.783-1.204 2.942 0 .431.067.832.201 1.204.03.075.186.401.468.981.282.58.691 1.404 1.226 2.474.713 1.427 1.07 2.638 1.07 3.633 0 .817-.201 1.605-.602 2.363-.134.253-.413.591-.948.992-.431.312-.837.456-1.179.456a1.19 1.19 0 01-.414-.067zM19.774 48.403c-.074-.476-.13-.985-.167-1.527a25.07 25.07 0 01-.056-1.705c0-.788.044-1.962.134-3.522.089-1.56.134-2.742.134-3.544 0-1.145-.05-2.086-.181-3.04a.044.044 0 00-.039-.037c-.096-.005-.371-.029-.494-.123-.143-.109-.097-1.255.081-1.255.148-.03.499-.048.632-.048.119 0 .26.008.423.022.163.015.342.037.535.067 1.932.312 3.388 1.159 4.369 2.541.312.446.468.951.468 1.516 0 .535-.119 1.048-.357 1.538-.565 1.219-2.157 3.512-3.767 4.079-.06.253-.089.602-.089 1.048 0 .282.208 3.413-.275 4.516-.093.213-.363.287-.576.193-.296-.132-.736-.383-.775-.719zm4.035-11.012c0-.535-.837-1.628-2.363-1.872.059 1.025.104 1.928.134 2.708.03.78.045 1.453.045 2.017v.557c0 .164-.008.32-.022.468 1.715-1.292 2.058-2.482 2.207-3.7v-.178zM25.213 48.001c0-.58.163-1.271.49-2.073.446-1.085.712-2.156.725-2.268 0 0-.411.166-.604.018-.208-.163.042-1.056.101-1.116.059-.089.227-.113.468-.201.22-.08.4-.197.4-.197.267-.728.714-2.158 1.294-4.194.253-.892.487-1.668.702-2.329.215-.661.42-1.229.613-1.705.089-.208.34-.312.623-.312.208 0 .328.067.492.201.416.357 1.018 3.136 1.048 3.433.371 1.754.75 3.347 1.137 4.781a58.34 58.34 0 001.181 3.89c.089.253.134.461.134.624 0 .298-.126.557-.379.78-.109.095-.641.46-1.023.249-.454-.251-.767-1.133-.871-1.698-.193-1.129-.438-2.073-.736-2.831l-1.516.134c-.579.074-1.33.275-1.33.275-.075.238-.197.817-.308 1.219-.112.401-.234.899-.368 1.494-.253 1.099-.498 1.924-.736 2.474-.438.579-1.538.086-1.538-.446v-.202zm5.417-6.33c-.03-.297-.067-.598-.111-.903a12.76 12.76 0 00-.178-.947 39.794 39.794 0 01-.212-.892 42.591 42.591 0 00-.212-.892 47.923 47.923 0 00-1.159 3.7c.237-.044.861-.066 1.872-.066zM40.883 49.985a5.806 5.806 0 01-1.85-.769 10.575 10.575 0 01-1.672-1.282 10.125 10.125 0 01-1.293-1.46c-.357-.498-.595-.932-.713-1.304a9.446 9.446 0 01-.446-2.151 21.675 21.675 0 01-.089-1.794c0-1.248.189-2.318.568-3.21.379-.892.806-1.597 1.282-2.118.728-.802 1.404-1.389 2.028-1.761a3.909 3.909 0 011.65-.557c1.064-.107 1.293.602 1.293.869 0 .208-.052.398-.156.568-.104.171-.29.286-.557.345a9.19 9.19 0 00-1.037.245c-.349.104-.762.364-1.237.78a5.453 5.453 0 00-.747.825 5.703 5.703 0 00-.658 1.159 7.9 7.9 0 00-.468 1.527 9.387 9.387 0 00-.178 1.906c0 1.278.416 2.601 1.248 3.968a18.755 18.755 0 001.783 1.928c.163.156.416.323.758.501.119.059.275.123.468.189.193.067.349.123.468.167.237.134.357.319.357.557 0 .237-.078.453-.234.646-.156.193-.323.267-.502.223h-.066zM41.981 40.683c0-.474.869-.243.899-.363.015-.059.023-.18.053-.522s.047-1.131.091-1.799c-.908.407-1.206-.177-1.206-.653.015-.431.275-.772.78-1.025 0 0 6.512-2.172 6.986-1.813.161.086.362.372.422.535.059.164.149.446.149.52 0 .134-.052.231-.156.29-.282.119-.624.242-1.025.368-.401.126-.869.264-1.404.412-.535.149-1.003.286-1.404.412s-.743.249-1.025.368c-.06.178-.115.483-.167.914a25.358 25.358 0 00-.159 1.827c.238.089 4.152-.4 4.27-.081.113.307.14 1.355-.068 1.355-.312.06-3.75.317-4.165.465-.282 1.04-.364 3.351-.245 3.633.31.577 3.85.648 3.984.537.134-.112.186-.403.454-.42.535-.034.601.154.705.793 0 .03.051.465.051.495 0 .208-.063.39-.189.546-.126.156-.329.256-.946.256-.134 0-5.056-.288-5.517-.938-.702-.991-.466-4.605-.436-4.857 0 0-.272.027-.502.013a.314.314 0 01-.292-.337l.062-.931zM46.32 28.708a.622.622 0 01-.127-.376v-.282c0-.639.018-1.371.056-2.196.037-.825.1-1.75.189-2.775.223-2.467.334-4.257.334-5.372 0-.386-.008-.754-.022-1.103-.011-.266-.027-.53-.047-.792a.433.433 0 01.219-.421c.145-.075.311-.113.496-.113.565 0 .892.208.981.624 0 .149.003.305.011.468.007.164.011.342.011.535 0 .579-.015 1.237-.045 1.973s-.074 1.572-.134 2.508a63.87 63.87 0 00-.178 4.837v.624c.386-.148.929-.46 1.627-.936.371-.253.687-.464.947-.635a6.75 6.75 0 011.032-.518c.596-.19.918.181 1.052.418.089.178.134.327.134.446a.563.563 0 01-.134.379l-2.608 1.85a24.78 24.78 0 01-1.416.936 9.519 9.519 0 01-1.237.646.6.6 0 01-.267.067c-.208 0-.401-.134-.58-.401l-.294-.391zM36.491 24.188a7.988 7.988 0 01-.653 1.49c-.262.459-.551.86-.869 1.204a4.088 4.088 0 01-1.049.827c-.382.207-.78.326-1.193.357-.29.022-.623-.036-.999-.172a3.406 3.406 0 01-1.082-.657c-.345-.302-.646-.678-.904-1.128s-.407-.986-.447-1.609c-.031-.489-.191-1.658.484-3.632.21-.613.656-1.429 1.575-2.4 2.643-2.792 4.536.126 4.725.492.191.365 1.05 2.178.412 5.228zm-2.429-4.907c-.902-.295-2.3.342-3.046 2.995-.061.218-.505 3.974 1.237 4.176 1.501.175 2.159-1.606 2.338-1.967.934-1.878.724-4.794-.529-5.204zM44.378 26.328c-.234.485-.592.86-.933 1.204a4.356 4.356 0 01-1.127.827c-.41.207-.838.326-1.283.357-.311.022-.669-.036-1.073-.172a3.726 3.726 0 01-1.163-.657 4.432 4.432 0 01-.972-1.128c-.277-.45-.437-.986-.48-1.609-.034-.489.023-1.062.161-1.72.177-.847.715-3.066 1.979-4.27 3.172-3.023 4.947.085 5.151.451.204.365 1.233 3.622-.26 6.717zm-1.949-6.708c-.967-.301-2.511.68-3.312 3.334-.066.218-.476 2.603.683 3.836.44.468 1.291.391 1.654.313 2.655-.571 3.197-6.792.975-7.483z"
}))));
var _path;
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3.apply(null, arguments);
}
const SvgArrowFirst = props => /*#__PURE__*/React.createElement("svg", _extends$3({
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.41 10.59L7.82 6l4.59-4.59L11 0 5 6l6 6 1.41-1.41zM0 0h2v12H0V0z",
  fill: "none",
  fillRule: "evenodd"
})));
var _path$1;
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4.apply(null, arguments);
}
const SvgArrowLast = props => /*#__PURE__*/React.createElement("svg", _extends$4({
  viewBox: "0 0 12 12"
}, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
  d: "M.59 1.41L5.18 6 .59 10.59 2 12l6-6-6-6L.59 1.41zM11 0h2v12h-2V0z",
  fill: "#1D1D1D",
  fillRule: "evenodd"
})));
var _path$2;
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$5.apply(null, arguments);
}
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends$5({
  viewBox: "0 0 8 12"
}, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.41 1.41L6 0 0 6l6 6 1.41-1.41L2.83 6z",
  fill: "none",
  fillRule: "evenodd"
})));
var _path$3;
function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$6.apply(null, arguments);
}
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends$6({
  viewBox: "0 0 8 12"
}, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
  d: "M2 0L.59 1.41 5.17 6 .59 10.59 2 12l6-6z",
  fill: "none",
  fillRule: "evenodd"
})));
var _path$4;
function _extends$7() {
  return _extends$7 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$7.apply(null, arguments);
}
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends$7({
  viewBox: "0 0 12 8"
}, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.59.59L6 5.17 1.41.59 0 2l6 6 6-6z",
  fill: "none",
  fillRule: "evenodd"
})));
var _path$5;
function _extends$8() {
  return _extends$8 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$8.apply(null, arguments);
}
const SvgBin = props => /*#__PURE__*/React.createElement("svg", _extends$8({
  viewBox: "0 0 14 18"
}, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
  d: "M11 6v10H3V6h8zM9.5 0h-5l-1 1H0v2h14V1h-3.5l-1-1zM13 4H1v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4z",
  fill: "#2F4857",
  fillRule: "evenodd"
})));
var _path$6;
function _extends$9() {
  return _extends$9 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$9.apply(null, arguments);
}
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends$9({
  viewBox: "0 0 14 14"
}, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
  d: "M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z",
  fill: "#2F4857",
  fillRule: "evenodd"
})));
var _path$7;
function _extends$a() {
  return _extends$a = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$a.apply(null, arguments);
}
const SvgCross = props => /*#__PURE__*/React.createElement("svg", _extends$a({
  viewBox: "0 0 24 24"
}, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
})));
var _path$8;
function _extends$b() {
  return _extends$b = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$b.apply(null, arguments);
}
const SvgDash = props => /*#__PURE__*/React.createElement("svg", _extends$b({
  viewBox: "0 0 24 24"
}, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
  d: "M6 11h12v2H6z"
})));
var _path$9;
function _extends$c() {
  return _extends$c = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$c.apply(null, arguments);
}
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends$c({
  viewBox: "0 0 24 24"
}, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z",
  fill: "none",
  fillRule: "evenodd"
})));
var _path$a;
function _extends$d() {
  return _extends$d = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$d.apply(null, arguments);
}
const SvgHelp = props => /*#__PURE__*/React.createElement("svg", _extends$d({
  viewBox: "0 0 20 20"
}, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
  d: "M9 16h2v-2H9v2zm1-16C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14C7.79 4 6 5.79 6 8h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z",
  fill: "#2F4857",
  fillRule: "evenodd"
})));
var _path$b;
function _extends$e() {
  return _extends$e = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$e.apply(null, arguments);
}
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends$e({
  viewBox: "0 0 18 12"
}, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
  d: "M0 12h18v-2H0v2zm0-5h18V5H0v2zm0-7v2h18V0H0z",
  fill: "#2F4857",
  fillRule: "evenodd"
})));
var _path$c;
function _extends$f() {
  return _extends$f = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$f.apply(null, arguments);
}
const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends$f({
  viewBox: "0 0 17 17"
}, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
  d: "M10 3.25l-10 10V17h3.75l10-10L10 3.25zM2.92 15H2v-.92l8-8 .92.92-8 8zM16.71 4.04a.996.996 0 000-1.41L14.37.29a.996.996 0 00-1.41 0L11 2.25 14.75 6l1.96-1.96z",
  fill: "#1D1D1D",
  fillRule: "evenodd"
})));
var _path$d;
function _extends$g() {
  return _extends$g = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$g.apply(null, arguments);
}
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends$g({
  viewBox: "0 0 24 24"
}, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z",
  fill: "none",
  fillRule: "evenodd"
})));
var _path$e;
function _extends$h() {
  return _extends$h = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$h.apply(null, arguments);
}
const SvgTick = props => /*#__PURE__*/React.createElement("svg", _extends$h({
  viewBox: "0 0 24 24"
}, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
})));
var _path$f;
function _extends$i() {
  return _extends$i = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$i.apply(null, arguments);
}
const SvgRefresh = props => /*#__PURE__*/React.createElement("svg", _extends$i({
  viewBox: "0 0 24 24"
}, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
  d: "M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z",
  fill: "none",
  fillRule: "evenodd"
})));
var _path$g;
function _extends$j() {
  return _extends$j = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$j.apply(null, arguments);
}
const SvgSortDown = props => /*#__PURE__*/React.createElement("svg", _extends$j({
  viewBox: "0 0 24 24"
}, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z",
  fill: "none",
  fillRule: "evenodd"
})));
var _path$h;
function _extends$k() {
  return _extends$k = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$k.apply(null, arguments);
}
const SvgAlertOutlined = props => /*#__PURE__*/React.createElement("svg", _extends$k({
  width: 18,
  height: 18,
  fill: "none"
}, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 .667A8.336 8.336 0 00.667 9c0 4.6 3.733 8.333 8.333 8.333S17.334 13.6 17.334 9 13.6.667 9 .667zm.834 12.5H8.167V11.5h1.667v1.667zm0-3.334H8.167v-5h1.667v5z",
  fill: "#C41D10"
})));
var _path$i, _path2;
function _extends$l() {
  return _extends$l = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$l.apply(null, arguments);
}
const SvgRadioTick = props => /*#__PURE__*/React.createElement("svg", _extends$l({
  width: 20,
  height: 20,
  fill: "none"
}, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.833 10a9.167 9.167 0 1118.333 0A9.167 9.167 0 01.833 10z",
  fill: "#00868B"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.425 6.702a.833.833 0 010 1.179l-5.172 5.416a.833.833 0 01-1.179 0l-2.5-2.5A.833.833 0 116.753 9.62l1.91 1.91 4.584-4.827a.833.833 0 011.178 0z",
  fill: "#fff"
})));

/** @jsx jsx */
const css$o = {
  button: theme => ({
    width: theme.layout.baseline * 2,
    height: theme.layout.baseline * 2,
    padding: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    lineHeight: `${theme.layout.baseline * 2}px`,
    border: 'none',
    borderRadius: '50%',
    background: 'transparent',
    '&:hover': {
      background: theme.colors.greyLight
    }
  }),
  container: _ref => {
    let {
      height,
      width
    } = _ref;
    return {
      height,
      width,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    };
  },
  svg: _ref2 => {
    let {
      color
    } = _ref2;
    return theme => ({
      '& svg': {
        height: '100%',
        width: 'auto',
        '> path': {
          fill: color || theme.colors.greyDark
        }
      }
    });
  }
};
const getIcon = name => {
  switch (name) {
    case 'arrow':
      return SvgArrowDown;
    case 'arrowLeft':
      return SvgArrowLeft;
    case 'arrowRight':
      return SvgArrowRight;
    case 'arrowFirst':
      return SvgArrowFirst;
    case 'arrowLast':
      return SvgArrowLast;
    case 'delete':
      return SvgBin;
    case 'close':
      return SvgClose;
    case 'cross':
      return SvgCross;
    case 'filter':
      return SvgFilter;
    case 'help':
      return SvgHelp;
    case 'logo':
      return SvgLogo;
    case 'logoDark':
      return SvgLogoDark;
    case 'menu':
      return SvgMenu;
    case 'plus':
      return SvgPlus;
    case 'edit':
      return SvgPencil;
    case 'refresh':
      return SvgRefresh;
    case 'sortDown':
      return SvgSortDown;
    case 'tick':
      return SvgTick;
    case 'dash':
      return SvgDash;
    case 'alertOutlined':
      return SvgAlertOutlined;
    case 'radioTick':
      return SvgRadioTick;
    default:
      return '';
  }
};
const Icon = _ref3 => {
  let {
    name,
    link,
    onClick,
    ariaLabel,
    ariaExpanded,
    height,
    width,
    color,
    styles
  } = _ref3;
  const IconComponent = getIcon(name);
  const IconContainer = () => jsx("div", {
    css: withTheme([css$o.container({
      height,
      width
    }), css$o.svg({
      color
    })])
  }, jsx(IconComponent, null));
  if (onClick) {
    return jsx("button", {
      css: withTheme([css$o.button, styles]),
      onClick: onClick,
      type: "button",
      "aria-label": ariaLabel,
      "aria-expanded": ariaExpanded
    }, jsx(IconContainer, null));
  }
  if (link) {
    return jsx(Link, {
      url: link
    }, jsx(IconContainer, null));
  }
  return jsx("div", {
    css: styles
  }, jsx(IconContainer, null));
};
Icon.propTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  ariaExpanded: PropTypes.bool,
  styles: PropTypes.oneOfType([PropTypes.func, PropTypes.objectOf(PropTypes.any)]),
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string
};
Icon.defaultProps = {
  link: null,
  onClick: null,
  ariaLabel: undefined,
  ariaExpanded: undefined,
  styles: null,
  height: 15,
  width: 15,
  color: null
};
const css$p = _ref => {
  let {
    vertical,
    withDivider
  } = _ref;
  return theme => ({
    ...(!vertical && {
      display: 'inline-block',
      marginRight: theme.layout.baseline * 2,
      '&:last-child': {
        marginRight: 0
      }
    }),
    ...(vertical && {
      marginBottom: theme.layout.baseline * 1.5,
      ...(withDivider && {
        display: 'flex',
        marginBottom: theme.layout.baseline,
        paddingBottom: theme.layout.baseline,
        borderBottom: `1px solid ${theme.colors.greyLight}`
      }),
      '&:last-of-type': {
        marginBottom: 0
      }
    })
  });
};
const LinkList = _ref2 => {
  let {
    items,
    isNav,
    onClick,
    styles,
    ...props
  } = _ref2;
  return jsx("ul", {
    css: styles
  }, items.map(_ref3 => {
    let {
      title,
      url,
      isExternal,
      showIcon,
      icon
    } = _ref3;
    return jsx("li", {
      css: css$p({
        ...props
      }),
      key: slugify(title)
    }, jsx(Link, _extends({
      url: url,
      isNavLink: isNav,
      isExternal: isExternal,
      highlighted: false
    }, onClick && {
      onClick
    }), title), showIcon && jsx(Icon, {
      name: icon,
      height: 20,
      width: 20,
      color: "#C41D10",
      styles: {
        marginLeft: 10
      }
    }));
  }));
};
LinkList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  isNav: PropTypes.bool,
  onClick: PropTypes.func,
  styles: PropTypes.oneOfType([PropTypes.func, PropTypes.objectOf(PropTypes.any)])
};
LinkList.defaultProps = {
  isNav: false,
  onClick: null,
  styles: null
};

/** @jsx jsx */
const css$q = {
  title: {
    marginTop: 0,
    marginBottom: 0
  },
  value: theme => ({
    display: 'block',
    marginTop: theme.layout.baseline / 2,
    minHeight: theme.layout.baseline
  })
};
const Property = _ref => {
  let {
    children,
    title,
    styles
  } = _ref;
  return jsx("div", {
    css: styles
  }, jsx(Heading, {
    styles: css$q.title,
    level: "3"
  }, title), jsx("span", {
    css: css$q.value
  }, children));
};
Property.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  styles: PropTypes.oneOfType([PropTypes.func, PropTypes.objectOf(PropTypes.any)])
};
Property.defaultProps = {
  styles: null
};
const NotFoundError = _ref => {
  let {
    homeDestination
  } = _ref;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, {
    level: "1",
    size: "x-large"
  }, "Page not found"), /*#__PURE__*/React.createElement("p", null, "We can't find the page you are looking for. It might have been moved or deleted."), /*#__PURE__*/React.createElement(Link, {
    url: homeDestination,
    isExternal: true
  }, "Back to home"));
};
NotFoundError.propTypes = {
  homeDestination: PropTypes.string.isRequired
};
const GenericError = () => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, {
    level: "1",
    size: "x-large"
  }, "Something went wrong"), /*#__PURE__*/React.createElement("p", null, "Please refresh the page and try again. If the problem persists, please", ' ', /*#__PURE__*/React.createElement(Link, {
    url: "https://school-space.org/about-us/contact-us",
    isExternal: true,
    opensInNewTab: true
  }, "contact us"), "."), /*#__PURE__*/React.createElement(Button, {
    onClick: () => window.location.reload(),
    state: "ghost"
  }, "Refresh page"));
};
const ErrorComponent = _ref => {
  let {
    error: {
      name
    }
  } = _ref;
  switch (name) {
    case ApiNotFoundError.name:
      return /*#__PURE__*/React.createElement(NotFoundError, {
        homeDestination: "/"
      });
    default:
      return /*#__PURE__*/React.createElement(GenericError, null);
  }
};
ErrorComponent.propTypes = {
  error: PropTypes.objectOf(PropTypes.any).isRequired
};
const ErrorBoundary = _ref2 => {
  let {
    children
  } = _ref2;
  const BugsnagErrorBoundary = errorHandler.getErrorBoundary();
  return /*#__PURE__*/React.createElement(BugsnagErrorBoundary, {
    FallbackComponent: ErrorComponent
  }, children);
};
ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};

/** @jsx jsx */
const css$r = {
  error: theme => ({
    color: theme.colors.error,
    marginTop: theme.layout.baseline / 2,
    marginBottom: theme.layout.baseline / 2,
    fontSize: theme.font.scale.small,
    minHeight: theme.font.scale.small,
    [theme.helpers.mq('s')]: {
      fontSize: theme.font.scale.default,
      minHeight: theme.font.scale.default
    }
  })
};
const InlineError = _ref => {
  let {
    message
  } = _ref;
  return jsx("p", {
    css: css$r.error
  }, message);
};
InlineError.propTypes = {
  message: PropTypes.string.isRequired
};
const css$s = {
  inlineLabel: _ref => {
    let {
      hasLabel
    } = _ref;
    return theme => ({
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      ...(hasLabel && {
        marginTop: theme.layout.baseline / 2,
        marginBottom: theme.layout.baseline / 2
      })
    });
  },
  blockLabel: theme => ({
    height: theme.layout.lineHeight + 2,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.layout.baseline / 2
  }),
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  input: {
    opacity: 0,
    height: 0,
    width: 0
  },
  box: _ref2 => {
    let {
      disabled
    } = _ref2;
    return theme => ({
      height: theme.layout.baseline,
      width: theme.layout.baseline,
      position: 'relative',
      border: `1px solid ${theme.colors.greyLight}`,
      borderRadius: theme.layout.baseline / 4,
      backgroundColor: theme.colors.white,
      marginRight: theme.layout.baseline / 2,
      'input:focus + & ': {
        ...theme.styles.focused,
        boxShadow: `0 0 1px 1px ${theme.colors.focus}`
      },
      '&:hover': {
        cursor: 'pointer'
      },
      ...(disabled && theme.styles.disabled)
    });
  },
  iconContainer: {
    position: 'absolute',
    top: -1,
    left: -1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  icon: _ref3 => {
    let {
      visible
    } = _ref3;
    return {
      opacity: visible ? 1 : 0,
      transition: 'opacity 0.1s ease-in'
    };
  },
  underLine: {
    textDecoration: 'underline'
  }
};
const Checkbox = _ref4 => {
  let {
    name,
    label,
    link,
    linkLabel,
    inlineLabel,
    checked,
    onChange,
    onChangeEvent,
    required,
    disabled,
    indeterminate,
    labelStyles,
    containerStyles
  } = _ref4;
  const inputRef = useRef({});
  const theme = useTheme();
  useEffect(() => {
    inputRef.current.checked = checked;
    inputRef.current.indeterminate = indeterminate;
  }, [indeterminate, checked]);
  const input = jsx("div", {
    css: withTheme([css$s.container, containerStyles])
  }, jsx("input", _extends({
    css: css$s.input,
    type: "checkbox",
    id: name,
    name: name,
    value: name,
    checked: checked,
    onChange: event => {
      event.persist();
      if (onChangeEvent) {
        onChangeEvent(event);
      } else {
        onChange(event.target.checked);
      }
    },
    "aria-label": label,
    disabled: disabled
  }, required && {
    required: true,
    'aria-required': true
  })), jsx("div", {
    css: css$s.box({
      disabled
    }),
    "aria-hidden": true
  }, jsx("div", {
    css: css$s.iconContainer
  }, jsx(Icon, {
    styles: css$s.icon({
      visible: checked
    }),
    name: "tick",
    height: theme.layout.baseline,
    width: theme.layout.baseline,
    color: theme.colors.secondary
  })), jsx("div", {
    css: css$s.iconContainer
  }, jsx(Icon, {
    styles: css$s.icon({
      visible: indeterminate
    }),
    name: "dash",
    height: theme.layout.baseline,
    width: theme.layout.baseline,
    color: theme.colors.secondary
  }))));
  return inlineLabel ? jsx("label", {
    htmlFor: name,
    css: css$s.inlineLabel({
      hasLabel: !!label
    })
  }, input, label && jsx("span", {
    css: labelStyles
  }, label), link && jsx("a", {
    href: link,
    target: "_blank",
    rel: "noopener noreferrer",
    style: css$s.underLine
  }, linkLabel)) : jsx(Label, {
    htmlFor: name,
    text: label
  }, jsx("div", {
    css: css$s.blockLabel
  }, input));
};
Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  link: PropTypes.string,
  linkLabel: PropTypes.string,
  inlineLabel: PropTypes.bool,
  checked: PropTypes.bool.isRequired,
  indeterminate: PropTypes.bool,
  onChange: PropTypes.func,
  onChangeEvent: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  labelStyles: PropTypes.oneOfType([PropTypes.func, PropTypes.objectOf(PropTypes.any)]),
  containerStyles: PropTypes.oneOfType([PropTypes.func, PropTypes.objectOf(PropTypes.any)])
};
Checkbox.defaultProps = {
  label: null,
  link: null,
  linkLabel: null,
  required: false,
  disabled: false,
  inlineLabel: true,
  labelStyles: {},
  containerStyles: {},
  indeterminate: false,
  onChange: null,
  onChangeEvent: null
};

/** @jsx jsx */
const styles = {
  button: theme => `
        height: ${theme.layout.baseline * 2}px;
        width: ${theme.layout.baseline * 2}px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid ${theme.colors.greyDark};
        border-radius: ${theme.borders.radius.low};
        background-color: ${theme.colors.white};
        svg path {
            fill: ${theme.colors.greyDark};
        }
        &:hover {
            border-color: ${theme.colors.secondary};
            cursor: pointer;
            svg path {
                fill: ${theme.colors.secondary};
            },
        }
        &:focus {
            border-color: transparent;
        }
        &:disabled {
            border-color: ${theme.colors.greyLight};
            cursor: default;
            pointer-events: none;
            svg path {
                fill: ${theme.colors.grey}
            }
        }
    `
};
const IconButton = _ref => {
  let {
    iconName,
    focusable,
    disabled,
    onClick,
    ariaLabel
  } = _ref;
  const theme = useTheme();
  return jsx(ClassNames, null, _ref2 => {
    let {
      css
    } = _ref2;
    return jsx("button", {
      type: "button",
      onClick: onClick,
      tabIndex: focusable ? undefined : -1,
      "aria-label": ariaLabel,
      disabled: disabled,
      className: css`
                        ${styles.button(theme)}
                    `
    }, jsx(Icon, {
      name: iconName,
      styles: styles.icon
    }));
  });
};
IconButton.propTypes = {
  iconName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  focusable: PropTypes.bool,
  disabled: PropTypes.bool
};
IconButton.defaultProps = {
  focusable: true,
  disabled: false
};

/** @jsx jsx */
const css$t = {
  content: theme => ({
    lineHeight: `${theme.layout.baseline * 2.5}px`
  })
};
const Placeholder = _ref => {
  let {
    title,
    children
  } = _ref;
  return jsx(Label, {
    text: title,
    htmlFor: slugify(title)
  }, jsx("div", {
    css: css$t.content
  }, children));
};
Placeholder.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired
};

/* eslint-disable react-hooks/exhaustive-deps */
const SearchFilters = _ref => {
  let {
    getData,
    setData,
    filters,
    params,
    location: {
      pathname
    },
    history,
    children
  } = _ref;
  const filterValues = filters.map(_ref2 => {
    let {
      value
    } = _ref2;
    return value;
  });
  const selectedFilters = filters.filter(_ref3 => {
    let {
      value
    } = _ref3;
    return !!value;
  });
  const updateQueryParameters = () => {
    filters.map(_ref4 => {
      let {
        key
      } = _ref4;
      return params.delete(key);
    });
    selectedFilters.map(_ref5 => {
      let {
        key,
        value
      } = _ref5;
      return params.set(key, value);
    });
    history.push({
      pathname,
      search: params.toString()
    });
  };
  const search = async () => {
    if (selectedFilters.length) {
      const query = {};
      selectedFilters.forEach(_ref6 => {
        let {
          key,
          value
        } = _ref6;
        query[key] = value;
      });
      getData(query).then(data => {
        setData(data);
        updateQueryParameters();
      }).catch(err => {
        console.error(err);
      });
    } else {
      updateQueryParameters();
    }
  };
  useEffect(() => {
    search();
  }, filterValues);
  return children;
};
SearchFilters.propTypes = {
  getData: PropTypes.func.isRequired,
  setData: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(PropTypes.object).isRequired,
  params: PropTypes.instanceOf(URLSearchParams).isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  location: ReactRouterPropTypes.location.isRequired
};
var SearchFilters$1 = withRouter(SearchFilters);

/** @jsx jsx */
const NumberField = _ref => {
  let {
    name,
    min,
    max,
    step,
    value,
    onChange,
    disabled
  } = _ref;
  return jsx(InputField, {
    type: "number",
    name: name,
    size: "small",
    value: value,
    onChange: onChange,
    inputAttributes: {
      ...(min && {
        min
      }),
      ...(max && {
        max
      }),
      ...(step && {
        step
      })
    },
    disabled: disabled
  });
};
NumberField.propTypes = {
  name: PropTypes.string.isRequired,
  min: PropTypes.string,
  max: PropTypes.string,
  step: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
NumberField.defaultProps = {
  min: '',
  max: '',
  step: '',
  disabled: false
};
const css$u = theme => ({
  height: 'auto',
  lineHeight: '22px',
  paddingTop: theme.layout.baseline * 3 / 4,
  paddingBottom: theme.layout.baseline * 3 / 4
});
const TextArea = _ref => {
  let {
    label,
    name,
    value,
    onChange,
    state,
    rows,
    cols,
    placeholder,
    ...props
  } = _ref;
  return jsx(Label, {
    htmlFor: name,
    text: label
  }, jsx("textarea", _extends({
    css: withTheme([css$5({
      size: 'large',
      state
    }), css$u]),
    type: "textarea",
    id: name,
    name: name,
    onChange: event => onChange(event.target.value),
    rows: rows,
    cols: cols,
    "aria-label": label,
    value: value,
    placeholder: placeholder
  }, props)));
};
TextArea.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  state: PropTypes.string,
  rows: PropTypes.string,
  cols: PropTypes.string,
  placeholder: PropTypes.string
};
TextArea.defaultProps = {
  state: null,
  rows: '5',
  cols: '',
  placeholder: ''
};

/** @jsx jsx */
const DiscountField = _ref => {
  let {
    value,
    onChange
  } = _ref;
  return jsx(Label, {
    htmlFor: "discount",
    text: "Discount %"
  }, jsx(NumberField, {
    type: "number",
    name: "discount",
    size: "small",
    value: decodeDiscount(value),
    min: "0",
    max: "100",
    step: "1",
    onChange: newValue => onChange(encodeDiscount(newValue))
  }));
};
DiscountField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};
DiscountField.defaultProps = {
  value: '0'
};

/** @jsx jsx */
const activities = [{
  id: 'activity-camp',
  name: 'Activity Camp',
  isSport: true
}, {
  id: 'badminton',
  name: 'Badminton',
  isSport: true
}, {
  id: 'basketball',
  name: 'Basketball',
  isSport: true
}, {
  id: 'cricket',
  name: 'Cricket',
  isSport: true
}, {
  id: 'carbootsale',
  name: 'Car Boot Sale',
  isSport: false
}, {
  id: 'carparking',
  name: 'Car Parking',
  isSport: false
}, {
  id: 'dance',
  name: 'Dance',
  isSport: true
}, {
  id: 'drama',
  name: 'Drama',
  isSport: false
}, {
  id: 'education',
  name: 'Education Class',
  isSport: false
}, {
  id: 'fitness',
  name: 'Fitness Class',
  isSport: true
}, {
  id: 'football',
  name: 'Football',
  isSport: true
}, {
  id: 'gymnastics',
  name: 'Gymnastics',
  isSport: true
}, {
  id: 'hockey',
  name: 'Hockey',
  isSport: true
}, {
  id: 'korfball',
  name: 'Korfball',
  isSport: true
}, {
  id: 'language',
  name: 'Language School',
  isSport: false
}, {
  id: 'martial-arts',
  name: 'Martial Arts',
  isSport: true
}, {
  id: 'music',
  name: 'Music',
  isSport: false
}, {
  id: 'netball',
  name: 'Netball',
  isSport: true
}, {
  id: 'other',
  name: 'Other',
  isSport: false
}, {
  id: 'other-sport',
  name: 'Other Sport',
  isSport: true
}, {
  id: 'outdoormarket',
  name: 'Outdoor Market',
  isSport: false
}, {
  id: 'pilates',
  name: 'Pilates',
  isSport: true
}, {
  id: 'private-party',
  name: 'Private Party',
  isSport: false
}, {
  id: 'religious',
  name: 'Religious Gathering',
  isSport: false
}, {
  id: 'rugby',
  name: 'Rugby',
  isSport: true
}, {
  id: 'volleyball',
  name: 'Volleyball',
  isSport: true
}, {
  id: 'yoga',
  name: 'Yoga',
  isSport: true
}, {
  id: 'zumba',
  name: 'Zumba',
  isSport: true
}];
const ActivityPicker = _ref => {
  let {
    value,
    onChange,
    isClearable,
    isDisabled
  } = _ref;
  return jsx(Select, {
    name: "booking-activity",
    label: "Activity",
    placeholder: "Select activity",
    value: activities.find(activity => activity.id === value),
    onChange: activity => onChange(activity ? activity.id : null),
    options: activities,
    isDisabled: isDisabled,
    isClearable: isClearable
  });
};
ActivityPicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isClearable: PropTypes.bool,
  isDisabled: PropTypes.bool
};
ActivityPicker.defaultProps = {
  value: null,
  isClearable: true,
  isDisabled: false
};
const AgeGroupsPicker = _ref => {
  let {
    ageGroups,
    setAgeGroups,
    ...selectProps
  } = _ref;
  const [options, setOptions] = useState([]);
  useEffect(() => {
    getAgeGroups().then(setOptions).catch(err => console.log(err));
  }, []);
  return /*#__PURE__*/React.createElement(Select, _extends({
    value: ageGroups && ageGroups.length ? ageGroups : null,
    onChange: setAgeGroups,
    options: options,
    isMulti: true,
    size: "large",
    isDisabled: options.length === 0
  }, selectProps));
};
AgeGroupsPicker.propTypes = {
  ageGroups: PropTypes.arrayOf(PropTypes.object),
  setAgeGroups: PropTypes.func.isRequired
};
AgeGroupsPicker.defaultProps = {
  ageGroups: []
};
const bookingTypes = [{
  name: 'Customer Booking',
  id: 'SpaceBooking'
}, {
  name: 'School Booking',
  id: 'SchoolBooking'
}, {
  id: 'Viewing',
  name: 'Viewing'
}, {
  id: 'Cleaning',
  name: 'Cleaning'
}];
const BookingTypePicker = _ref => {
  let {
    value,
    onChange,
    isClearable,
    isDisabled
  } = _ref;
  return /*#__PURE__*/React.createElement(Select, {
    name: "booking-type",
    label: "Booking type",
    placeholder: "All types",
    value: bookingTypes.find(type => type.id === value),
    onChange: type => onChange(type ? type.id : null),
    options: bookingTypes,
    isDisabled: isDisabled,
    isClearable: isClearable
  });
};
BookingTypePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isClearable: PropTypes.bool,
  isDisabled: PropTypes.bool
};
BookingTypePicker.defaultProps = {
  value: null,
  isClearable: true,
  isDisabled: false
};
const InvoiceContactPicker = _ref => {
  let {
    invoiceContact,
    setInvoiceContact,
    ...selectProps
  } = _ref;
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState([]);
  useEffect(() => {
    getInvoiceContacts().then(setOptions).then(() => setLoading(false)).catch(err => console.log(err));
  }, []);
  return /*#__PURE__*/React.createElement(Select, _extends({
    placeholder: "Search for an existing Xero contact",
    name: "invoice-contact",
    value: invoiceContact,
    onChange: setInvoiceContact,
    options: options,
    size: "large",
    isClearable: true,
    isSearchable: true,
    isLoading: loading
  }, selectProps));
};
InvoiceContactPicker.propTypes = {
  invoiceContact: PropTypes.objectOf(PropTypes.any),
  setInvoiceContact: PropTypes.func.isRequired
};
InvoiceContactPicker.defaultProps = {
  invoiceContact: null
};
const parseCombinedId = schoolSiteId => {
  const [schoolId, siteId] = schoolSiteId.split(':');
  return {
    schoolId,
    siteId: siteId || ''
  };
};
const generateCombinedId = (schoolId, siteId) => schoolId + (siteId && `:${siteId}`);
const SchoolSitePicker = _ref => {
  let {
    schoolId,
    siteId,
    setSchoolSite,
    fullWidth
  } = _ref;
  const schools = useSchools();
  const [combinedSchoolsAndSites, setCombinedSchoolsAndSites] = useState([]);
  const [visibleSchoolsAndSites, setVisibleSchoolsAndSites] = useState([]);
  const [page, setPage] = useState(1);
  const pageSize = 50;
  useEffect(() => {
    const data = schools.reduce((acc, school) => {
      const {
        id,
        name,
        sites
      } = school;
      if (sites) {
        sites.forEach(site => {
          acc.push({
            id: generateCombinedId(id, site.id),
            name: `${name} (${site.name})`
          });
        });
      } else {
        acc.push({
          id,
          name
        });
      }
      return acc;
    }, []);
    if (Array.isArray(data)) {
      setCombinedSchoolsAndSites(data);
      setVisibleSchoolsAndSites(data.slice(0, pageSize));
      setPage(1);
    } else {
      setCombinedSchoolsAndSites([]);
      setVisibleSchoolsAndSites([]);
    }
  }, [schools]);
  const combinedSchoolAndSite = combinedSchoolsAndSites.find(_ref2 => {
    let {
      id
    } = _ref2;
    return id === generateCombinedId(schoolId, siteId);
  });
  const loadMoreSpaces = () => {
    const nextPage = page + 1;
    const start = page * pageSize;
    const end = start + pageSize;
    const nextBatch = combinedSchoolsAndSites.slice(start, end);
    if (nextBatch.length > 0) {
      setVisibleSchoolsAndSites([...nextBatch]);
      setPage(nextPage);
    }
  };
  return /*#__PURE__*/React.createElement(Select, {
    name: "schoolSite",
    label: "School / Site",
    placeholder: "Search by school or site",
    value: combinedSchoolAndSite,
    onChange: _ref3 => {
      let {
        id
      } = _ref3;
      return setSchoolSite(parseCombinedId(id));
    },
    options: visibleSchoolsAndSites,
    isSearchable: true,
    size: fullWidth ? '' : 'large',
    onScrollBottom: () => {
      if (visibleSchoolsAndSites.length < combinedSchoolsAndSites.length) {
        loadMoreSpaces();
      }
    },
    onClose: () => {
      if (combinedSchoolsAndSites.length > pageSize) {
        setVisibleSchoolsAndSites(combinedSchoolsAndSites.slice(0, pageSize));
        setPage(1);
      }
    }
  });
};
SchoolSitePicker.propTypes = {
  setSchoolSite: PropTypes.func.isRequired,
  schoolId: PropTypes.string,
  siteId: PropTypes.string,
  fullWidth: PropTypes.bool
};
SchoolSitePicker.defaultProps = {
  schoolId: '',
  siteId: '',
  fullWidth: false
};
const MultiSpacePicker = _ref => {
  let {
    schoolId,
    siteId,
    spaces,
    excludedSpaceIds,
    setSpaces,
    fullWidth,
    ...selectProps
  } = _ref;
  const [options, setOptions] = useState([]);
  useEffect(() => {
    if (schoolId) {
      getSpaces({
        schoolId,
        siteId
      }).then(spaceOptions => setOptions(spaceOptions.filter(_ref2 => {
        let {
          id
        } = _ref2;
        return !excludedSpaceIds.includes(id);
      }))).catch(err => console.log(err));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolId, siteId]);
  return /*#__PURE__*/React.createElement(Select, _extends({
    value: spaces && spaces.length ? spaces : null,
    onChange: setSpaces,
    options: options,
    isMulti: true,
    size: fullWidth ? '' : 'large',
    isDisabled: options.length === 0
  }, selectProps));
};
MultiSpacePicker.propTypes = {
  schoolId: PropTypes.string.isRequired,
  siteId: PropTypes.string,
  spaces: PropTypes.arrayOf(PropTypes.object),
  setSpaces: PropTypes.func.isRequired,
  excludedSpaceIds: PropTypes.arrayOf(PropTypes.string),
  fullWidth: PropTypes.bool
};
MultiSpacePicker.defaultProps = {
  spaces: [],
  siteId: null,
  excludedSpaceIds: [],
  fullWidth: false
};
const MultiSpacePicker$1 = _ref => {
  let {
    spaceTypeValue,
    spaceType,
    setSpaceType,
    fullWidth,
    ...selectProps
  } = _ref;
  const theme = useTheme();
  const customStyles = {
    container: provided => ({
      ...provided,
      marginBottom: theme.layout.baseline,
      width: '100%',
      maxWidth: '400px',
      zIndex: 10000
    }),
    control: (provided, state) => ({
      ...provided,
      minHeight: theme.layout.lineHeight + 2,
      color: theme.colors.black,
      borderColor: theme.colors.grey,
      borderRadius: theme.borders.radius.low,
      outline: 'none',
      '&:hover': {
        borderColor: state.isFocused ? 'transparent' : theme.colors.secondary
      },
      ...(state.isFocused && {
        ...theme.styles.focused
      })
    }),
    menu: provided => ({
      ...provided,
      borderColor: theme.colors.grey,
      borderRadius: theme.borders.radius.low,
      boxShadow: theme.shadows.medium
    }),
    option: (provided, state) => ({
      ...provided,
      ...(state.isFocused && {
        backgroundColor: theme.colors.greyLighter,
        '&:active': {
          backgroundColor: theme.colors.greyLight
        }
      }),
      ...(state.isSelected && {
        color: theme.colors.black,
        backgroundColor: theme.colors.greyLighter,
        '&:active': {
          backgroundColor: theme.colors.greyLight
        }
      }),
      ...(state.isDisabled && theme.styles.disabled)
    }),
    placeholder: provided => ({
      ...provided,
      ...theme.styles.placeholder
    })
  };
  const [options, setOptions] = useState([]);
  useEffect(() => {
    getSpaceTypes().then(spaceTypes => {
      const spaceTypeOptions = spaceTypes.map(_ref2 => {
        let {
          id,
          type
        } = _ref2;
        return {
          value: id,
          label: type
        };
      });
      setOptions(spaceTypeOptions);
    }).catch(err => console.log(err));
  }, []);
  return jsx(ReactSelect, _extends({
    name: "space-type",
    label: "Space Type",
    defaultValue: spaceType && spaceTypeValue ? {
      value: spaceType,
      label: spaceTypeValue
    } : '',
    onChange: setSpaceType,
    styles: customStyles,
    options: options,
    isDisabled: options.length === 0
  }, selectProps));
};
MultiSpacePicker$1.propTypes = {
  value: PropTypes.string.isRequired,
  spaceTypeValue: PropTypes.string.isRequired,
  spaceType: PropTypes.number.isRequired,
  setSpaceType: PropTypes.func.isRequired,
  // eslint-disable-next-line react/require-default-props
  fullWidth: PropTypes.bool
};
var SpaceTypePicker = /*#__PURE__*/memo(MultiSpacePicker$1);
const YearPicker = _ref => {
  let {
    yearId,
    setYear,
    ...selectProps
  } = _ref;
  const [years, setYears] = useState([]);
  useEffect(() => {
    getYears().then(setYears).catch(err => console.log(err));
  }, []);
  const year = years.find(_ref2 => {
    let {
      id
    } = _ref2;
    return id === yearId;
  });
  return /*#__PURE__*/React.createElement(Select, _extends({
    name: "year",
    label: "Academic Year",
    placeholder: "Select a year",
    value: year,
    onChange: setYear,
    options: years
  }, selectProps));
};
YearPicker.propTypes = {
  yearId: PropTypes.number,
  setYear: PropTypes.func.isRequired
};
YearPicker.defaultProps = {
  yearId: null
};
const SitePicker = _ref => {
  let {
    availableSites,
    selectedSite,
    onChange,
    fullWidth
  } = _ref;
  const [site, setSiteHandler] = useState(selectedSite);
  const setSiteChangeHandler = value => {
    setSiteHandler(value);
    onChange(value);
  };
  return /*#__PURE__*/React.createElement(Select, {
    name: "schoolSite",
    label: "Sites",
    placeholder: "Change Site",
    value: site,
    options: availableSites,
    onChange: setSiteChangeHandler,
    size: fullWidth ? '' : 'large'
  });
};
SitePicker.propTypes = {
  availableSites: PropTypes.arrayOf(PropTypes.object),
  selectedSite: PropTypes.objectOf(PropTypes.string),
  fullWidth: PropTypes.bool,
  onChange: PropTypes.func
};
SitePicker.defaultProps = {
  availableSites: [],
  selectedSite: {},
  fullWidth: false,
  onChange: () => {}
};
const getDraftFromHTML = data => {
  if (data) {
    const blocksFromHtml = convertFromHTML(data);
    const {
      contentBlocks,
      entityMap
    } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    return EditorState.createWithContent(contentState);
  }
  return EditorState.createEmpty();
};
const RichTextEditor = _ref => {
  let {
    data,
    setFieldValue,
    fieldName = 'description'
  } = _ref;
  const [editorState, setEditorState] = useState(getDraftFromHTML(data));
  const setEditorStateHandler = state => {
    setEditorState(state);
    setFieldValue(fieldName, draftToHtml(convertToRaw(state.getCurrentContent())));
  };
  return /*#__PURE__*/React.createElement("div", null, data && /*#__PURE__*/React.createElement(Editor, {
    editorState: editorState,
    toolbarClassName: "toolbarClassName",
    wrapperClassName: "wrapperClassName",
    editorClassName: "editorClassName",
    onEditorStateChange: setEditorStateHandler
  }));
};
RichTextEditor.propTypes = {
  data: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  fieldName: PropTypes.string
};
RichTextEditor.defaultProps = {
  data: null,
  fieldName: 'description'
};
const MceEditor = _ref => {
  let {
    data,
    setFieldValue,
    fieldName = 'description',
    initForTable,
    directStateUpdation
  } = _ref;
  const [editorData, setEditorData] = useState(data || '<p></p>');
  const setEditorDataHandler = content => {
    setEditorData(content);
    if (content) {
      if (directStateUpdation) {
        setFieldValue(content);
      } else {
        setFieldValue(fieldName, content);
      }
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Editor$1, {
    apiKey: "9bxzx1mcxl8uivey7ujgv1tgcfinmabum4wzqb4w8y72gxdb",
    init: initForTable,
    value: editorData,
    onEditorChange: setEditorDataHandler
  }));
};
MceEditor.propTypes = {
  data: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  fieldName: PropTypes.string,
  initForTable: PropTypes.objectOf(PropTypes.any).isRequired,
  directStateUpdation: PropTypes.bool
};
MceEditor.defaultProps = {
  data: null,
  fieldName: 'description',
  directStateUpdation: null
};

/** @jsx jsx */
const css$v = inline => theme => ({
  width: '100%',
  ...(!inline && {
    margin: '0 auto'
  }),
  maxWidth: theme.grid.maxWidth.l,
  paddingLeft: theme.grid.gutter.s,
  paddingRight: theme.grid.gutter.s,
  [theme.helpers.mq('m')]: {
    paddingLeft: theme.grid.gutter.m,
    paddingRight: theme.grid.gutter.m
  },
  [theme.helpers.mq('l')]: {
    paddingLeft: theme.grid.gutter.l,
    paddingRight: theme.grid.gutter.l
  }
});
const Container = _ref => {
  let {
    children,
    inline,
    styles
  } = _ref;
  return jsx("div", {
    css: withTheme([css$v(inline), styles])
  }, children);
};
Container.propTypes = {
  children: PropTypes.node.isRequired,
  inline: PropTypes.bool,
  styles: PropTypes.oneOfType([PropTypes.func, PropTypes.objectOf(PropTypes.any)])
};
Container.defaultProps = {
  inline: false,
  styles: null
};

/** @jsx jsx */
const css$w = {
  wrapper: theme => ({
    backgroundColor: theme.colors.greyLighter,
    paddingTop: theme.layout.baseline,
    paddingBottom: theme.layout.baseline * 1.5
  }),
  links: theme => ({
    marginTop: theme.layout.baseline * 2,
    textAlign: 'center',
    [theme.helpers.mq('m')]: {
      marginTop: theme.layout.baseline * 3,
      textAlign: 'left'
    }
  }),
  meta: theme => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.helpers.mq('m')]: {
      alignItems: 'flex-end'
    }
  }),
  contact: links => theme => ({
    display: 'none',
    fontSize: theme.font.scale.small,
    lineHeight: '28px',
    ...(links ? {
      marginTop: 0,
      marginBottom: theme.layout.baseline * 2,
      textAlign: 'right'
    } : {
      marginTop: theme.layout.baseline * 3
    }),
    [theme.helpers.mq('l')]: {
      display: 'block'
    }
  }),
  copyright: theme => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.helpers.mq('m')]: {
      justifyContent: 'flex-end',
      marginBottom: theme.layout.baseline * 0.75
    },
    [theme.helpers.print]: {
      display: 'none'
    }
  }),
  copyrightText: theme => ({
    fontSize: theme.font.scale.small
  }),
  logo: theme => ({
    width: theme.layout.baseline * 2,
    marginLeft: theme.layout.baseline / 2,
    [theme.helpers.mq('l')]: {
      width: theme.layout.baseline * 2.5,
      marginLeft: theme.layout.baseline
    }
  })
};
const ContactInfo = _ref => {
  let {
    links
  } = _ref;
  return jsx("p", {
    css: css$w.contact(!!links)
  }, jsx("b", null, "Email"), " ", jsx("a", {
    href: "mailto: info@school-space.org"
  }, "info@school-space.org"), jsx("br", null), jsx("b", null, "Phone"), " ", jsx("a", {
    href: "tel:02033693269"
  }, "020 3369 3269"), jsx("br", null));
};
const CopyrightInfo = () => jsx("div", {
  css: css$w.copyright
}, jsx("p", {
  css: css$w.copyrightText
}, "Copyright \xA9 School Space 2019"), jsx("div", {
  css: css$w.logo
}, jsx(SvgLogoDark, null)));
const Footer = _ref2 => {
  let {
    links
  } = _ref2;
  return jsx("footer", {
    css: css$w.wrapper
  }, jsx(Container, null, jsx(Row, {
    verticalAlign: "flex-end"
  }, jsx(Column, {
    s: [6],
    m: [6],
    l: [6]
  }, links ? jsx(LinkList, {
    styles: css$w.links,
    vertical: true,
    items: links
  }) : jsx(ContactInfo, {
    links: links
  })), jsx(Column, {
    styles: css$w.meta,
    s: [6],
    m: [6],
    l: [6]
  }, links && jsx(ContactInfo, {
    links: links
  }), jsx(CopyrightInfo, null)))));
};
ContactInfo.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object)
};
ContactInfo.defaultProps = {
  links: null
};
Footer.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object)
};
Footer.defaultProps = {
  links: null
};

/** @jsx jsx */
const css$x = {
  wrapper: theme => ({
    height: 72,
    paddingTop: theme.layout.baseline,
    paddingBottom: theme.layout.baseline / 2,
    [theme.helpers.mq('m')]: {
      height: 80,
      paddingBottom: theme.layout.baseline
    },
    [theme.helpers.mq('l')]: {
      height: 98,
      paddingBottom: theme.layout.baseline
    }
  }),
  logo: theme => ({
    height: theme.layout.baseline * 2.5,
    width: theme.layout.baseline * 2.5,
    [theme.helpers.mq('m')]: {
      height: theme.layout.baseline * 3,
      width: theme.layout.baseline * 3
    },
    [theme.helpers.mq('l')]: {
      height: theme.layout.baseline * 4,
      width: theme.layout.baseline * 4
    }
  }),
  navDesktop: theme => ({
    display: 'none',
    [theme.helpers.mq('m')]: {
      display: 'block'
    }
  }),
  navMobile: theme => ({
    display: 'block',
    [theme.helpers.mq('m')]: {
      display: 'none'
    }
  })
};
const Header = _ref => {
  let {
    links,
    openMenu,
    isMinimal
  } = _ref;
  return jsx("div", {
    css: css$x.wrapper
  }, jsx(Container, null, jsx(Row, null, jsx(Column, {
    s: [2],
    m: [2],
    l: [2]
  }, jsx("div", {
    css: css$x.logo
  }, jsx(SvgLogo, null))), !isMinimal && jsx(React.Fragment, null, jsx(Column, {
    styles: css$x.navDesktop,
    alignRight: true,
    s: [6],
    m: [10],
    l: [10]
  }, jsx(LinkList, {
    isNav: true,
    items: links
  })), jsx(Column, {
    styles: css$x.navMobile,
    alignRight: true,
    s: [2, 2],
    m: [2, 8]
  }, jsx(Icon, {
    name: "menu",
    onClick: openMenu
  }))))));
};
Header.propTypes = {
  links: PropTypes.arrayOf(PropTypes.any),
  openMenu: PropTypes.func,
  isMinimal: PropTypes.bool
};
Header.defaultProps = {
  links: [],
  openMenu: null,
  isMinimal: false
};

/** @jsx jsx */
const css$y = {
  container: theme => ({
    height: '100%',
    width: '100%',
    padding: theme.layout.baseline,
    display: 'flex',
    flexDirection: 'column',
    [theme.helpers.mq('m')]: {
      padding: theme.layout.baseline * 1.5
    }
  }),
  header: theme => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    flexDirection: 'column',
    [theme.helpers.mq('m')]: {
      flexDirection: 'row-reverse'
    }
  }),
  close: theme => ({
    alignSelf: 'flex-end',
    [theme.helpers.mq('m')]: {
      alignSelf: 'auto'
    }
  }),
  title: {
    fontSize: '1.3rem',
    marginTop: 0
  },
  content: theme => ({
    ...theme.styles.flexColumnGrow
  })
};
const ModalContainer = _ref => {
  let {
    title,
    close,
    isClosable,
    children
  } = _ref;
  return jsx("div", {
    css: css$y.container
  }, jsx("div", {
    css: css$y.header
  }, jsx("div", {
    css: css$y.close
  }, isClosable && jsx(Icon, {
    name: "close",
    onClick: close
  })), title && jsx(Heading, {
    level: "2",
    size: "large",
    styles: css$y.title
  }, title)), jsx("div", {
    css: css$y.content
  }, children));
};
ModalContainer.propTypes = {
  title: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  isClosable: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};
const modalStyles = {
  body: `
        overflow: hidden
    `,
  overlay: `
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 1;
    `,
  content: (theme, _ref) => {
    let {
      height,
      maxHeight,
      maxWidth
    } = _ref;
    return `
        position: initial;
        background-color: ${theme.colors.white};
        border: none;
        outline: none;
        width: 100%;
        height: 100%;
        overflow-y: auto;
        ${[theme.helpers.mq('m')]} {
            border-radius: ${theme.borders.radius.medium};
            height: ${height};
            max-height: ${maxHeight};
            max-width: ${maxWidth};
        }
    `;
  }
};
const Modal = _ref2 => {
  let {
    title,
    children,
    isOpen,
    isClosable,
    closeModal,
    ariaLabel,
    height,
    maxHeight,
    maxWidth
  } = _ref2;
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(ClassNames, null, _ref3 => {
    let {
      css
    } = _ref3;
    return /*#__PURE__*/React.createElement(ReactModal, _extends({
      bodyOpenClassName: css`
                        ${modalStyles.body}
                    `,
      overlayClassName: css`
                        ${modalStyles.overlay}
                    `,
      className: css`
                        ${modalStyles.content(theme, {
        height,
        maxHeight,
        maxWidth
      })}
                    `,
      isOpen: isOpen,
      contentLabel: ariaLabel,
      shouldCloseOnOverlayClick: isClosable
    }, isClosable && {
      onRequestClose: closeModal
    }), /*#__PURE__*/React.createElement(ModalContainer, {
      title: title,
      close: closeModal,
      isClosable: isClosable
    }, children));
  });
};
Modal.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isClosable: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  height: PropTypes.string,
  maxHeight: PropTypes.string,
  maxWidth: PropTypes.string
};
Modal.defaultProps = {
  title: '',
  isClosable: true,
  height: 'auto',
  maxHeight: 'initial',
  maxWidth: '600px'
};
const ModalContext = /*#__PURE__*/createContext({
  openModal: () => {},
  closeModal: () => {},
  types: {}
});

/** @jsx jsx */
const css$z = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  actions: {
    marginTop: 'auto',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  actionButton: theme => ({
    marginBottom: 0,
    maxWidth: 'initial',
    [theme.helpers.mq('m')]: {
      maxWidth: '50%'
    }
  })
};
const ModalInformation = _ref => {
  let {
    closeModal,
    title,
    message: Message,
    cancelText,
    cancelAction,
    hideButton
  } = _ref;
  return jsx(Modal, {
    title: title,
    isOpen: true,
    closeModal: closeModal,
    ariaLabel: title
  }, jsx("div", {
    css: css$z.container
  }, jsx(Message, null), !hideButton && jsx(React.Fragment, null, jsx(Spacer, null), jsx("div", {
    css: css$z.actions
  }, jsx(Button, {
    styles: css$z.actionButton,
    state: "ghost",
    onClick: cancelAction || closeModal,
    actionWillUnmountComponent: true
  }, cancelText)))));
};
ModalInformation.propTypes = {
  closeModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.func.isRequired,
  cancelText: PropTypes.string.isRequired,
  cancelAction: PropTypes.func,
  hideButton: PropTypes.bool
};
ModalInformation.defaultProps = {
  cancelAction: null,
  hideButton: false
};

/** @jsx jsx */
const css$A = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  actions: {
    marginTop: 'auto',
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    maxWidth: 'none',
    marginBottom: 0,
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const ModalCancellation = _ref => {
  let {
    cancellationType,
    title,
    message: Message,
    confirmText,
    cancelText,
    closeModal,
    confirmAction
  } = _ref;
  const [reason, setReason] = useState(null);
  const [description, setDescription] = useState('');
  return jsx(Modal, {
    title: title,
    isOpen: true,
    closeModal: closeModal,
    ariaLabel: title
  }, jsx("div", {
    css: css$A.container
  }, jsx(Message, null), jsx(Spacer, null), jsx(CancellationPicker, {
    value: reason ? reason.id : null,
    description: description,
    onChange: setReason,
    onDescriptionChange: setDescription,
    cancellationType: cancellationType
  }), jsx(Spacer, {
    height: 1.5
  }), jsx("div", {
    css: css$A.actions
  }, jsx(Button, {
    styles: css$A.actionButton,
    state: "ghost",
    onClick: closeModal,
    actionWillUnmountComponent: true
  }, cancelText), jsx(Button, {
    styles: css$A.actionButton,
    state: "warning",
    onClick: () => {
      if (reason) {
        return confirmAction({
          type: reason.id,
          description: reason.id === 'other' ? description : reason.name
        });
      }
      return confirmAction({
        type: null,
        description: null
      });
    },
    actionWillUnmountComponent: true,
    disabled: !reason
  }, confirmText))));
};
ModalCancellation.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.func.isRequired,
  confirmText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  confirmAction: PropTypes.func.isRequired,
  cancellationType: PropTypes.string.isRequired
};
const css$B = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  summary: theme => ({
    marginTop: 0,
    marginBottom: theme.layout.baseline,
    color: theme.colors.greyDark
  })
};
const Container$1 = _ref => {
  let {
    Pages,
    modalProps,
    closeModal,
    isClosable,
    title,
    subtitles,
    ...props
  } = _ref;
  const numberOfPages = subtitles.length;
  const {
    stepIndex,
    isFirstStep,
    isLastStep,
    nextStep,
    previousStep,
    goToStep
  } = useSteps(numberOfPages);
  return jsx(Modal, _extends({
    isOpen: true,
    closeModal: closeModal,
    title: title,
    ariaLabel: title,
    isClosable: isClosable
  }, modalProps), jsx("div", {
    css: css$B.container
  }, numberOfPages > 1 && jsx("p", {
    css: css$B.summary
  }, `Step ${stepIndex + 1} of ${subtitles.length} - ${subtitles[stepIndex]}`), jsx(Pages, _extends({
    pageIndex: stepIndex,
    isFirstPage: isFirstStep,
    isLastPage: isLastStep,
    nextPage: nextStep,
    previousPage: previousStep,
    goToPage: goToStep,
    closeModal: closeModal
  }, props))));
};
Container$1.propTypes = {
  Pages: PropTypes.func.isRequired,
  modalProps: PropTypes.objectOf(PropTypes.any).isRequired,
  closeModal: PropTypes.func.isRequired,
  isClosable: PropTypes.bool,
  title: PropTypes.string.isRequired,
  subtitles: PropTypes.arrayOf(PropTypes.string).isRequired
};
Container$1.defaultProps = {
  isClosable: true
};
const MultiPageModal = (Pages, modalProps) => props => jsx(Container$1, _extends({
  Pages: Pages,
  modalProps: modalProps
}, props));
const bookingIsAmendable = (date, holidays) => !isWithinNBusinessDays({
  n: 5,
  date,
  holidays
});
const bookingIsCancellable = (date, holidays) => !isWithinNBusinessDays({
  n: 2,
  date,
  holidays
});
const getUnamendableReason = (_ref, holidays) => {
  let {
    date,
    isException
  } = _ref;
  if (!bookingIsAmendable(date, holidays)) {
    return 'Booking can no longer be amended';
  }
  if (isException) {
    return 'Booking must be updated individually';
  }
  return 'Booking can not be amended';
};
const getUncancellableReason = () => 'Booking can no longer be cancelled';
const splitBookingsByAmendable = (bookings, holidays) => {
  const bookingCanBeAmended = booking => bookingIsAmendable(booking.date, holidays) && !booking.isException;
  return partition(bookings, bookingCanBeAmended);
};
const splitBookingsByCancellable = (bookings, holidays) => {
  const bookingCanBeCancelled = booking => bookingIsCancellable(booking.date, holidays);
  return partition(bookings, bookingCanBeCancelled);
};
const getDatesString = numberOfDates => `${numberOfDates.length} ${getPluralNoun(numberOfDates, 'date')}`;
var css$C = {
  container: theme => ({
    maxHeight: '400px',
    overflowY: 'scroll',
    paddingBottom: theme.layout.baseline / 2
  }),
  status: theme => ({
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: theme.layout.baseline * 1.5,
    '&:first-of-type': {
      marginTop: theme.layout.baseline
    }
  }),
  statusIcon: theme => ({
    marginRight: theme.layout.baseline
  }),
  statusSummary: theme => ({
    marginBottom: theme.layout.baseline
  }),
  dateRow: theme => ({
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.layout.baseline / 2
  }),
  date: theme => ({
    minWidth: theme.layout.baseline * 6,
    marginRight: theme.layout.baseline / 2,
    fontWeight: 'bold'
  }),
  allDatesToggle: {
    padding: '0'
  }
};

/** @jsx jsx */
const UnchangeableDates = _ref => {
  let {
    heading,
    dates,
    getUnchangeableReason
  } = _ref;
  return jsx("div", {
    css: css$C.status
  }, jsx("div", {
    css: css$C.statusIcon
  }, jsx(Icon, {
    name: "cross"
  })), jsx("div", null, jsx("div", {
    css: css$C.statusSummary
  }, heading), dates.map(booking => jsx("div", {
    key: booking.id,
    css: css$C.dateRow
  }, jsx("span", {
    css: css$C.date
  }, getShortDateString(booking.date)), jsx("span", null, getUnchangeableReason(booking))))));
};
UnchangeableDates.propTypes = {
  heading: PropTypes.string.isRequired,
  dates: PropTypes.arrayOf(PropTypes.object).isRequired,
  getUnchangeableReason: PropTypes.func.isRequired
};

/** @jsx jsx */
const ChangeableDates = _ref => {
  let {
    heading,
    dates,
    initialDatesToShow
  } = _ref;
  const [showAllDates, setShowAllDates] = useState(false);
  const [datesToShow, setDatesToShow] = useState(initialDatesToShow);
  const hiddenDates = dates.length - initialDatesToShow;
  const showAllText = showAllDates ? 'show less dates' : `and ${hiddenDates} more dates`;
  const theme = useTheme();
  return jsx("div", {
    css: css$C.status
  }, jsx("div", {
    css: css$C.statusIcon
  }, jsx(Icon, {
    name: "tick",
    color: theme.colors.secondary
  })), jsx("div", null, jsx("div", {
    css: css$C.statusSummary
  }, heading), dates.slice(0, datesToShow).map(booking => jsx("div", {
    key: booking.id,
    css: css$C.dateRow
  }, getShortDateString(booking.date))), hiddenDates > 0 && jsx(Button, {
    styles: css$C.allDatesToggle,
    state: "text",
    size: "small",
    onClick: () => {
      setDatesToShow(showAllDates ? initialDatesToShow : dates.length);
      setShowAllDates(!showAllDates);
    }
  }, showAllText)));
};
ChangeableDates.propTypes = {
  heading: PropTypes.string.isRequired,
  dates: PropTypes.arrayOf(PropTypes.object).isRequired,
  initialDatesToShow: PropTypes.number.isRequired
};

/** @jsx jsx */
const RecurringCancellationSummary = _ref => {
  let {
    customerId,
    recurringBookingId
  } = _ref;
  const [fetching, setFetching] = useState(false);
  const [bookings, setBookings] = useState([]);
  const bankHolidays = useBankHolidays();
  const holidays = bankHolidays.map(holiday => holiday.date);
  useEffect(() => {
    setFetching(true);
    getCustomerBookings(customerId, {
      recurringBookingId,
      fromDate: getTodaysDate(),
      states: ['confirmed', 'amending', 'pending']
    }).then(setBookings).catch(() => setBookings([])).then(() => setFetching(false));
  }, [customerId, recurringBookingId]);
  if (fetching) {
    return jsx(Loading, null);
  }
  const [cancellableDates, uncancellableDates] = splitBookingsByCancellable(bookings, holidays);
  const getUncancellableHeading = dates => `${getDatesString(dates)} will not be cancelled`;
  const getCancellableHeading = dates => `${getDatesString(dates)} will be cancelled`;
  return jsx("div", {
    css: css$C.container
  }, !!uncancellableDates.length && jsx(UnchangeableDates, {
    heading: getUncancellableHeading(uncancellableDates),
    dates: uncancellableDates,
    getUnchangeableReason: booking => getUncancellableReason()
  }), !!cancellableDates.length && jsx(ChangeableDates, {
    heading: getCancellableHeading(cancellableDates),
    dates: cancellableDates,
    initialDatesToShow: 4
  }));
};
RecurringCancellationSummary.propTypes = {
  customerId: PropTypes.string.isRequired,
  recurringBookingId: PropTypes.string.isRequired
};
const css$D = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  cancellationReason: theme => ({
    marginTop: theme.layout.baseline
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const RecurringCancellationModal = _ref => {
  let {
    pageIndex,
    isFirstPage,
    isLastPage,
    nextPage,
    previousPage,
    closeModal,
    recurringBookingId,
    customerId,
    confirmAction
  } = _ref;
  const [reason, setReason] = useState(null);
  const [description, setDescription] = useState('');
  const submit = () => {
    if (reason) {
      return confirmAction({
        type: reason.id,
        description: reason.id === 'other' ? description : reason.name
      });
    }
    return confirmAction({
      type: null,
      description: null
    });
  };
  const navigateBack = () => isFirstPage ? closeModal() : previousPage();
  const nextAction = () => isLastPage ? submit() : nextPage();
  return jsx("div", {
    css: css$D.container
  }, jsx("div", {
    css: css$D.container
  }, pageIndex === 0 && jsx("div", {
    css: css$D.cancellationReason
  }, jsx(CancellationPicker, {
    value: reason ? reason.id : null,
    description: description,
    onChange: setReason,
    onDescriptionChange: setDescription,
    cancellationType: "customerRecurringBooking"
  })), pageIndex === 1 && jsx("div", {
    css: css$D.container
  }, jsx("p", null, "Your spaces will be available for other customers to book. Please be aware that you may be subject to the following", ' ', jsx(Link, {
    url: "https://school-space.org/terms-conditions/school-space-cancellation-policy",
    isExternal: true,
    opensInNewTab: true
  }, "cancellations fees"), "."), jsx(RecurringCancellationSummary, {
    customerId: customerId,
    recurringBookingId: recurringBookingId
  }))), jsx("div", {
    css: css$D.buttonContainer
  }, jsx(Button, {
    styles: css$D.actionButton,
    state: "ghost",
    onClick: navigateBack,
    actionWillUnmountComponent: isFirstPage
  }, isFirstPage ? 'No, keep booking' : 'Back'), jsx(Button, _extends({
    styles: css$D.actionButton
  }, isLastPage && {
    state: 'warning'
  }, {
    onClick: nextAction
  }), isLastPage ? 'Yes, cancel repeat booking' : 'Next step')));
};
RecurringCancellationModal.propTypes = {
  pageIndex: PropTypes.number.isRequired,
  isFirstPage: PropTypes.bool.isRequired,
  isLastPage: PropTypes.bool.isRequired,
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  recurringBookingId: PropTypes.string.isRequired,
  customerId: PropTypes.string.isRequired,
  confirmAction: PropTypes.func.isRequired
};
var RecurringCancellationModal$1 = MultiPageModal(RecurringCancellationModal, {
  height: '90vh',
  maxHeight: '700px',
  maxWidth: '550px'
});

// eslint-disable-next-line import/prefer-default-export
const dayIsAvailable = _ref => {
  let {
    date,
    minDate,
    maxDate
  } = _ref;
  if (minDate && dateIsBefore(date, minDate)) return false;
  if (maxDate && dateIsAfter(date, maxDate)) return false;
  return true;
};

// eslint-disable-next-line import/prefer-default-export
const getWeeks = _ref => {
  let {
    selectDate,
    getDateIsSelected,
    minDate,
    maxDate,
    visibleDate
  } = _ref;
  const year = getYear$1(visibleDate);
  const month = getMonth$1(visibleDate);
  const firstDayInMonth = new Date(year, month, 1);
  const daysInVisibleMonth = Array(getDaysInMonth(firstDayInMonth)).fill().map((m, index) => new Date(year, month, index + 1));
  const firstWeekdayInMonth = getDay(firstDayInMonth);
  const daysInPreviousMonth = firstWeekdayInMonth > 0 ? firstWeekdayInMonth - 1 : 6;
  if (daysInPreviousMonth) {
    for (let x = 1; x <= daysInPreviousMonth; x += 1) {
      const date = subDays(firstDayInMonth, x);
      daysInVisibleMonth.unshift(date);
    }
  }
  const lastDayInMonth = new Date(year, month, getDaysInMonth(firstDayInMonth));
  const lastWeekdayInMonth = getDay(lastDayInMonth);
  const daysInNextMonth = lastWeekdayInMonth > 0 ? 7 - lastWeekdayInMonth : 0;
  if (daysInNextMonth) {
    for (let x = 1; x <= daysInNextMonth; x += 1) {
      const date = addDays(lastDayInMonth, x);
      daysInVisibleMonth.push(date);
    }
  }
  const weeksInMonth = [];
  for (let i = 0; i < daysInVisibleMonth.length; i += 7) {
    const daysInWeek = daysInVisibleMonth.slice(i, i + 7);
    const week = daysInWeek.map(date => {
      const day = {
        date,
        format: function () {
          let formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'd';
          return format(date, formatString);
        },
        set: () => selectDate(date),
        isVisible: getMonth$1(date) === month,
        isSelectable: dayIsAvailable({
          date,
          minDate,
          maxDate
        }),
        isSelected: getDateIsSelected(date)
      };
      return {
        ...day,
        getProps: () => ({
          onClick: day.set,
          disabled: !day.isVisible || !day.isSelectable
        })
      };
    });
    weeksInMonth.push(week);
  }
  return weeksInMonth;
};
const WEEKDAYS = [1, 2, 3, 4, 5, 6, 0];

// eslint-disable-next-line import/prefer-default-export
const getWeekdays = () => {
  const utilityDate = new Date(2000, 0, 1);
  const weekdays = WEEKDAYS.map(dayIndex => ({
    current: dayIndex,
    format: function () {
      let formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'EEEEEE';
      return format(setDay(utilityDate, dayIndex), formatString);
    },
    getProps: () => {}
  }));
  return weekdays;
};

// eslint-disable-next-line import/prefer-default-export
const getMonth = _ref => {
  let {
    visibleDate,
    setVisibleDate,
    minDate,
    maxDate,
    showUnavailableMonthsAndYears
  } = _ref;
  const showPreviousMonth = showUnavailableMonthsAndYears || !minDate || dateIsBefore(minDate, visibleDate);
  const showNextMonth = showUnavailableMonthsAndYears || !maxDate || !dateIsBefore(maxDate, addMonths(visibleDate, 1));
  return {
    current: getMonth$1(visibleDate),
    format: function () {
      let formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'MMMM';
      return format(visibleDate, formatString);
    },
    goTo: index => setVisibleDate(setMonth(visibleDate, index)),
    previous: {
      format: function () {
        let formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'MMMM';
        return format(subMonths(visibleDate, 1), formatString);
      },
      goTo: () => setVisibleDate(subMonths(visibleDate, 1)),
      isDisabled: !showPreviousMonth
    },
    next: {
      format: function () {
        let formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'MMMM';
        return format(addMonths(visibleDate, 1), formatString);
      },
      goTo: () => setVisibleDate(addMonths(visibleDate, 1)),
      isDisabled: !showNextMonth
    }
  };
};

// eslint-disable-next-line import/prefer-default-export
const getYear = _ref => {
  let {
    visibleDate,
    setVisibleDate,
    minDate,
    maxDate,
    showUnavailableMonthsAndYears
  } = _ref;
  const showPreviousYear = showUnavailableMonthsAndYears || !minDate || dateIsBefore(minDate, subYears(visibleDate, 1));
  const showNextYear = showUnavailableMonthsAndYears || !maxDate || !dateIsBefore(maxDate, addYears(addMonths(visibleDate, 1), 1));
  return {
    current: getYear$1(visibleDate),
    format: function () {
      let formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'yyyy';
      return format(visibleDate, formatString);
    },
    goTo: index => setVisibleDate(setYear(visibleDate, index)),
    previous: {
      goTo: () => setVisibleDate(subYears(visibleDate, 1)),
      isDisabled: !showPreviousYear
    },
    next: {
      goTo: () => setVisibleDate(addYears(visibleDate, 1)),
      isDisabled: !showNextYear
    }
  };
};
const useCalendar = function () {
  let {
    date = null,
    setDate,
    dates,
    setDates,
    minDate = null,
    maxDate = null,
    showUnavailableMonthsAndYears = true,
    month: visibleMonth = null,
    year: visibleYear = null,
    multiSelect
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const getVisibleDate = useCallback(() => {
    const currentDate = multiSelect ? dates[dates.length - 1] : date;
    const visibleDate = currentDate || getTodaysDate();
    return new Date(visibleYear || getYear$1(visibleDate), visibleMonth || getMonth$1(visibleDate), 1);
  }, [date, multiSelect, dates, visibleYear, visibleMonth]);
  const [visibleDate, setVisibleDate] = useState(getVisibleDate());
  useEffect(() => {
    setVisibleDate(getVisibleDate());
  }, [getVisibleDate]);
  const selectDate = multiSelect ? d => {
    const newDates = [...dates];
    const dIndex = dates.findIndex(comp => dateIsSame(d, comp));
    if (dIndex > -1) {
      newDates.splice(dIndex, 1);
    } else {
      newDates.push(d);
    }
    setDates(newDates);
  } : d => setDate(d);
  const getDateIsSelected = multiSelect ? d => dates.some(comp => dateIsSame(d, comp)) : d => dateIsSame(d, date);
  const weeks = getWeeks({
    selectDate,
    getDateIsSelected,
    minDate,
    maxDate,
    visibleDate
  });
  const weekdays = getWeekdays();
  const month = getMonth({
    visibleDate,
    setVisibleDate,
    minDate,
    maxDate,
    showUnavailableMonthsAndYears
  });
  const year = getYear({
    visibleDate,
    setVisibleDate,
    minDate,
    maxDate,
    showUnavailableMonthsAndYears
  });
  return {
    weeks,
    weekdays,
    month,
    year
  };
};

/** @jsx jsx */
const css$E = {
  button: _ref => {
    let {
      active,
      disabled,
      highlighted
    } = _ref;
    return theme => ({
      position: 'relative',
      height: theme.layout.lineHeight,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0,
      border: `1px solid ${theme.colors.white}`,
      borderRadius: theme.borders.radius.low,
      backgroundColor: theme.colors.white,
      color: theme.colors.black,
      '&:disabled': {
        ...(!highlighted && {
          color: theme.colors.greyLight
        })
      },
      ...(active && {
        borderColor: theme.colors.secondary,
        backgroundColor: theme.colors.secondary,
        color: theme.colors.white
      }),
      '&:hover': {
        ...(!disabled && {
          borderColor: theme.colors.secondary
        })
      }
    });
  }
};
const CalendarButton = _ref2 => {
  let {
    value,
    active,
    disabled,
    highlighted,
    onClick,
    ariaLabel
  } = _ref2;
  return jsx("div", null, jsx("button", {
    type: "button",
    css: css$E.button({
      active,
      disabled,
      highlighted
    }),
    onClick: () => onClick(value),
    disabled: disabled,
    "aria-pressed": active,
    "aria-label": ariaLabel
  }, value));
};
CalendarButton.propTypes = {
  value: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  highlighted: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired
};
CalendarButton.defaultProps = {
  disabled: false,
  highlighted: false
};
const css$F = {
  container: {
    flexBasis: 0,
    flexGrow: 1,
    overflowY: 'scroll',
    padding: 4,
    margin: '0 -4px'
  },
  navigation: theme => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.layout.baseline / 2
  }),
  weekdays: theme => ({
    ...theme.styles.grid({
      gap: 6,
      numColumns: 7
    }),
    textAlign: 'center',
    height: theme.layout.baseline * 1.5,
    color: theme.colors.grey,
    userSelect: 'none'
  }),
  dates: theme => ({
    ...theme.styles.grid({
      gap: 6,
      numColumns: 7
    }),
    marginTop: theme.layout.baseline / 2
  })
};
const Calendar = _ref => {
  let {
    date,
    setDate,
    dates,
    setDates,
    minDate,
    maxDate,
    initialVisibleDate,
    isDayDisabled,
    multiSelect
  } = _ref;
  const {
    weeks,
    weekdays,
    month,
    year
  } = useCalendar({
    date,
    setDate,
    dates,
    setDates,
    minDate,
    maxDate,
    ...(initialVisibleDate && {
      month: getMonth$1(initialVisibleDate),
      year: getYear$1(initialVisibleDate)
    }),
    showUnavailableMonthsAndYears: false,
    multiSelect
  });
  return jsx("div", {
    css: css$F.container
  }, jsx("div", {
    css: css$F.navigation
  }, jsx(IconButton, {
    iconName: "arrowLeft",
    onClick: month.previous.goTo,
    disabled: month.previous.isDisabled,
    ariaLabel: `View ${month.previous.format('MMMM yyyy')}`
  }), jsx(Heading, {
    level: "3",
    size: "medium"
  }, `${month.format()} ${year.format()}`), jsx(IconButton, {
    iconName: "arrowRight",
    onClick: month.next.goTo,
    disabled: month.next.isDisabled,
    ariaLabel: `View ${month.next.format('MMMM yyyy')}`
  })), jsx("div", {
    css: css$F.weekdays
  }, weekdays.map(weekday => {
    const weekdayString = weekday.format();
    return jsx("span", {
      key: weekdayString
    }, weekdayString);
  })), jsx("div", {
    css: css$F.dates
  }, weeks.map(week => week.map(day => {
    const dayString = day.format();
    const {
      disabled,
      ...dayProps
    } = day.getProps();
    return day.isVisible ? jsx(CalendarButton, _extends({
      key: dayString,
      value: dayString,
      active: day.isSelected,
      ariaLabel: `Select ${day.format('do MMMM')}`,
      disabled: disabled || isDayDisabled && isDayDisabled(day.date)
    }, dayProps)) : jsx("div", {
      key: dayString
    });
  }))));
};
Calendar.propTypes = {
  date: PropTypes.instanceOf(Date),
  setDate: PropTypes.func,
  dates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  setDates: PropTypes.func,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  initialVisibleDate: PropTypes.instanceOf(Date),
  isDayDisabled: PropTypes.func,
  multiSelect: PropTypes.bool
};
Calendar.defaultProps = {
  date: null,
  setDate: null,
  dates: null,
  setDates: null,
  minDate: null,
  maxDate: null,
  initialVisibleDate: null,
  isDayDisabled: null,
  multiSelect: false
};
const css$G = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  row: () => ({
    display: 'flex',
    justifyContent: 'space-between'
  }),
  field: theme => ({
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  }),
  discountRow: {
    display: 'flex'
  },
  discount: theme => ({
    marginRight: theme.layout.baseline
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const endDateIsValid = (endDate, dateOptions) => {
  const recurrenceDate = dateOptions.find(_ref => {
    let {
      date
    } = _ref;
    return dateIsSame(date, endDate);
  });
  return recurrenceDate && recurrenceDate.isSelectable;
};
const dateIsAvailable = date => !date.isUnavailable && !date.isNonOperational;
const recurrenceIsFortnightly = recurrenceString => {
  const {
    frequency,
    interval
  } = getRecurrenceOptions(recurrenceString);
  return frequencyIsFortnightly(frequency, interval);
};
const setSelectableDates = (dateOptions, startDate, pickingStartDate, recurrenceString) => {
  if (dateOptions === null) return dateOptions;
  if (pickingStartDate) {
    return dateOptions.map((date, index) => ({
      ...date,
      isSelectable: dateOptions[index + 1] ? dateIsAvailable(date) && dateIsAvailable(dateOptions[index + 1]) : dateIsAvailable(date)
    }));
  }
  const isFortnightly = recurrenceIsFortnightly(recurrenceString);
  const firstUnavailableDate = dateOptions.find(date => dateIsAfter(date.date, startDate) && !dateIsAvailable(date));
  return dateOptions.map(date => {
    const isSelectable = dateIsAfter(date.date, startDate) && (!firstUnavailableDate || dateIsBefore(date.date, firstUnavailableDate.date)) && (!isFortnightly || !datesAreOnAlternateWeeks(date.date, startDate));
    return {
      ...date,
      isSelectable
    };
  });
};
const RecurringStartEndDatesModal = _ref2 => {
  let {
    pageIndex,
    closeModal,
    originalRecurringBooking,
    onUpdate
  } = _ref2;
  const [picker, setPicker] = useState('startDate');
  const pickingStartDate = picker === 'startDate';
  const originalStartDate = new Date(originalRecurringBooking.startDate);
  const originalEndDate = new Date(originalRecurringBooking.endDate);
  const [startDate, setStartDate] = useState(originalStartDate);
  const [endDate, setEndDate] = useState(originalEndDate);
  const [dateOptions, setDateOptions] = useState(null);
  const dateOptionsWithSelectable = useMemo(() => setSelectableDates(dateOptions, startDate, pickingStartDate, originalRecurringBooking.recurrenceString), [dateOptions, startDate, pickingStartDate, originalRecurringBooking.recurrenceString]);
  const [initialVisibleDate, setInitialVisibleDate] = useState(null);
  const calendarDate = pickingStartDate ? startDate : endDate;
  const submit = () => {
    if (dateIsSame(originalStartDate, startDate) && dateIsSame(originalEndDate, endDate)) {
      return closeModal();
    }
    return updateCustomerRecurringBooking(originalRecurringBooking.customerId, originalRecurringBooking.id, {
      startDate: dateFromDatetime(startDate),
      endDate: dateFromDatetime(endDate)
    }).then(onUpdate).then(closeModal);
  };
  useEffect(() => {
    getCustomerRecurringBookingAvailableDates(originalRecurringBooking.customerId, originalRecurringBooking.id).then(setDateOptions).catch(err => console.log(err));
  }, [originalRecurringBooking]);
  useEffect(() => {
    if (!dateOptionsWithSelectable) {
      return;
    }
    if (!endDateIsValid(endDate, dateOptionsWithSelectable)) {
      const firstSelectableDate = dateOptionsWithSelectable.find(_ref3 => {
        let {
          isSelectable
        } = _ref3;
        return isSelectable;
      });
      setEndDate(null);
      setInitialVisibleDate(new Date(firstSelectableDate.date));
    }
  }, [endDate, dateOptionsWithSelectable]);
  const dayIsDisabled = useCallback(day => {
    const recurrenceDate = dateOptionsWithSelectable.find(_ref4 => {
      let {
        date
      } = _ref4;
      return dateIsSame(day, date);
    });
    return !recurrenceDate || !recurrenceDate.isSelectable;
  }, [dateOptionsWithSelectable]);
  return jsx("div", {
    css: css$G.container
  }, pageIndex === 0 && jsx("div", {
    css: css$G.container
  }, jsx("div", {
    css: css$G.row
  }, jsx("div", {
    css: css$G.field
  }, jsx(PickerField, {
    id: "startDate",
    label: "Start date",
    placeholder: "Select date below",
    value: ukDateFromDatetime(startDate),
    active: pickingStartDate,
    showPlaceholder: !startDate,
    onClick: () => setPicker('startDate'),
    disabled: false
  })), jsx("div", {
    css: css$G.field
  }, jsx(PickerField, {
    id: "endDate",
    label: "End date",
    placeholder: "Select date below",
    value: endDate && ukDateFromDatetime(endDate),
    active: !pickingStartDate,
    showPlaceholder: !endDate,
    onClick: () => setPicker('endDate'),
    disabled: !startDate
  }))), jsx("div", {
    css: css$G.container
  }, dateOptions ? jsx(Calendar, _extends({
    date: calendarDate
  }, !calendarDate && {
    initialVisibleDate
  }, {
    setDate: pickingStartDate ? date => {
      setStartDate(date);
      setPicker('endDate');
    } : setEndDate,
    minDate: new Date(dateOptions[0].date),
    maxDate: new Date(dateOptions[dateOptions.length - 1].date),
    isDayDisabled: dayIsDisabled
  })) : jsx(Loading, {
    fullHeight: true
  }))), jsx("div", {
    css: css$G.buttonContainer
  }, jsx(Button, {
    styles: css$G.actionButton,
    state: "ghost",
    onClick: closeModal,
    actionWillUnmountComponent: true
  }, "Cancel"), jsx(Button, {
    styles: css$G.actionButton,
    onClick: submit
  }, "Confirm")));
};
RecurringStartEndDatesModal.propTypes = {
  pageIndex: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired,
  originalRecurringBooking: PropTypes.objectOf(PropTypes.any),
  onUpdate: PropTypes.func.isRequired
};
RecurringStartEndDatesModal.defaultProps = {
  originalRecurringBooking: {}
};
var RecurringStartEndDatesModal$1 = MultiPageModal(RecurringStartEndDatesModal, {
  height: '90vh',
  maxHeight: '700px',
  maxWidth: '550px'
});

/** @jsx jsx */
const css$H = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  content: theme => ({
    ...theme.styles.flexColumnGrow,
    height: '40vh',
    overflow: 'scroll'
  }),
  heading: {
    marginBottom: '0'
  },
  list: theme => ({
    paddingLeft: theme.layout.baseline,
    listStyleType: 'circle'
  }),
  buttonContainer: theme => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.layout.baseline / 2
  }),
  actionButton: function () {
    let hidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return theme => ({
      flexGrow: 1,
      maxWidth: 'initial',
      marginLeft: theme.layout.baseline,
      '&:first-of-type': {
        marginLeft: 0
      },
      ...(hidden && {
        visibility: 'hidden '
      })
    });
  }
};
const RebookingInformationModal = _ref => {
  let {
    pageIndex,
    isFirstPage,
    isLastPage,
    nextPage,
    previousPage,
    closeModal
  } = _ref;
  const submit = () => {
    localStorage.setItem('rebookingInfoSeen', 'true');
    return closeModal();
  };
  const nextAction = () => {
    return isLastPage ? submit() : nextPage();
  };
  return jsx("div", {
    css: css$H.container
  }, jsx("div", {
    css: css$H.container
  }, pageIndex === 0 && jsx("div", {
    css: css$H.content
  }, jsx("p", null, "Every year, we open up bookings for the next academic year. Priority is given to our existing customers to rebook the slots they have had this year."), jsx("p", null, "We\u2019ve created your new repeat bookings for the next academic year, based on the booking you\u2019ve had with us this year.", ' ', jsx("b", null, "In order to keep your slots next year, you need to review and confirm all of the repeat bookings by 5 pm on 23rd May 2025.")), jsx("p", null, "After this date, if you have not confirmed your booking, we will assume that you do not wish to continue your bookings into the next academic year. The slots we\u2019re holding for you will be cancelled and the spaces will become available to other customers to use from 1st September 2025.")), pageIndex === 1 && jsx("div", {
    css: css$H.content
  }, jsx("p", null, "Before you get started, there are a few things to be aware of that will affect your bookings for the 2025/2026 academic year."), jsx(Heading, {
    styles: css$H.heading,
    level: "3"
  }, "Pricing changes"), jsx("p", null, "Each year we review the prices of our School Spaces. You may therefore see an increase to the amount you pay per booking which will take effect from 1st September 2025."), jsx(Heading, {
    styles: css$H.heading,
    level: "3"
  }, "Cancellations"), jsx("p", null, "If your bookings are recurring, we will assume that any dates confirmed in the next step will be going ahead and you will therefore be charged accordingly for all confirmed booking dates. Please be sure to check the start and end dates of your bookings are correct and cancel any dates that you do not require well in advance of bookings to avoid any cancellation fees."), jsx(Heading, {
    styles: css$H.heading,
    level: "3"
  }, "VAT charges"), jsx("p", null, "If the facility you\u2019re hiring is a sporting facility or car park then these are subject to VAT, unless your bookings meet the exemption. Please take into account that changes to your bookings may result in your bookings no longer meeting the VAT exemption."), jsx("p", null, "By agreeing to re-book with School Space, you agree to our updated policies. Please read carefully before accepting:", ' '), jsx("p", null, jsx(Link, {
    url: "https://school-space.org/terms-conditions",
    isExternal: true,
    opensInNewTab: true
  }, "Terms and Conditions")), jsx("p", null, jsx(Link, {
    url: "https://school-space.org/terms-conditions/hire-charges-deposit-terms",
    isExternal: true,
    opensInNewTab: true
  }, "Hire Charges & Deposit Terms")), jsx("p", null, jsx(Link, {
    url: "https://school-space.org/terms-conditions/school-space-cancellation-policy",
    isExternal: true,
    opensInNewTab: true
  }, "School Space Cancellation Policy")), ".")), jsx("div", {
    css: css$H.buttonContainer
  }, jsx(Button, {
    styles: css$H.actionButton(isFirstPage),
    state: "ghost",
    onClick: previousPage,
    actionWillUnmountComponent: isFirstPage
  }, "Back"), jsx(Button, {
    styles: css$H.actionButton(),
    onClick: nextAction
  }, isLastPage ? "I accept, let's go!" : 'Next')));
};
RebookingInformationModal.propTypes = {
  pageIndex: PropTypes.number.isRequired,
  isFirstPage: PropTypes.bool.isRequired,
  isLastPage: PropTypes.bool.isRequired,
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
};
var RebookingInformationModal$1 = MultiPageModal(RebookingInformationModal, {
  height: '82vh',
  maxHeight: '680px',
  maxWidth: '550px'
});

/** @jsx jsx */
const css$I = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  actions: {
    marginTop: 'auto',
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    maxWidth: 'none',
    marginBottom: 0,
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const ModalConfirmation = _ref => {
  let {
    closeModal,
    title,
    message: Message,
    confirmText,
    confirmAction,
    confirmButtonState,
    cancelText,
    cancelAction
  } = _ref;
  return jsx(Modal, {
    title: title,
    isOpen: true,
    closeModal: closeModal,
    ariaLabel: title
  }, jsx("div", {
    css: css$I.container
  }, jsx(Message, null), jsx(Spacer, null), jsx("div", {
    css: css$I.actions
  }, jsx(Button, {
    styles: css$I.actionButton,
    state: "ghost",
    onClick: cancelAction || closeModal,
    actionWillUnmountComponent: true
  }, cancelText), jsx(Button, {
    styles: css$I.actionButton,
    state: confirmButtonState,
    onClick: confirmAction,
    actionWillUnmountComponent: true
  }, confirmText))));
};
ModalConfirmation.propTypes = {
  closeModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.func.isRequired,
  confirmText: PropTypes.string.isRequired,
  confirmAction: PropTypes.func.isRequired,
  confirmButtonState: PropTypes.string,
  cancelText: PropTypes.string.isRequired,
  cancelAction: PropTypes.func
};
ModalConfirmation.defaultProps = {
  confirmButtonState: null,
  cancelAction: null
};

/** @jsx jsx */
const css$J = {
  wrapper: theme => ({
    [theme.helpers.mq('l')]: {
      display: 'none'
    }
  }),
  links: {
    textAlign: 'center'
  },
  meta: theme => ({
    position: 'absolute',
    bottom: theme.layout.baseline,
    left: theme.grid.gutter.s,
    right: theme.grid.gutter.s,
    fontSize: theme.font.scale.small,
    lineHeight: theme.font.baseline,
    [theme.helpers.mq('m')]: {
      left: theme.grid.gutter.m,
      right: theme.grid.gutter.m
    }
  }),
  contactPhone: theme => ({
    fontSize: theme.font.scale.small
  })
};
const MobileMenu = _ref => {
  let {
    links,
    closeModal
  } = _ref;
  return jsx("div", {
    css: css$J.wrapper
  }, jsx(Modal, {
    isOpen: true,
    closeModal: closeModal,
    ariaLabel: "Mobile navigation menu"
  }, jsx(Container, null, jsx("div", null, jsx(Spacer, {
    height: 1.5
  }), jsx(Row, null, jsx(Column, {
    s: [4, 1, 1],
    m: [6, 3, 3]
  }, jsx("nav", {
    "aria-label": "Main"
  }, jsx(LinkList, {
    styles: css$J.links,
    vertical: true,
    items: links,
    onClick: closeModal
  }))))), jsx("div", {
    css: css$J.meta
  }, jsx(Row, null, jsx(Column, {
    s: [3],
    m: [6]
  }, jsx("p", {
    css: css$J.contactPhone
  }, "Phone: ", jsx("br", null), jsx("a", {
    href: "tel:02033693269"
  }, "020 3369 3269"))), jsx(Column, {
    alignRight: true,
    s: [3],
    m: [6]
  }, jsx("a", {
    href: "mailto: info@school-space.org"
  }, "info@school-space.org")))))));
};
MobileMenu.propTypes = {
  links: PropTypes.arrayOf(PropTypes.any).isRequired,
  closeModal: PropTypes.func.isRequired
};

/** @jsx jsx */
const css$K = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  spaceBooker: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  summary: theme => ({
    marginTop: theme.layout.baseline,
    marginBottom: theme.layout.baseline / 2,
    fontSize: theme.font.scale.small,
    [theme.helpers.mq('s')]: {
      fontSize: theme.font.scale.default
    }
  }),
  spaceSummary: theme => ({
    marginTop: 0,
    marginBottom: theme.layout.baseline,
    fontSize: theme.font.scale.small,
    [theme.helpers.mq('s')]: {
      fontSize: theme.font.scale.default
    }
  }),
  error: theme => ({
    color: theme.colors.error,
    marginTop: theme.layout.baseline / 2,
    marginBottom: theme.layout.baseline / 2,
    fontSize: theme.font.scale.small,
    minHeight: theme.font.scale.small,
    [theme.helpers.mq('s')]: {
      fontSize: theme.font.scale.default,
      minHeight: theme.font.scale.default
    }
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const validate = (_ref, _ref2) => {
  let {
    spaceId,
    startTime,
    endTime
  } = _ref;
  let {
    space: {
      minimumBookingDuration
    }
  } = _ref2;
  if (!spaceId) {
    return 'Please select a space for your booking.';
  }
  if (!startTime) {
    return 'Please select a start time for your booking.';
  }
  if (!endTime) {
    return 'Please select an end time for your booking.';
  }
  if (calculateDurationInMinutes(startTime, endTime) < minimumBookingDuration) {
    return `Bookings in this space must be at least ${minimumBookingDuration} minutes.`;
  }
  return null;
};
const SpaceBookingModal = _ref3 => {
  let {
    closeModal,
    customerId,
    bookingId,
    originalSpaceBooking,
    date,
    dateString,
    school,
    site,
    onUpdate
  } = _ref3;
  const [space, setSpace] = useState(originalSpaceBooking.space || {});
  const [startTime, setStartTime] = useState(originalSpaceBooking.startTime);
  const [endTime, setEndTime] = useState(originalSpaceBooking.endTime);
  const [spaceUnavailable, setSpaceUnavailable] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const pickSpace = useCallback(newSpace => {
    setErrorMessage('');
    setSpace(newSpace);
  }, []);
  const setTimes = useCallback(times => {
    setErrorMessage('');
    setStartTime(times.startTime);
    setEndTime(times.endTime);
  }, []);
  const getSlotsForPicker = useCallback(() => getSlots({
    eventType: 'SpaceBooking',
    eventId: originalSpaceBooking.id,
    date,
    spaceId: space.id,
    bookingId
  }), [originalSpaceBooking.id, date, space.id, bookingId]);
  const submit = () => {
    const data = {
      spaceId: space.id,
      startTime: formatToIso(startTime),
      endTime: formatToIso(endTime)
    };
    if (spaceUnavailable) {
      return setErrorMessage('Please select a space that is available on this day.');
    }
    const validationError = validate(data, {
      space
    });
    if (validationError) {
      return setErrorMessage(validationError);
    }
    if (originalSpaceBooking.id) {
      return updateCustomerSpaceBooking(customerId, bookingId, originalSpaceBooking.id, data).then(onUpdate).then(closeModal).catch(() => setErrorMessage('Error amending booking, please refresh and try again.'));
    }
    return postCustomerSpaceBooking(customerId, bookingId, data).then(onUpdate).then(closeModal).catch(() => setErrorMessage('Error amending booking, please refresh and try again.'));
  };
  const title = originalSpaceBooking.space ? 'Edit space' : 'Add new space';
  return jsx(Modal, {
    title: title,
    isOpen: true,
    closeModal: closeModal,
    ariaLabel: title,
    height: "90vh",
    maxHeight: "700px",
    maxWidth: "550px"
  }, jsx("div", {
    css: css$K.container
  }, jsx("p", {
    css: css$K.spaceSummary
  }, jsx("b", null, school.name), jsx("br", null), dateString), jsx("div", {
    css: css$K.spaceBooker
  }, jsx(SpaceBooker, {
    date: date,
    schoolId: school.id,
    siteId: site.id,
    space: space,
    setSpace: pickSpace,
    times: {
      startTime,
      endTime
    },
    setTimes: setTimes,
    spaceUnavailable: spaceUnavailable,
    setSpaceUnavailable: setSpaceUnavailable,
    getSlots: getSlotsForPicker
  })), jsx("p", {
    css: css$K.error
  }, errorMessage), jsx("div", {
    css: css$K.buttonContainer
  }, jsx(Button, {
    styles: css$K.actionButton,
    state: "ghost",
    onClick: closeModal,
    actionWillUnmountComponent: true
  }, "Cancel"), jsx(Button, {
    styles: css$K.actionButton,
    onClick: submit
  }, "Confirm"))));
};
SpaceBookingModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  school: PropTypes.objectOf(PropTypes.any).isRequired,
  site: PropTypes.objectOf(PropTypes.any),
  date: PropTypes.string.isRequired,
  dateString: PropTypes.string.isRequired,
  bookingId: PropTypes.string.isRequired,
  customerId: PropTypes.string.isRequired,
  originalSpaceBooking: PropTypes.objectOf(PropTypes.any),
  onUpdate: PropTypes.func.isRequired
};
SpaceBookingModal.defaultProps = {
  site: {},
  originalSpaceBooking: {}
};

/** @jsx jsx */
const css$L = {
  container: theme => ({
    marginBottom: theme.layout.baseline
  }),
  titleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    margin: 0
  },
  controls: {
    display: 'flex',
    alignItems: 'center'
  },
  filters: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  filter: theme => ({
    marginRight: theme.layout.baseline
  }),
  controlButton: theme => ({
    marginLeft: theme.layout.baseline / 2
  }),
  textButton: theme => ({
    minHeight: theme.layout.baseline * 2,
    paddingTop: theme.layout.baseline / 4,
    paddingBottom: theme.layout.baseline / 4
  })
};
const TableHeader = _ref => {
  let {
    title,
    isResponsive,
    filterable,
    refreshData,
    columns,
    selectedAction,
    selectedActionLabel,
    hasSelected,
    onCreate
  } = _ref;
  const [showFilters, setShowFilters] = useState(false);
  return jsx("div", {
    css: css$L.container
  }, jsx("div", {
    css: css$L.titleRow
  }, jsx("div", null, !isResponsive && title && jsx(Heading, {
    level: "2",
    size: "large",
    styles: css$L.title
  }, title)), jsx("div", {
    css: css$L.controls
  }, selectedAction && jsx("div", {
    css: css$L.controlButton
  }, jsx(Button, {
    state: "ghost",
    size: "small",
    onClick: selectedAction,
    styles: css$L.textButton,
    disabled: !hasSelected
  }, selectedActionLabel)), onCreate && jsx("div", {
    css: css$L.controlButton
  }, jsx(IconButton, {
    iconName: "plus",
    ariaLabel: "create new",
    onClick: onCreate
  })), refreshData && jsx("div", {
    css: css$L.controlButton
  }, jsx(IconButton, {
    iconName: "refresh",
    ariaLabel: "refresh table data",
    onClick: refreshData
  })), filterable && jsx("div", {
    css: css$L.controlButton
  }, jsx(IconButton, {
    iconName: "filter",
    ariaLabel: "toggle table filters",
    onClick: () => setShowFilters(!showFilters)
  })))), showFilters && jsx("div", {
    css: css$L.filters
  }, columns.map(column => column.canFilter && jsx("div", {
    css: css$L.filter,
    key: `table-filters-${column.id}`
  }, jsx(Label, {
    text: column.render('Header'),
    htmlFor: `table-filter-${column.id}`
  }, column.render('Filter'))))));
};
TableHeader.propTypes = {
  title: PropTypes.string,
  isResponsive: PropTypes.bool.isRequired,
  filterable: PropTypes.bool.isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  refreshData: PropTypes.func,
  selectedAction: PropTypes.func,
  selectedActionLabel: PropTypes.string,
  hasSelected: PropTypes.bool,
  onCreate: PropTypes.func
};
TableHeader.defaultProps = {
  title: null,
  refreshData: null,
  selectedAction: null,
  selectedActionLabel: '',
  hasSelected: false,
  onCreate: null
};
const css$M = {
  headerCell: _ref => {
    let {
      paginated
    } = _ref;
    return theme => ({
      paddingBottom: paginated ? theme.layout.baseline : theme.layout.baseline / 2,
      paddingTop: 0,
      textAlign: 'left',
      fontWeight: 'bold',
      color: theme.colors.secondaryDark,
      whiteSpace: 'nowrap'
    });
  },
  headerCellContent: {
    display: 'flex',
    alignItems: 'center'
  },
  sortIcon: _ref2 => {
    let {
      descending
    } = _ref2;
    return theme => ({
      ...theme.styles.rotatable({
        rotated: !descending
      }),
      marginLeft: theme.layout.baseline / 4
    });
  }
};
const TableHead = _ref3 => {
  let {
    title,
    headerGroups,
    paginated,
    responsiveOnMobile,
    sortable
  } = _ref3;
  return jsx("thead", null, responsiveOnMobile ? jsx("tr", null, jsx("th", {
    css: css$M.headerCell({
      paginated
    })
  }, title)) : headerGroups.map(headerGroup => jsx("tr", headerGroup.getHeaderGroupProps(), headerGroup.headers.map(column => jsx("th", _extends({
    css: css$M.headerCell({
      paginated
    })
  }, column.getHeaderProps(sortable && column.getSortByToggleProps())), jsx("div", {
    css: css$M.headerCellContent
  }, column.render('Header'), column.isSorted && jsx(Icon, {
    name: "sortDown",
    styles: css$M.sortIcon({
      descending: column.isSortedDesc
    })
  })))))));
};
TableHead.propTypes = {
  headerGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string,
  responsiveOnMobile: PropTypes.bool.isRequired,
  paginated: PropTypes.bool.isRequired,
  sortable: PropTypes.bool.isRequired
};
TableHead.defaultProps = {
  title: null
};

/** @jsx jsx */
const css$N = {
  actions: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-end'
  },
  action: theme => ({
    marginRight: theme.layout.baseline / 2,
    '&:last-of-type': {
      marginRight: 0
    }
  })
};
const CellRowEdit = _ref => {
  let {
    row,
    onEdit,
    onDelete,
    focusable
  } = _ref;
  return jsx("div", {
    css: css$N.actions
  }, onEdit && jsx("div", {
    css: css$N.action
  }, jsx(IconButton, {
    iconName: "edit",
    onClick: () => onEdit(row.original),
    ariaLabel: "edit row",
    focusable: focusable
  })), onDelete && jsx("div", {
    css: css$N.action
  }, jsx(IconButton, {
    iconName: "delete",
    onClick: () => onDelete(row.original),
    ariaLabel: "delete row",
    focusable: focusable
  })));
};
CellRowEdit.propTypes = {
  row: PropTypes.objectOf(PropTypes.any).isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  focusable: PropTypes.bool
};
CellRowEdit.defaultProps = {
  focusable: true,
  onEdit: null,
  onDelete: null
};
const css$O = {
  row: _ref => {
    let {
      disabled,
      stripedRows,
      clickable
    } = _ref;
    return theme => ({
      ...(disabled && {
        color: theme.colors.grey
      }),
      ...(stripedRows && {
        '&:nth-of-type(even)': {
          backgroundColor: theme.colors.greyLighter
        }
      }),
      ...(clickable && {
        '&:hover': {
          backgroundColor: theme.colors.greyLighter
        }
      })
    });
  },
  mobileRow: theme => ({
    marginTop: theme.layout.baseline / 4,
    '&:first-of-type': {
      marginTop: 0
    }
  }),
  selectorCell: theme => ({
    paddingRight: theme.layout.baseline
  }),
  cell: _ref2 => {
    let {
      rowHeight
    } = _ref2;
    return theme => ({
      height: rowHeight,
      paddingRight: theme.layout.baseline,
      '&:first-of-type': {
        width: theme.layout.tableColumnWidths.medium
      },
      '&:last-of-type': {
        paddingRight: 0,
        verticalAlign: 'baseline'
      },
      [theme.helpers.mq('s')]: {
        '&:last-of-type': {
          verticalAlign: 'inherit'
        }
      }
    });
  },
  editCell: theme => ({
    width: theme.layout.baseline * 6
  }),
  disabledStatus: {
    textAlign: 'right'
  }
};
const TableBody = _ref3 => {
  let {
    rows,
    onEdit,
    onDelete,
    onRowClick,
    stripedRows,
    focusable,
    selectable,
    responsiveOnMobile,
    getTableBodyProps,
    prepareRow,
    rowHeight
  } = _ref3;
  return jsx("tbody", getTableBodyProps(), rows.map(row => {
    prepareRow(row);
    const tableIsEditable = onEdit || onDelete;
    const rowIsDisabled = row.original.disabled;
    const rowIsEditable = tableIsEditable && !rowIsDisabled && row.original.editable !== false;
    const dataCells = selectable ? row.cells.slice(1) : row.cells;
    const selectorCell = selectable && row.cells[0];
    return jsx("tr", _extends({
      css: css$O.row({
        disabled: row.original.disabled,
        stripedRows,
        clickable: !!onRowClick
      })
    }, row.getRowProps()), selectorCell && jsx("td", _extends({
      css: css$O.selectorCell
    }, selectorCell.getCellProps()), selectorCell.render('Cell')), responsiveOnMobile ? jsx("td", {
      css: css$O.cell({
        rowHeight
      })
    }, dataCells.map(cell => !cell.column.hideOnMobile && jsx("div", _extends({
      css: css$O.mobileRow
    }, cell.getCellProps()), cell.render('Cell')))) : dataCells.map(cell => {
      return jsx("td", _extends({
        css: css$O.cell({
          rowHeight
        })
      }, cell.getCellProps(), onRowClick && {
        onClick: () => onRowClick(row.original)
      }), cell.render('Cell'));
    }), jsx("td", {
      css: withTheme([css$O.cell({
        rowHeight
      }), tableIsEditable && css$O.editCell])
    }, rowIsEditable && jsx(CellRowEdit, {
      row: row,
      onEdit: onEdit,
      onDelete: onDelete,
      focusable: focusable
    }), rowIsDisabled && jsx("div", {
      css: css$O.disabledStatus
    }, "Cancelled")));
  }));
};
TableBody.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onRowClick: PropTypes.func,
  stripedRows: PropTypes.bool.isRequired,
  focusable: PropTypes.bool.isRequired,
  responsiveOnMobile: PropTypes.bool.isRequired,
  getTableBodyProps: PropTypes.func.isRequired,
  prepareRow: PropTypes.func.isRequired,
  rowHeight: PropTypes.number.isRequired,
  selectable: PropTypes.bool.isRequired
};
TableBody.defaultProps = {
  onEdit: null,
  onDelete: null,
  onRowClick: null
};

/** @jsx jsx */
const css$P = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  navigation: {
    display: 'flex',
    alignItems: 'center'
  },
  navigationButton: theme => ({
    marginLeft: theme.layout.baseline / 2
  }),
  pageSize: {
    display: 'flex',
    alignItems: 'center'
  }
};
const selectCss$1 = theme => ({
  container: {
    marginRight: theme.layout.baseline / 2,
    marginBottom: 0,
    width: theme.layout.baseline * 4.5
  },
  control: {
    minHeight: theme.layout.baseline * 2
  },
  indicatorsContainer: {
    '> div': {
      padding: theme.layout.baseline / 4
    }
  }
});
const options = [{
  id: 5,
  name: '5'
}, {
  id: 10,
  name: '10'
}, {
  id: 25,
  name: '25'
}, {
  id: 50,
  name: '50'
}];
const getPositionText = (pageSize, pageIndex, totalRows) => {
  const firstRowNumber = pageSize * pageIndex + 1;
  const lastRowNumber = pageSize * (pageIndex + 1);
  return `${firstRowNumber}-${Math.min(lastRowNumber, totalRows)} of ${totalRows} rows`;
};
const Pagination = _ref => {
  let {
    canPreviousPage,
    canNextPage,
    goToFirstPage,
    goToPrevPage,
    goToNextPage,
    goToLastPage,
    pageSize,
    setPageSize,
    totalRows,
    pageIndex
  } = _ref;
  return jsx("div", {
    css: css$P.container
  }, jsx("div", {
    css: css$P.pageSize
  }, jsx(Select, {
    name: "pageSize",
    size: "small",
    options: options,
    value: options.find(_ref2 => {
      let {
        id
      } = _ref2;
      return id === pageSize;
    }),
    onChange: _ref3 => {
      let {
        id
      } = _ref3;
      return setPageSize(id);
    },
    styles: selectCss$1
  }), jsx("span", null, "rows per page")), jsx("div", {
    css: css$P.navigation
  }, jsx("span", null, getPositionText(pageSize, pageIndex, totalRows)), jsx("div", {
    css: css$P.navigationButton
  }, jsx(IconButton, {
    iconName: "arrowFirst",
    ariaLabel: "Go to first page",
    onClick: goToFirstPage,
    disabled: !canPreviousPage
  })), jsx("div", {
    css: css$P.navigationButton
  }, jsx(IconButton, {
    iconName: "arrowLeft",
    ariaLabel: "Go to previous page",
    onClick: goToPrevPage,
    disabled: !canPreviousPage
  })), jsx("div", {
    css: css$P.navigationButton
  }, jsx(IconButton, {
    iconName: "arrowRight",
    ariaLabel: "Go to next page",
    onClick: goToNextPage,
    disabled: !canNextPage
  })), jsx("div", {
    css: css$P.navigationButton
  }, jsx(IconButton, {
    iconName: "arrowLast",
    ariaLabel: "Go to last page",
    onClick: goToLastPage,
    disabled: !canNextPage
  }))));
};
Pagination.propTypes = {
  canPreviousPage: PropTypes.bool.isRequired,
  canNextPage: PropTypes.bool.isRequired,
  goToFirstPage: PropTypes.func.isRequired,
  goToPrevPage: PropTypes.func.isRequired,
  goToNextPage: PropTypes.func.isRequired,
  goToLastPage: PropTypes.func.isRequired,
  setPageSize: PropTypes.func.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalRows: PropTypes.number.isRequired,
  pageIndex: PropTypes.number.isRequired
};
const FilterDefault = _ref => {
  let {
    column: {
      id: columnId,
      filterValue,
      setFilter
    }
  } = _ref;
  return /*#__PURE__*/React.createElement(InputField, {
    name: `table-filter-${columnId}`,
    value: filterValue,
    size: "medium",
    placeholder: "All",
    onChange: value => setFilter(value || undefined)
  });
};
FilterDefault.propTypes = {
  column: PropTypes.objectOf(PropTypes.any).isRequired
};
const boolean = 'boolean';
const filterBoolean = (rows, id, filterValue) => rows.filter(row => {
  if (!filterValue) {
    return true;
  }
  if (filterValue === 'true' && row.values[id]) {
    return true;
  }
  if (filterValue === 'false' && !row.values[id]) {
    return true;
  }
  return false;
});
var filterFunctions = {
  [boolean]: filterBoolean
};

/** @jsx jsx */
const css$Q = {
  checkbox: theme => ({
    marginLeft: theme.layout.baseline / 8
  })
};
const CellRowSelect = _ref => {
  let {
    row: {
      getToggleRowSelectedProps,
      ...row
    }
  } = _ref;
  const {
    checked,
    onChange
  } = getToggleRowSelectedProps();
  return jsx(Checkbox, {
    name: `row-select-${row.id}`,
    checked: checked,
    onChangeEvent: onChange,
    containerStyles: css$Q.checkbox
  });
};
CellRowSelect.propTypes = {
  row: PropTypes.objectOf(PropTypes.any).isRequired
};

/** @jsx jsx */
const css$R = {
  checkbox: theme => ({
    marginLeft: theme.layout.baseline / 8
  })
};
const HeaderCellSelectAll = _ref => {
  let {
    getToggleAllRowsSelectedProps
  } = _ref;
  const {
    checked,
    indeterminate,
    onChange
  } = getToggleAllRowsSelectedProps();
  return jsx(Checkbox, {
    name: "select-all",
    checked: checked,
    indeterminate: indeterminate,
    onChangeEvent: onChange,
    containerStyles: css$R.checkbox
  });
};
HeaderCellSelectAll.propTypes = {
  getToggleAllRowsSelectedProps: PropTypes.func.isRequired
};
const rowHeight = 40;
const headerHeight = 32;
const css$S = {
  tableContainer: _ref => {
    let {
      pageSize,
      applyMinHeight
    } = _ref;
    return theme => {
      const padding = theme.layout.baseline / 4;
      const minHeight = pageSize * rowHeight + headerHeight + padding * 2;
      return {
        padding,
        margin: -theme.layout.baseline / 4,
        width: `calc(100% + ${theme.layout.baseline / 2}px)`,
        overflowX: 'auto',
        ...(applyMinHeight && {
          minHeight
        })
      };
    };
  },
  table: _ref2 => {
    let {
      numRows
    } = _ref2;
    return {
      borderSpacing: 0,
      width: '100%',
      height: rowHeight * numRows
    };
  },
  pagination: theme => ({
    marginTop: theme.layout.baseline
  })
};
const addSelectableColumn = originalColumns => [{
  id: 'selection',
  groupByBoundary: true,
  Header: HeaderCellSelectAll,
  Cell: CellRowSelect
}, ...originalColumns];
const Table = _ref3 => {
  let {
    columns: originalColumns,
    data: originalData,
    hiddenColumns,
    onCreate,
    onEdit,
    onDelete,
    onRowClick,
    setSelected,
    refreshData,
    title,
    isResponsive,
    stripedRows,
    focusable,
    filterable,
    paginated,
    selectable,
    sortable,
    selectedAction,
    selectedActionLabel,
    setPage,
    setRowsPerPage,
    totalCount,
    pageNumber,
    itemsPerPage,
    setQueryParameters,
    serverPagination
  } = _ref3;
  const {
    isMobile
  } = useContext(DeviceContext);
  const responsiveOnMobile = isResponsive && isMobile;
  const columns = useMemo(() => originalColumns(isMobile), [originalColumns, isMobile]);
  const data = useMemo(() => originalData, [originalData]);
  const filterTypes = useMemo(() => filterFunctions, []);
  const defaultColumn = useMemo(() => ({
    Filter: FilterDefault
  }), []);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    columns: allColumns,
    rows,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: {
      pageSize,
      pageIndex,
      selectedRowIds,
      filters
    }
  } = useTable({
    columns,
    data,
    defaultColumn,
    filterTypes,
    autoResetFilters: false,
    initialState: {
      hiddenColumns,
      pageIndex: pageNumber,
      pageSize: itemsPerPage
    },
    manualPagination: true,
    pageCount: totalCount
  }, filterable && useFilters, sortable && useSortBy, paginated && usePagination, selectable && useRowSelect, hooks => selectable && hooks.visibleColumns.push(addSelectableColumn));
  serverPagination && useEffect(() => {
    const appliedFilters = {};
    filters.map(data => {
      if (data.id === 'state.id') appliedFilters.states = data.value;else appliedFilters[data.id] = data.value;
    });
    setQueryParameters(appliedFilters);
  }, [filters]);
  useEffect(() => {
    if (selectable && setSelected) {
      const selectedKeys = Object.keys(selectedRowIds);
      const selectedRows = rows.filter(row => selectedKeys.includes(row.id)).map(_ref4 => {
        let {
          original
        } = _ref4;
        return original;
      });
      setSelected(selectedRows);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectable, selectedRowIds, setSelected]);
  const applyMinHeight = paginated && pageCount > 1;
  const nextPageHandler = () => {
    nextPage();
    setPage(pageIndex + 1);
  };
  const prevPageHandler = () => {
    previousPage();
    setPage(pageIndex - 1);
  };
  const goToFirstPageHandler = () => {
    setPage(0);
  };
  const goToLastPageHandler = () => {
    setPage(Math.floor(totalCount / pageSize));
  };
  const pageSizeHandler = pageSize => {
    setRowsPerPage(pageSize);
    setPageSize(pageSize);
  };
  const canPreviousPageHandler = pageIndex !== 0;
  const canNextPageHandler = pageIndex < Math.floor(totalCount / pageSize);
  return jsx("div", null, jsx(TableHeader, {
    title: title,
    isResponsive: isResponsive,
    filterable: filterable,
    refreshData: refreshData,
    columns: allColumns,
    selectedAction: selectedAction,
    selectedActionLabel: selectedActionLabel,
    hasSelected: selectedRowIds && Object.keys(selectedRowIds).length > 0,
    onCreate: onCreate
  }), jsx("div", {
    css: css$S.tableContainer({
      pageSize,
      applyMinHeight
    })
  }, jsx("table", _extends({
    css: css$S.table
  }, getTableProps()), jsx(TableHead, {
    title: title,
    headerGroups: headerGroups,
    responsiveOnMobile: responsiveOnMobile,
    paginated: paginated,
    sortable: sortable
  }), jsx(TableBody, {
    rows: paginated ? page : rows,
    onEdit: onEdit,
    onDelete: onDelete,
    onRowClick: onRowClick,
    stripedRows: stripedRows,
    focusable: focusable,
    selectable: selectable,
    responsiveOnMobile: responsiveOnMobile,
    getTableBodyProps: getTableBodyProps,
    prepareRow: prepareRow,
    rowHeight: rowHeight
  }))), jsx(Spacer, null), paginated && jsx(Pagination, {
    canPreviousPage: serverPagination ? canPreviousPageHandler : canPreviousPage,
    canNextPage: serverPagination ? canNextPageHandler : canNextPage,
    goToNextPage: serverPagination ? nextPageHandler : nextPage,
    goToPrevPage: serverPagination ? prevPageHandler : previousPage,
    goToFirstPage: serverPagination ? goToFirstPageHandler : () => gotoPage(0),
    goToLastPage: serverPagination ? goToLastPageHandler : () => gotoPage(pageCount - 1),
    pageSize: pageSize,
    setPageSize: serverPagination ? pageSizeHandler : setPageSize,
    totalRows: serverPagination ? totalCount : rows.length,
    pageIndex: pageIndex
  }));
};
Table.propTypes = {
  columns: PropTypes.func.isRequired,
  hiddenColumns: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  onCreate: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onRowClick: PropTypes.func,
  setSelected: PropTypes.func,
  refreshData: PropTypes.func,
  title: PropTypes.string,
  isResponsive: PropTypes.bool,
  stripedRows: PropTypes.bool,
  focusable: PropTypes.bool,
  filterable: PropTypes.bool,
  paginated: PropTypes.bool,
  selectable: PropTypes.bool,
  sortable: PropTypes.bool,
  selectedAction: PropTypes.func,
  selectedActionLabel: PropTypes.string,
  setPage: PropTypes.func,
  setRowsPerPage: PropTypes.func,
  totalCount: PropTypes.number,
  pageNumber: PropTypes.number,
  itemsPerPage: PropTypes.number,
  setQueryParameters: PropTypes.func,
  serverPagination: PropTypes.bool
};
Table.defaultProps = {
  onCreate: null,
  onEdit: null,
  onDelete: null,
  onRowClick: null,
  refreshData: null,
  setSelected: null,
  title: null,
  isResponsive: false,
  stripedRows: false,
  focusable: true,
  filterable: false,
  paginated: false,
  selectable: false,
  sortable: false,
  hiddenColumns: [],
  selectedAction: null,
  selectedActionLabel: '',
  setPage: null,
  setRowsPerPage: null,
  totalCount: null,
  pageNumber: null,
  itemsPerPage: null,
  setQueryParameters: null,
  serverPagination: false
};
const EventTitle = _ref => {
  let {
    cell: {
      value,
      row: {
        original: {
          bookingId
        }
      }
    }
  } = _ref;
  let name;
  let link;
  switch (value) {
    case 'SpaceBooking':
      name = 'Booking';
      link = `/bookings/${bookingId}`;
      break;
    case 'RecurringBooking':
      name = 'Recurring Booking';
      link = `/recurring-bookings/${bookingId}`;
      break;
    case 'SchoolBooking':
      name = 'School Booking';
      break;
    case 'Viewing':
      name = 'Viewing';
      break;
    case 'Cleaning':
      name = 'Cleaning';
      break;
    default:
      name = 'Booking';
      break;
  }
  if (link) {
    return /*#__PURE__*/React.createElement(Link, {
      highlighted: true,
      opensInNewTab: true,
      url: link
    }, name);
  }
  return name;
};
EventTitle.propTypes = {
  cell: PropTypes.objectOf(PropTypes.any).isRequired
};
const columns = () => [{
  Header: 'Clashing event',
  accessor: 'type',
  Cell: EventTitle
}, {
  Header: 'Time',
  accessor: 'startTime',
  Cell: _ref2 => {
    let {
      cell: {
        row: {
          original: {
            startTime,
            endTime
          }
        }
      }
    } = _ref2;
    return `${startTime} - ${endTime}`;
  }
}];
const ClashesTable = _ref3 => {
  let {
    clashes
  } = _ref3;
  return /*#__PURE__*/React.createElement(Table, {
    columns: columns,
    data: clashes
  });
};
ClashesTable.propTypes = {
  clashes: PropTypes.arrayOf(PropTypes.object).isRequired
};

/** @jsx jsx */
const css$T = {
  container: theme => ({
    marginBottom: theme.layout.baseline / 4,
    minHeight: theme.font.scale.small,
    fontSize: theme.font.scale.small,
    [theme.helpers.mq('s')]: {
      minHeight: theme.layout.baseline * 1.5,
      fontSize: theme.font.scale.default
    }
  }),
  message: theme => ({
    margin: 0,
    color: theme.colors.error
  }),
  errorTitle: theme => ({
    margin: 0,
    marginBottom: theme.layout.baseline * 0.75
  }),
  errorDetails: theme => ({
    marginBottom: theme.layout.baseline * 0.75,
    padding: theme.layout.baseline,
    backgroundColor: theme.colors.errorBackground
  })
};
const getErrorDetails = error => {
  if (error instanceof ApiAvailabilityError) {
    return jsx(ClashesTable, {
      clashes: error.data
    });
  }
  if (error instanceof ApiValidationError) {
    return jsx("ul", null, error.data.map(_ref => {
      let {
        field,
        errors
      } = _ref;
      return errors.map(fieldError => jsx("li", null, `${capitalise(convertCamelCaseToSentenceCase(field))} ${fieldError}`));
    }));
  }
  return null;
};
const ModalError = _ref2 => {
  let {
    error
  } = _ref2;
  return jsx("div", {
    css: css$T.container
  }, error instanceof Error ? jsx("div", {
    css: css$T.errorDetails
  }, jsx(Heading, {
    level: "3",
    size: "default",
    styles: css$T.errorTitle
  }, error.message), getErrorDetails(error)) : jsx("p", {
    css: css$T.message
  }, error));
};
ModalError.propTypes = {
  error: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.any), PropTypes.string])
};
ModalError.defaultProps = {
  error: null
};

/** @jsx jsx */
const RecurringAmendmentSummary = _ref => {
  let {
    customerId,
    recurringBookingId,
    newSpace
  } = _ref;
  const [fetching, setFetching] = useState(false);
  const [bookings, setBookings] = useState([]);
  const bankHolidays = useBankHolidays();
  const holidays = bankHolidays.map(holiday => holiday.date);
  useEffect(() => {
    setFetching(true);
    getCustomerBookings(customerId, {
      recurringBookingId,
      fromDate: getTodaysDate(),
      states: ['confirmed', 'amending', 'pending']
    }).then(data => {
      if (data.length > 0) {
        setBookings(data);
      } else {
        setBookings(null);
      }
      setFetching(false);
    }).catch(() => {
      setBookings(null);
      setFetching(false);
    });
  }, [customerId, recurringBookingId]);
  if (fetching) {
    return jsx(Loading, null);
  }
  const [amendableDates, unamendableDates] = splitBookingsByAmendable(bookings, holidays);
  const getUnamendableHeading = dates => {
    const heading = newSpace ? `${newSpace} will not be added to` : 'Changes will not be applied to';
    return `${heading} ${getDatesString(dates)}`;
  };
  const getAmendableHeading = dates => {
    const heading = newSpace ? `${newSpace} will be added to` : 'Changes will be applied to';
    return `${heading} ${getDatesString(dates)}`;
  };
  return jsx("div", {
    css: css$C.container
  }, !!unamendableDates.length && jsx(UnchangeableDates, {
    heading: getUnamendableHeading(unamendableDates),
    dates: unamendableDates,
    getUnchangeableReason: booking => getUnamendableReason(booking, holidays)
  }), !!amendableDates.length && jsx(ChangeableDates, {
    heading: getAmendableHeading(amendableDates),
    dates: amendableDates,
    initialDatesToShow: 4
  }));
};
RecurringAmendmentSummary.propTypes = {
  customerId: PropTypes.string.isRequired,
  recurringBookingId: PropTypes.string.isRequired,
  newSpace: PropTypes.string
};
RecurringAmendmentSummary.defaultProps = {
  newSpace: null
};
const css$U = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  discountRow: {
    display: 'flex'
  },
  discount: theme => ({
    marginRight: theme.layout.baseline
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const validate$1 = (_ref, _ref2) => {
  let {
    spaceId,
    startTime,
    endTime
  } = _ref;
  let {
    space: {
      minimumBookingDuration
    }
  } = _ref2;
  if (!spaceId) {
    return 'Please select a space for your booking.';
  }
  if (!startTime) {
    return 'Please select a start time for your booking.';
  }
  if (!endTime) {
    return 'Please select an end time for your booking.';
  }
  if (calculateDurationInMinutes(startTime, endTime) < minimumBookingDuration) {
    return `Bookings in this space must be at least ${minimumBookingDuration} minutes.`;
  }
  return null;
};
const pruneAndFormatData = (data, originalSpaceBooking) => {
  const formattedData = {
    spaceId: data.spaceId,
    startTime: formatToIso(data.startTime),
    endTime: formatToIso(data.endTime)
  };
  if (isEmpty(originalSpaceBooking)) return formattedData;
  if (originalSpaceBooking.startTime === data.startTime && originalSpaceBooking.endTime === data.endTime) {
    delete formattedData.startTime;
    delete formattedData.endTime;
  }
  if (originalSpaceBooking.space.id === data.spaceId) delete formattedData.spaceId;
  return formattedData;
};
const RecurringSpaceBookingModal = _ref3 => {
  let {
    pageIndex,
    isFirstPage,
    isLastPage,
    nextPage,
    previousPage,
    closeModal,
    school,
    site,
    day,
    recurrenceString,
    startDate,
    endDate,
    recurringBookingId,
    originalRecurringSpaceBooking,
    customerId,
    onUpdate
  } = _ref3;
  const [space, setSpace] = useState(originalRecurringSpaceBooking.space || {});
  const [startTime, setStartTime] = useState(originalRecurringSpaceBooking.startTime);
  const [endTime, setEndTime] = useState(originalRecurringSpaceBooking.endTime);
  const [spaceUnavailable, setSpaceUnavailable] = useState(false);
  const [error, setError] = useState(null);
  const pickSpace = useCallback(newSpace => {
    setError(null);
    setSpace(newSpace);
  }, []);
  const setTimes = useCallback(times => {
    setError(null);
    setStartTime(times.startTime);
    setEndTime(times.endTime);
  }, []);
  const getSlotsForPicker = useCallback(() => getRecurringSlots({
    day,
    recurrenceString,
    fromDate: startDate,
    toDate: endDate,
    recurringBookingId,
    recurringSpaceBookingId: originalRecurringSpaceBooking.id,
    spaceId: space.id
  }), [day, recurrenceString, startDate, endDate, recurringBookingId, originalRecurringSpaceBooking.id, space.id]);
  const data = {
    spaceId: space.id,
    startTime,
    endTime
  };
  const submit = () => {
    if (spaceUnavailable) {
      previousPage();
      return setError('Please select a space that is available on this day.');
    }
    const formattedData = pruneAndFormatData(data, originalRecurringSpaceBooking);
    if (isEmpty(formattedData)) {
      return closeModal();
    }
    if (!isEmpty(originalRecurringSpaceBooking)) {
      return updateCustomerRecurringSpaceBooking(customerId, recurringBookingId, originalRecurringSpaceBooking.id, formattedData).then(onUpdate).then(closeModal).catch(setError);
    }
    return postCustomerRecurringSpaceBooking(customerId, recurringBookingId, formattedData).then(onUpdate).then(closeModal).catch(setError);
  };
  const navigateBack = () => {
    setError(null);
    return isFirstPage ? closeModal() : previousPage();
  };
  const nextAction = () => {
    const validationError = validate$1(data, {
      space
    });
    if (validationError) {
      return setError(validationError);
    }
    return isLastPage ? submit() : nextPage();
  };
  return jsx("div", {
    css: css$U.container
  }, jsx("div", {
    css: css$U.container
  }, pageIndex === 0 && jsx(SpaceBooker, {
    schoolId: school.id,
    siteId: site.id,
    space: space,
    setSpace: pickSpace,
    times: {
      startTime,
      endTime
    },
    setTimes: setTimes,
    spaceUnavailable: spaceUnavailable,
    setSpaceUnavailable: setSpaceUnavailable,
    getSlots: getSlotsForPicker
  }), pageIndex === 1 && jsx("div", {
    css: css$U.container
  }, jsx(RecurringAmendmentSummary, _extends({
    customerId: customerId,
    recurringBookingId: recurringBookingId
  }, !originalRecurringSpaceBooking.space && {
    newSpace: space.name
  })))), jsx(ModalError, {
    error: error
  }), jsx("div", {
    css: css$U.buttonContainer
  }, jsx(Button, {
    styles: css$U.actionButton,
    state: "ghost",
    onClick: navigateBack,
    actionWillUnmountComponent: isFirstPage
  }, isFirstPage ? 'Cancel' : 'Back'), jsx(Button, {
    styles: css$U.actionButton,
    onClick: nextAction
  }, isLastPage ? 'Confirm' : 'Next step')));
};
RecurringSpaceBookingModal.propTypes = {
  pageIndex: PropTypes.number.isRequired,
  isFirstPage: PropTypes.bool.isRequired,
  isLastPage: PropTypes.bool.isRequired,
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  day: PropTypes.string.isRequired,
  recurrenceString: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  school: PropTypes.objectOf(PropTypes.any).isRequired,
  site: PropTypes.objectOf(PropTypes.any),
  recurringBookingId: PropTypes.string.isRequired,
  customerId: PropTypes.string.isRequired,
  originalRecurringSpaceBooking: PropTypes.objectOf(PropTypes.any),
  onUpdate: PropTypes.func.isRequired
};
RecurringSpaceBookingModal.defaultProps = {
  site: {},
  originalRecurringSpaceBooking: {}
};
var RecurringSpaceBookingModal$1 = MultiPageModal(RecurringSpaceBookingModal, {
  height: '90vh',
  maxHeight: '700px',
  maxWidth: '550px'
});

/** @jsx jsx */
const css$V = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  fieldRow: theme => ({
    ...theme.styles.fieldRow
  }),
  error: theme => ({
    color: theme.colors.error,
    marginTop: theme.layout.baseline / 2,
    marginBottom: theme.layout.baseline / 2,
    fontSize: theme.font.scale.small,
    minHeight: theme.font.scale.small,
    [theme.helpers.mq('s')]: {
      fontSize: theme.font.scale.default,
      minHeight: theme.font.scale.default
    }
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const BookingFeesModal = _ref => {
  let {
    closeModal,
    bookingId,
    originalBookingFee,
    onUpdate
  } = _ref;
  const [fees, setFees] = useState([]);
  const [feeId, setFeeId] = useState(originalBookingFee.feeId || {});
  const [amount, setAmount] = useState(originalBookingFee.amount || '');
  const [error, setError] = useState(null);
  useEffect(() => {
    getFees().then(setFees).catch(() => setError('Error fetching fees, please refresh and try again'));
  }, []);
  const pickFee = newFee => {
    setError(null);
    setFeeId(newFee.id);
    setAmount(newFee.amount);
  };
  const pickAmount = newAmount => {
    setError(null);
    setAmount(newAmount);
  };
  const submit = () => {
    setError(null);
    const data = {
      bookingId,
      feeId,
      amount: Number(amount)
    };
    if (originalBookingFee.id) {
      return updateBookingFee(bookingId, originalBookingFee.id, {
        id: originalBookingFee.id,
        ...data
      }).then(onUpdate).then(closeModal).catch(setError);
    }
    return postBookingFee(bookingId, data).then(onUpdate).then(closeModal).catch(setError);
  };
  const title = originalBookingFee.id ? 'Edit booking fee' : 'Add new booking fee';
  const submitText = originalBookingFee.id ? 'Update booking fee' : 'Add booking fee';
  return jsx(Modal, {
    title: title,
    isOpen: true,
    closeModal: closeModal,
    ariaLabel: title
  }, jsx("div", {
    css: css$V.container
  }, jsx("div", {
    css: css$V.fieldRow
  }, jsx(Select, {
    name: "fees",
    label: "Fee",
    placeholder: "Select fee",
    value: fees.find(_ref2 => {
      let {
        id
      } = _ref2;
      return id === feeId;
    }),
    onChange: pickFee,
    options: fees
  }), jsx(Label, {
    htmlFor: "amount",
    text: "Amount"
  }, jsx(NumberField, {
    name: "amount",
    value: amount,
    onChange: pickAmount,
    step: "0.01",
    min: "0"
  }))), jsx(ModalError, {
    error: error
  }), jsx("div", {
    css: css$V.buttonContainer
  }, jsx(Button, {
    styles: css$V.actionButton,
    state: "ghost",
    onClick: closeModal,
    actionWillUnmountComponent: true
  }, "Cancel"), jsx(Button, {
    styles: css$V.actionButton,
    onClick: submit
  }, submitText))));
};
BookingFeesModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  bookingId: PropTypes.string.isRequired,
  originalBookingFee: PropTypes.objectOf(PropTypes.any),
  onUpdate: PropTypes.func.isRequired
};
BookingFeesModal.defaultProps = {
  originalBookingFee: {}
};

/** @jsx jsx */
const css$W = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  fieldRow: theme => ({
    ...theme.styles.fieldRow
  }),
  error: theme => ({
    color: theme.colors.error,
    marginTop: theme.layout.baseline / 2,
    marginBottom: theme.layout.baseline / 2,
    fontSize: theme.font.scale.small,
    minHeight: theme.font.scale.small,
    [theme.helpers.mq('s')]: {
      fontSize: theme.font.scale.default,
      minHeight: theme.font.scale.default
    }
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const BankHolidaysModal = _ref => {
  let {
    closeModal,
    originalBankHoliday,
    onUpdate
  } = _ref;
  const [name, setName] = useState(originalBankHoliday.name || '');
  const [date, setDate] = useState(originalBankHoliday.date || getTodaysDate());
  const [operational, setOperational] = useState(typeof originalBankHoliday.operational !== 'undefined' ? originalBankHoliday.operational : true);
  const [daytimePremiumMultiplier, setDaytimePremiumMultiplier] = useState(originalBankHoliday.daytimePremiumMultiplier || '');
  const [eveningPremiumMultiplier, setEveningPremiumMultiplier] = useState(originalBankHoliday.eveningPremiumMultiplier || '');
  const toggleOperational = newOperational => {
    if (newOperational) {
      setDaytimePremiumMultiplier(originalBankHoliday.daytimePremiumMultiplier || '');
      setEveningPremiumMultiplier(originalBankHoliday.eveningPremiumMultiplier || '');
    } else {
      setDaytimePremiumMultiplier('');
      setEveningPremiumMultiplier('');
    }
    setOperational(newOperational);
  };
  const [error, setError] = useState(null);
  const submit = () => {
    setError(null);
    const data = {
      name,
      date: dateFromDatetime(date),
      operational,
      daytimePremiumMultiplier: daytimePremiumMultiplier ? Number(daytimePremiumMultiplier) : null,
      eveningPremiumMultiplier: eveningPremiumMultiplier ? Number(eveningPremiumMultiplier) : null
    };
    if (originalBankHoliday.id) {
      return updateBankHoliday(originalBankHoliday.id, {
        id: originalBankHoliday.id,
        ...data
      }).then(onUpdate).then(closeModal).catch(setError);
    }
    return postBankHoliday(data).then(onUpdate).then(closeModal).catch(setError);
  };
  const title = originalBankHoliday.id ? 'Edit bank holiday' : 'Add new bank holiday';
  const submitText = originalBankHoliday.id ? 'Update bank holiday' : 'Add bank holiday';
  return jsx(Modal, {
    title: title,
    isOpen: true,
    closeModal: closeModal,
    ariaLabel: title
  }, jsx("div", {
    css: css$W.container
  }, jsx("div", {
    css: css$W.fieldRow
  }, jsx(Label, {
    htmlFor: "name",
    text: "Name"
  }, jsx(InputField, {
    name: "name",
    value: name,
    onChange: setName
  })), jsx(DatePicker, {
    label: "Date",
    name: "date",
    value: date,
    onChange: setDate
  })), jsx("div", {
    css: css$W.fieldRow
  }, jsx(Checkbox, {
    label: "Operational",
    inlineLabel: false,
    name: "operational",
    checked: operational,
    onChange: toggleOperational
  }), jsx(Label, {
    htmlFor: "daytimePremiumMultiplier",
    text: "Daytime Multiplier"
  }, jsx(NumberField, {
    name: "daytimePremiumMultiplier",
    value: daytimePremiumMultiplier,
    onChange: setDaytimePremiumMultiplier,
    step: "0.1",
    min: "0",
    disabled: !operational
  })), jsx(Label, {
    htmlFor: "eveningPremiumMultiplier",
    text: "Evening Multiplier"
  }, jsx(NumberField, {
    name: "eveningPremiumMultiplier",
    value: eveningPremiumMultiplier,
    onChange: setEveningPremiumMultiplier,
    step: "0.1",
    min: "0",
    disabled: !operational
  }))), jsx(ModalError, {
    error: error
  }), jsx("div", {
    css: css$W.buttonContainer
  }, jsx(Button, {
    styles: css$W.actionButton,
    state: "ghost",
    onClick: closeModal,
    actionWillUnmountComponent: true
  }, "Cancel"), jsx(Button, {
    styles: css$W.actionButton,
    onClick: submit
  }, submitText))));
};
BankHolidaysModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  originalBankHoliday: PropTypes.objectOf(PropTypes.any),
  onUpdate: PropTypes.func.isRequired
};
BankHolidaysModal.defaultProps = {
  originalBankHoliday: {}
};

/** @jsx jsx */
const css$X = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  intro: theme => ({
    marginBottom: theme.layout.baseline
  }),
  contactSelectRow: theme => ({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: theme.layout.baseline
  }),
  selectLabel: theme => ({
    marginTop: 0,
    marginBottom: theme.layout.baseline / 2
  }),
  createButton: theme => ({
    flexShrink: 0,
    marginLeft: theme.layout.baseline
  }),
  fieldRow: () => ({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  }),
  property: theme => ({
    marginBottom: theme.layout.baseline,
    width: '100%',
    [theme.helpers.mq('m')]: {
      width: '50%'
    }
  }),
  address: theme => ({
    marginBottom: theme.layout.baseline
  }),
  error: theme => ({
    color: theme.colors.error,
    marginTop: theme.layout.baseline / 2,
    marginBottom: theme.layout.baseline / 2,
    fontSize: theme.font.scale.small,
    minHeight: theme.font.scale.small,
    [theme.helpers.mq('s')]: {
      fontSize: theme.font.scale.default,
      minHeight: theme.font.scale.default
    }
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 'auto'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const InvoiceContactModal = _ref => {
  let {
    closeModal,
    customerId,
    originalInvoiceContact,
    onUpdate
  } = _ref;
  const [invoiceContact, setInvoiceContact] = useState(originalInvoiceContact);
  const [error, setError] = useState(null);
  const pickInvoiceContact = newContact => {
    setError(null);
    setInvoiceContact(newContact);
  };
  const generateContact = () => {
    setError(null);
    return postInvoiceContact({
      customerId
    }).then(setInvoiceContact).catch(() => setError('Error generating Xero contact, check for an existing contact with the same name or create a new contact manually in Xero.'));
  };
  const submit = () => {
    if (!invoiceContact) {
      return setError('Please select or generate a Xero contact');
    }
    setError(null);
    const data = {
      invoiceContactId: invoiceContact.id
    };
    return updateCustomer(customerId, data).then(onUpdate).then(closeModal).catch(setError);
  };
  const titleText = originalInvoiceContact ? 'Update invoice contact' : 'Set invoice contact';
  const introText = originalInvoiceContact ? 'Updating the invoice contact will cause future Xero invoices to be generated for the new contact' : 'Setting the invoice contact will enable future Xero invoices to be generated automatically for this customer';
  const submitText = originalInvoiceContact ? 'Update invoice contact' : 'Set invoice contact';
  return jsx(Modal, {
    title: titleText,
    isOpen: true,
    closeModal: closeModal,
    ariaLabel: titleText
  }, jsx("div", {
    css: css$X.container
  }, jsx("p", {
    css: css$X.intro
  }, introText, ". This change will not automatically amend existing invoices or bookings."), jsx(Heading, {
    styles: css$X.selectLabel,
    level: "3"
  }, "Select a contact"), jsx("div", {
    css: css$X.contactSelectRow
  }, jsx(InvoiceContactPicker, {
    invoiceContact: invoiceContact,
    setInvoiceContact: pickInvoiceContact,
    maxMenuHeight: 120,
    styles: theme => ({
      container: {
        marginBottom: 0,
        width: '100%',
        marginRight: theme.layout.baseline,
        [theme.helpers.mq('m')]: {
          width: '60%'
        }
      }
    })
  }), jsx("span", null, "or"), jsx(Button, {
    styles: css$X.createButton,
    state: "text",
    size: "small",
    onClick: generateContact
  }, "Generate a new contact")), jsx("div", {
    css: css$X.fieldRow
  }, jsx(Property, {
    styles: css$X.property,
    title: "Name"
  }, invoiceContact ? jsx(Link, {
    url: invoiceContact.url,
    isExternal: true,
    opensInNewTab: true
  }, invoiceContact.name) : null), jsx(Property, {
    styles: css$X.property,
    title: "Email"
  }, invoiceContact ? invoiceContact.email : null)), jsx("div", {
    css: css$X.fieldRow
  }, jsx(Property, {
    styles: css$X.address,
    title: "Address"
  }, invoiceContact ? invoiceContact.address : null)), jsx(ModalError, {
    error: error
  }), jsx("div", {
    css: css$X.buttonContainer
  }, jsx(Button, {
    styles: css$X.actionButton,
    state: "ghost",
    onClick: closeModal,
    actionWillUnmountComponent: true
  }, "Cancel"), jsx(Button, {
    styles: css$X.actionButton,
    onClick: submit
  }, submitText))));
};
InvoiceContactModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  customerId: PropTypes.string.isRequired,
  originalInvoiceContact: PropTypes.objectOf(PropTypes.any),
  onUpdate: PropTypes.func.isRequired
};
InvoiceContactModal.defaultProps = {
  originalInvoiceContact: {}
};

/** @jsx jsx */
const css$Y = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  discountRow: {
    display: 'flex'
  },
  discount: theme => ({
    marginRight: theme.layout.baseline
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const validate$2 = (_ref, _ref2) => {
  let {
    spaceId,
    startTime,
    endTime
  } = _ref;
  let {
    space: {
      minimumBookingDuration
    }
  } = _ref2;
  if (!spaceId) {
    return 'Please select a space for your booking.';
  }
  if (!startTime) {
    return 'Please select a start time for your booking.';
  }
  if (!endTime) {
    return 'Please select an end time for your booking.';
  }
  if (calculateDurationInMinutes(startTime, endTime) < minimumBookingDuration) {
    return `Bookings in this space must be at least ${minimumBookingDuration} minutes.`;
  }
  return null;
};
const sanitise = (data, originalSpaceBooking) => {
  const formattedData = {
    spaceId: data.spaceId,
    startTime: formatToIso(data.startTime),
    endTime: formatToIso(data.endTime),
    discount: Number(data.discount)
  };
  if (isEmpty(originalSpaceBooking)) return formattedData;
  if (originalSpaceBooking.startTime === data.startTime && originalSpaceBooking.endTime === data.endTime) {
    delete formattedData.startTime;
    delete formattedData.endTime;
  }
  if (originalSpaceBooking.discount === data.discount) delete formattedData.discount;
  if (originalSpaceBooking.space.id === data.spaceId) delete formattedData.spaceId;
  return formattedData;
};
const AdminSpaceBookingModal = _ref3 => {
  let {
    pageIndex,
    isFirstPage,
    isLastPage,
    nextPage,
    previousPage,
    closeModal,
    customer: {
      discount: customerDiscount
    },
    booking: {
      id: bookingId,
      discount: bookingDiscount
    },
    originalSpaceBooking,
    date,
    school,
    site,
    onUpdate
  } = _ref3;
  const [space, setSpace] = useState(originalSpaceBooking.space || {});
  const [startTime, setStartTime] = useState(originalSpaceBooking.startTime);
  const [endTime, setEndTime] = useState(originalSpaceBooking.endTime);
  const [spaceUnavailable, setSpaceUnavailable] = useState(false);
  const [discount, setDiscount] = useState(originalSpaceBooking.discount || '0');
  const [error, setError] = useState(null);
  const pickSpace = useCallback(newSpace => {
    setError(null);
    setSpace(newSpace);
  }, []);
  const setTimes = useCallback(times => {
    setError(null);
    setStartTime(times.startTime);
    setEndTime(times.endTime);
  }, []);
  const getSlotsForPicker = useCallback(() => getSlots({
    eventType: 'SpaceBooking',
    eventId: originalSpaceBooking.id,
    date,
    spaceId: space.id,
    bookingId
  }), [originalSpaceBooking.id, date, space.id, bookingId]);
  const data = {
    spaceId: space.id,
    startTime,
    endTime,
    discount
  };
  const submit = () => {
    if (spaceUnavailable) {
      previousPage();
      return setError('Please select a space that is available on this day.');
    }
    const sanitisedData = sanitise(data, originalSpaceBooking);
    if (isEmpty(sanitisedData)) {
      return closeModal();
    }
    if (!isEmpty(originalSpaceBooking)) {
      return updateSpaceBooking(bookingId, originalSpaceBooking.id, sanitisedData).then(onUpdate).then(closeModal).catch(setError);
    }
    return postSpaceBooking(bookingId, sanitisedData).then(onUpdate).then(closeModal).catch(setError);
  };
  const navigateBack = () => {
    setError(null);
    return isFirstPage ? closeModal() : previousPage();
  };
  const nextAction = () => {
    const validationError = validate$2(data, {
      space
    });
    if (validationError) {
      return setError(validationError);
    }
    return isLastPage ? submit() : nextPage();
  };
  return jsx("div", {
    css: css$Y.container
  }, jsx("div", {
    css: css$Y.container
  }, pageIndex === 0 && jsx(SpaceBooker, {
    date: date,
    schoolId: school.id,
    siteId: site.id,
    space: space,
    setSpace: pickSpace,
    times: {
      startTime,
      endTime
    },
    setTimes: setTimes,
    spaceUnavailable: spaceUnavailable,
    setSpaceUnavailable: setSpaceUnavailable,
    getSlots: getSlotsForPicker,
    isAdmin: true
  }), pageIndex === 1 && jsx("div", {
    css: css$Y.container
  }, jsx("div", {
    css: css$Y.discountRow
  }, jsx("div", {
    css: css$Y.discount
  }, jsx(DiscountField, {
    value: discount,
    onChange: setDiscount
  })), jsx(Placeholder, {
    title: "Hourly rate"
  }, "\xA3", getDiscountedHourlyRate({
    hourlyRate: space.hourlyRate,
    spaceDiscount: discount,
    bookingDiscount,
    customerDiscount
  }))))), jsx(ModalError, {
    error: error
  }), jsx("div", {
    css: css$Y.buttonContainer
  }, jsx(Button, {
    styles: css$Y.actionButton,
    state: "ghost",
    onClick: navigateBack,
    actionWillUnmountComponent: isFirstPage
  }, isFirstPage ? 'Cancel' : 'Back'), jsx(Button, {
    styles: css$Y.actionButton,
    onClick: nextAction
  }, isLastPage ? 'Confirm' : 'Next step')));
};
AdminSpaceBookingModal.propTypes = {
  pageIndex: PropTypes.number.isRequired,
  isFirstPage: PropTypes.bool.isRequired,
  isLastPage: PropTypes.bool.isRequired,
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  school: PropTypes.objectOf(PropTypes.any).isRequired,
  site: PropTypes.objectOf(PropTypes.any),
  date: PropTypes.string.isRequired,
  booking: PropTypes.objectOf(PropTypes.any).isRequired,
  customer: PropTypes.objectOf(PropTypes.any).isRequired,
  originalSpaceBooking: PropTypes.objectOf(PropTypes.any),
  onUpdate: PropTypes.func.isRequired
};
AdminSpaceBookingModal.defaultProps = {
  site: {},
  originalSpaceBooking: {}
};
var AdminSpaceBookingModal$1 = MultiPageModal(AdminSpaceBookingModal, {
  height: '90vh',
  maxHeight: '700px',
  maxWidth: '550px'
});

/** @jsx jsx */
const css$Z = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  spaceBooker: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  error: theme => ({
    color: theme.colors.error,
    marginTop: theme.layout.baseline / 2,
    marginBottom: theme.layout.baseline / 2,
    fontSize: theme.font.scale.small,
    minHeight: theme.font.scale.small,
    [theme.helpers.mq('s')]: {
      fontSize: theme.font.scale.default,
      minHeight: theme.font.scale.default
    }
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const SchoolBookingModal = _ref => {
  let {
    closeModal,
    originalSchoolBooking,
    schoolId,
    siteId,
    onUpdate
  } = _ref;
  const [date, setDate] = useState(originalSchoolBooking.date);
  const [space, setSpace] = useState(originalSchoolBooking.space || {});
  const [startTime, setStartTime] = useState(originalSchoolBooking.startTime);
  const [endTime, setEndTime] = useState(originalSchoolBooking.endTime);
  const [spaceUnavailable, setSpaceUnavailable] = useState(false);
  const [error, setError] = useState(null);
  const pickSpace = useCallback(newSpace => {
    setError(null);
    setSpace(newSpace);
  }, []);
  const setTimes = useCallback(times => {
    setError(null);
    setStartTime(times.startTime);
    setEndTime(times.endTime);
  }, []);
  const getSlotsForPicker = useCallback(() => getSlots({
    eventType: 'SchoolBooking',
    eventId: originalSchoolBooking.id,
    date,
    spaceId: space.id
  }), [originalSchoolBooking, date, space.id]);
  const submit = () => {
    setError(null);
    const data = {
      spaceId: space.id,
      date,
      startTime: formatToIso(startTime),
      endTime: formatToIso(endTime)
    };
    if (originalSchoolBooking.id) {
      return updateSchoolBooking(originalSchoolBooking.id, {
        id: originalSchoolBooking.id,
        ...data
      }).then(onUpdate).then(closeModal).catch(setError);
    }
    return postSchoolBooking(data).then(onUpdate).then(closeModal).catch(setError);
  };
  const title = originalSchoolBooking.id ? 'Edit school booking' : 'Add new school booking';
  const submitText = originalSchoolBooking.id ? 'Update school booking' : 'Add school booking';
  return jsx(Modal, {
    title: title,
    isOpen: true,
    closeModal: closeModal,
    ariaLabel: title,
    height: "90vh",
    maxHeight: "700px",
    maxWidth: "550px"
  }, jsx("div", {
    css: css$Z.container
  }, jsx("div", {
    css: css$Z.spaceBooker
  }, jsx(SpaceBooker, {
    date: date,
    schoolId: schoolId,
    siteId: siteId,
    space: space,
    setSpace: pickSpace,
    times: {
      startTime,
      endTime
    },
    setTimes: setTimes,
    setDate: setDate,
    spaceUnavailable: spaceUnavailable,
    setSpaceUnavailable: setSpaceUnavailable,
    getSlots: getSlotsForPicker,
    isAdmin: true
  })), jsx(ModalError, {
    error: error
  }), jsx("div", {
    css: css$Z.buttonContainer
  }, jsx(Button, {
    styles: css$Z.actionButton,
    state: "ghost",
    onClick: closeModal,
    actionWillUnmountComponent: true
  }, "Cancel"), jsx(Button, {
    styles: css$Z.actionButton,
    onClick: submit
  }, submitText))));
};
SchoolBookingModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  originalSchoolBooking: PropTypes.objectOf(PropTypes.any),
  schoolId: PropTypes.string.isRequired,
  siteId: PropTypes.string,
  onUpdate: PropTypes.func.isRequired
};
SchoolBookingModal.defaultProps = {
  originalSchoolBooking: {},
  siteId: null
};
const css$_ = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  spaceBooker: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  error: theme => ({
    color: theme.colors.error,
    marginTop: theme.layout.baseline / 2,
    marginBottom: theme.layout.baseline / 2,
    fontSize: theme.font.scale.small,
    minHeight: theme.font.scale.small,
    [theme.helpers.mq('s')]: {
      fontSize: theme.font.scale.default,
      minHeight: theme.font.scale.default
    }
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const SchoolBookingBulkModal = _ref => {
  let {
    closeModal,
    schoolId: originalSchoolId,
    siteId: originalSiteId,
    onUpdate
  } = _ref;
  const [schoolId, setSchoolId] = useState(originalSchoolId || '');
  const [siteId, setSiteId] = useState(originalSiteId || '');
  const [dates, setDates] = useState([]);
  const [spaces, setSpaces] = useState([]);
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [error, setError] = useState(null);
  const pickSchoolSite = useCallback(newSchoolSite => {
    setError(null);
    setSchoolId(newSchoolSite.schoolId);
    setSiteId(newSchoolSite.siteId);
    setSpaces([]);
  }, []);
  const pickSpaces = useCallback(newSpaces => {
    setError(null);
    setSpaces(newSpaces);
  }, []);
  const setTimes = useCallback(times => {
    setError(null);
    setStartTime(times.startTime);
    setEndTime(times.endTime);
  }, []);
  const submit = () => {
    setError(null);
    if (spaces.length === 0) {
      return setError('Please select at least one space');
    }
    if (dates.length === 0) {
      return setError('Please select at least one date');
    }
    if (!startTime) {
      return setError('Please select a start time');
    }
    if (!endTime) {
      return setError('Please select an end time');
    }
    const data = dates.map(date => spaces.map(_ref2 => {
      let {
        id: spaceId
      } = _ref2;
      return {
        spaceId,
        date: dateFromDatetime(date),
        startTime: formatToIso(startTime),
        endTime: formatToIso(endTime)
      };
    })).flat();
    return postSchoolBookings(data).then(onUpdate).then(closeModal).catch(setError);
  };
  return jsx(Modal, {
    title: "Bulk add school bookings",
    isOpen: true,
    closeModal: closeModal,
    ariaLabel: "Bulk add school bookings",
    height: "auto",
    maxHeight: "90vh",
    maxWidth: "550px"
  }, jsx("div", {
    css: css$_.container
  }, jsx("div", {
    css: css$_.spaceBooker
  }, jsx(SchoolSitePicker, {
    schoolId: schoolId,
    siteId: siteId,
    setSchoolSite: pickSchoolSite,
    fullWidth: true
  }), jsx(MultiSpacePicker, _extends({
    schoolId: schoolId
  }, siteId && {
    siteId
  }, {
    spaces: spaces,
    setSpaces: pickSpaces,
    name: "spaces",
    label: "Spaces",
    placeholder: "Select spaces",
    isSearchable: true,
    fullWidth: true
  })), jsx(CustomStartEndTimesPicker, {
    times: {
      startTime,
      endTime
    },
    setTimes: setTimes
  }), jsx(Label, {
    text: "Dates"
  }, jsx(Calendar, {
    dates: dates,
    setDates: setDates,
    multiSelect: true
  }))), jsx(ModalError, {
    error: error
  }), jsx("div", {
    css: css$_.buttonContainer
  }, jsx(Button, {
    styles: css$_.actionButton,
    state: "ghost",
    onClick: closeModal,
    actionWillUnmountComponent: true
  }, "Cancel"), jsx(Button, {
    styles: css$_.actionButton,
    onClick: submit
  }, "Create bookings"))));
};
SchoolBookingBulkModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  schoolId: PropTypes.string.isRequired,
  siteId: PropTypes.string,
  onUpdate: PropTypes.func.isRequired
};
SchoolBookingBulkModal.defaultProps = {
  siteId: null
};

/** @jsx jsx */
const css$$ = {
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  error: theme => ({
    color: theme.colors.error,
    marginTop: theme.layout.baseline / 2,
    marginBottom: theme.layout.baseline / 2,
    fontSize: theme.font.scale.small,
    minHeight: theme.font.scale.small,
    [theme.helpers.mq('s')]: {
      fontSize: theme.font.scale.default,
      minHeight: theme.font.scale.default
    }
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const FaqModal = _ref => {
  let {
    isNew,
    id,
    question,
    answer,
    isSchool,
    closeModal,
    setRefetchData
  } = _ref;
  const [questionState, setQuestionState] = useState(question);
  const [answerState, setAnswerState] = useState(answer);
  const [view, setView] = useState(isSchool);
  const updateSubmit = async () => {
    try {
      await updateFaq(id, {
        question: questionState,
        answer: answerState,
        isSchool: view
      });
      closeModal();
      setRefetchData(prevState => !prevState);
    } catch (error) {
      console.log('updateSubmit -> error', error);
    }
  };
  const createSubmit = async () => {
    try {
      await postFaq({
        question: questionState,
        answer: answerState,
        isSchool: view
      });
      closeModal();
      setRefetchData(prevState => !prevState);
    } catch (error) {
      console.log('updateSubmit -> error', error);
    }
  };
  const title = isNew ? 'Create new FAQ' : 'Update Faq';
  const submitText = isNew ? 'Create' : 'Update';
  return jsx(Modal, {
    title: title,
    isOpen: true,
    closeModal: closeModal,
    ariaLabel: title,
    height: "90vh",
    maxHeight: "700px",
    maxWidth: "550px"
  }, jsx("div", {
    css: css$$.container
  }, jsx(InputField, {
    type: "text",
    name: "question",
    value: questionState,
    placeholder: "Question",
    onChange: state => {
      setQuestionState(state);
    },
    required: true
  }), jsx(MceEditor, {
    data: answerState,
    setFieldValue: state => {
      setAnswerState(state);
    },
    initForTable: {
      plugins: ['link'],
      menubar: false,
      toolbar: 'link'
    },
    directStateUpdation: true
  }), jsx(Checkbox, {
    name: "view",
    label: "For Schools",
    checked: view,
    onChange: value => setView(value),
    required: true
  }), jsx("div", {
    css: css$$.buttonContainer
  }, jsx(Button, {
    styles: css$$.actionButton,
    state: "ghost",
    onClick: closeModal,
    actionWillUnmountComponent: true
  }, "Cancel"), jsx(Button, {
    styles: css$$.actionButton,
    onClick: isNew ? createSubmit : updateSubmit
  }, submitText))));
};
FaqModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  setRefetchData: PropTypes.func.isRequired,
  isNew: PropTypes.bool,
  id: PropTypes.number,
  question: PropTypes.string,
  answer: PropTypes.string,
  isSchool: PropTypes.bool
};
FaqModal.defaultProps = {
  isNew: false,
  id: null,
  question: '',
  answer: '',
  isSchool: false
};

/** @jsx jsx */
const css$10 = {
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  error: theme => ({
    color: theme.colors.error,
    marginTop: theme.layout.baseline / 2,
    marginBottom: theme.layout.baseline / 2,
    fontSize: theme.font.scale.small,
    minHeight: theme.font.scale.small,
    [theme.helpers.mq('s')]: {
      fontSize: theme.font.scale.default,
      minHeight: theme.font.scale.default
    }
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  uploaderContainer: {
    marginBottom: 20,
    display: 'flex'
  },
  logoName: {
    marginLeft: '1rem'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const PartnerModal = _ref => {
  let {
    closeModal,
    refetchSchool,
    ImageHelper
  } = _ref;
  const [name, setName] = useState('');
  const [logo, setLogo] = useState('');
  const hiddenFileInput = useRef(null);
  const submit = async () => {
    try {
      const {
        compressImage,
        uploadToS3
      } = ImageHelper;
      const uploadedLogo = await uploadToS3(await compressImage(logo[0], 0.8, 148, 93));
      await createPartner({
        name,
        logo: uploadedLogo.location
      });
      closeModal();
      refetchSchool();
    } catch (error) {
      console.log('Submit -> error', error);
    }
  };
  const handleClick = () => {
    hiddenFileInput.current.click();
  };
  const handleFileChange = event => {
    event.preventDefault();
    const imageFile = event.target.files;
    setLogo(imageFile);
  };
  const title = 'Create New Partner';
  const submitText = 'Create';
  return jsx(Modal, {
    title: title,
    isOpen: true,
    closeModal: closeModal,
    ariaLabel: title,
    height: "90vh",
    maxHeight: "700px",
    maxWidth: "550px"
  }, jsx("div", {
    css: css$10.container
  }, jsx(InputField, {
    type: "text",
    name: "name",
    value: name,
    placeholder: "Name",
    onChange: state => {
      setName(state);
    },
    required: true
  }), jsx("div", {
    css: css$10.uploaderContainer
  }, jsx(Button, {
    size: "small",
    state: "secondary",
    onClick: handleClick
  }, "Choose File"), jsx("input", {
    type: "file",
    accept: "image/png, image/jpg, image/jpeg",
    ref: hiddenFileInput,
    onChange: handleFileChange,
    style: {
      display: 'none'
    },
    required: true
  }), jsx("p", null, logo && logo[0].name)), jsx("div", {
    css: css$10.buttonContainer
  }, jsx(Button, {
    styles: css$10.actionButton,
    state: "ghost",
    onClick: closeModal,
    actionWillUnmountComponent: true
  }, "Cancel"), jsx(Button, {
    styles: css$10.actionButton,
    onClick: submit
  }, submitText))));
};
PartnerModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  refetchSchool: PropTypes.func.isRequired,
  ImageHelper: PropTypes.objectOf(PropTypes.string).isRequired
};
PartnerModal.defaultProps = {};

/** @jsx jsx */
const css$11 = {
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  error: theme => ({
    color: theme.colors.error,
    marginTop: theme.layout.baseline / 2,
    marginBottom: theme.layout.baseline / 2,
    fontSize: theme.font.scale.small,
    minHeight: theme.font.scale.small,
    [theme.helpers.mq('s')]: {
      fontSize: theme.font.scale.default,
      minHeight: theme.font.scale.default
    }
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const PasswordDeletionModal = _ref => {
  let {
    title,
    confirmText,
    confirmButtonState,
    cancelText,
    password,
    closeModal,
    onConfirmDeletion
  } = _ref;
  const [deletionPassword, setDeletionPassword] = useState('');
  const [error, setError] = useState();
  const handleSubmit = async () => {
    try {
      if (deletionPassword === password) {
        onConfirmDeletion();
        closeModal();
      } else {
        setError(true);
      }
    } catch (err) {
      console.log('updateSubmit -> error', err);
    }
  };
  return jsx(Modal, {
    title: title,
    isOpen: true,
    closeModal: closeModal,
    ariaLabel: title,
    height: "40vh"
  }, jsx("div", {
    css: css$11.container
  }, jsx(InputField, {
    type: "password",
    name: "Deletion Password",
    value: deletionPassword,
    placeholder: "Password",
    onChange: state => {
      setDeletionPassword(state);
      setError(false);
    },
    required: true
  }), error && jsx("p", null, "Invalid Password"), jsx("div", {
    css: css$11.buttonContainer
  }, jsx(Button, {
    styles: css$11.actionButton,
    state: "ghost",
    onClick: closeModal,
    actionWillUnmountComponent: true
  }, cancelText), jsx(Button, {
    state: confirmButtonState,
    styles: css$11.actionButton,
    onClick: handleSubmit
  }, confirmText))));
};
PasswordDeletionModal.propTypes = {
  title: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  confirmButtonState: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  onConfirmDeletion: PropTypes.func.isRequired
};

/** @jsx jsx */
const css$12 = {
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  error: theme => ({
    color: theme.colors.error,
    marginTop: theme.layout.baseline / 2,
    marginBottom: theme.layout.baseline / 2,
    fontSize: theme.font.scale.small,
    minHeight: theme.font.scale.small,
    [theme.helpers.mq('s')]: {
      fontSize: theme.font.scale.default,
      minHeight: theme.font.scale.default
    }
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const SpaceRateModal = _ref => {
  let {
    spaceId,
    closeModal,
    setRefetchData
  } = _ref;
  const [rate, setRate] = useState();
  const [startDate, setStartDate] = useState();
  const [error, setError] = useState();
  const [deletionPassword, setDeletionPassword] = useState('');
  const [passwordError, setPasswordError] = useState();
  const handleSubmit = async () => {
    try {
      if (deletionPassword === `${process.env.DOCKERHUB_PASSWORD}`) {
        await postSpaceRates({
          spaceId,
          rate: +rate,
          startDate
        });
        closeModal();
        setRefetchData(prevState => !prevState);
      } else {
        setPasswordError(true);
      }
    } catch (err) {
      setError(true);
    }
  };
  const title = 'Create new rate';
  const submitText = 'Submit';
  return jsx(Modal, {
    title: title,
    isOpen: true,
    closeModal: closeModal,
    ariaLabel: title
  }, jsx("div", {
    css: css$12.container
  }, jsx(InputField, {
    type: "number",
    name: "rate",
    value: rate,
    placeholder: "Rate",
    onChange: state => {
      setRate(state);
      setError(false);
    },
    required: true
  }), jsx(InputField, {
    type: "date",
    name: "startDate",
    value: startDate,
    onChange: state => {
      setStartDate(state);
      setError(false);
    },
    required: true
  }), jsx(InputField, {
    type: "password",
    name: "Update Password",
    value: deletionPassword,
    placeholder: "Password",
    onChange: state => {
      setDeletionPassword(state);
      setPasswordError(false);
    },
    required: true
  }), error && jsx("p", null, "Rate must be a number and please select future date"), passwordError && jsx("p", null, "Invalid Password"), jsx("div", {
    css: css$12.buttonContainer
  }, jsx(Button, {
    styles: css$12.actionButton,
    state: "ghost",
    onClick: closeModal,
    actionWillUnmountComponent: true
  }, "Cancel"), jsx(Button, {
    styles: css$12.actionButton,
    onClick: handleSubmit
  }, submitText))));
};
SpaceRateModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  setRefetchData: PropTypes.func.isRequired,
  spaceId: PropTypes.string.isRequired
};
const css$13 = {
  container: theme => ({
    ...theme.styles.flexColumnGrow
  }),
  discountRow: {
    display: 'flex'
  },
  discount: theme => ({
    marginRight: theme.layout.baseline
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const validate$3 = (_ref, _ref2) => {
  let {
    spaceId,
    startTime,
    endTime
  } = _ref;
  let {
    space: {
      minimumBookingDuration
    }
  } = _ref2;
  if (!spaceId) {
    return 'Please select a space for your booking.';
  }
  if (!startTime) {
    return 'Please select a start time for your booking.';
  }
  if (!endTime) {
    return 'Please select an end time for your booking.';
  }
  if (calculateDurationInMinutes(startTime, endTime) < minimumBookingDuration) {
    return `Bookings in this space must be at least ${minimumBookingDuration} minutes.`;
  }
  return null;
};
const pruneAndFormatData$1 = (data, originalSpaceBooking) => {
  const formattedData = {
    spaceId: data.spaceId,
    startTime: formatToIso(data.startTime),
    endTime: formatToIso(data.endTime)
  };
  if (isEmpty(originalSpaceBooking)) return formattedData;
  if (originalSpaceBooking.startTime === data.startTime && originalSpaceBooking.endTime === data.endTime) {
    delete formattedData.startTime;
    delete formattedData.endTime;
  }
  if (originalSpaceBooking.space.id === data.spaceId) delete formattedData.spaceId;
  return formattedData;
};
const AdminRecurringSpaceBookingModal = _ref3 => {
  let {
    pageIndex,
    isFirstPage,
    isLastPage,
    nextPage,
    previousPage,
    closeModal,
    school,
    site,
    day,
    recurrenceString,
    startDate,
    endDate,
    recurringBookingId,
    originalRecurringSpaceBooking,
    customerId,
    onUpdate
  } = _ref3;
  const [space, setSpace] = useState(originalRecurringSpaceBooking.space || {});
  const [startTime, setStartTime] = useState(originalRecurringSpaceBooking.startTime);
  const [endTime, setEndTime] = useState(originalRecurringSpaceBooking.endTime);
  const [spaceUnavailable, setSpaceUnavailable] = useState(false);
  const [error, setError] = useState(null);
  const pickSpace = useCallback(newSpace => {
    setError(null);
    setSpace(newSpace);
  }, []);
  const setTimes = useCallback(times => {
    setError(null);
    setStartTime(times.startTime);
    setEndTime(times.endTime);
  }, []);
  const getSlotsForPicker = useCallback(() => getRecurringSlots({
    day,
    recurrenceString,
    fromDate: startDate,
    toDate: endDate,
    recurringBookingId,
    recurringSpaceBookingId: originalRecurringSpaceBooking.id,
    spaceId: space.id
  }), [day, recurrenceString, startDate, endDate, recurringBookingId, originalRecurringSpaceBooking.id, space.id]);
  const data = {
    spaceId: space.id,
    startTime,
    endTime
  };
  const submit = () => {
    if (spaceUnavailable) {
      previousPage();
      return setError('Please select a space that is available on this day.');
    }
    const formattedData = pruneAndFormatData$1(data, originalRecurringSpaceBooking);
    if (isEmpty(formattedData)) {
      return closeModal();
    }
    if (!isEmpty(originalRecurringSpaceBooking)) {
      return updateCustomerRecurringSpaceBooking(customerId, recurringBookingId, originalRecurringSpaceBooking.id, formattedData).then(onUpdate).then(closeModal).catch(setError);
    }
    return postCustomerRecurringSpaceBooking(customerId, recurringBookingId, formattedData).then(onUpdate).then(closeModal).catch(setError);
  };
  const navigateBack = () => {
    setError(null);
    return isFirstPage ? closeModal() : previousPage();
  };
  const nextAction = () => {
    const validationError = validate$3(data, {
      space
    });
    if (validationError) {
      return setError(validationError);
    }
    return isLastPage ? submit() : nextPage();
  };
  return jsx("div", {
    css: css$13.container
  }, jsx("div", {
    css: css$13.container
  }, pageIndex === 0 && jsx(SpaceBooker, {
    schoolId: school.id,
    siteId: site.id,
    space: space,
    setSpace: pickSpace,
    times: {
      startTime,
      endTime
    },
    setTimes: setTimes,
    spaceUnavailable: spaceUnavailable,
    setSpaceUnavailable: setSpaceUnavailable,
    getSlots: getSlotsForPicker,
    isAdmin: true,
    isRepeatBooking: true
  }), pageIndex === 1 && jsx("div", {
    css: css$13.container
  }, jsx(RecurringAmendmentSummary, _extends({
    customerId: customerId,
    recurringBookingId: recurringBookingId
  }, !originalRecurringSpaceBooking.space && {
    newSpace: space.name
  })))), jsx(ModalError, {
    error: error
  }), jsx("div", {
    css: css$13.buttonContainer
  }, jsx(Button, {
    styles: css$13.actionButton,
    state: "ghost",
    onClick: navigateBack,
    actionWillUnmountComponent: isFirstPage
  }, isFirstPage ? 'Cancel' : 'Back'), jsx(Button, {
    styles: css$13.actionButton,
    onClick: nextAction
  }, isLastPage ? 'Confirm' : 'Next step')));
};
AdminRecurringSpaceBookingModal.propTypes = {
  pageIndex: PropTypes.number.isRequired,
  isFirstPage: PropTypes.bool.isRequired,
  isLastPage: PropTypes.bool.isRequired,
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  day: PropTypes.string.isRequired,
  recurrenceString: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  school: PropTypes.objectOf(PropTypes.any).isRequired,
  site: PropTypes.objectOf(PropTypes.any),
  recurringBookingId: PropTypes.string.isRequired,
  customerId: PropTypes.string.isRequired,
  originalRecurringSpaceBooking: PropTypes.objectOf(PropTypes.any),
  onUpdate: PropTypes.func.isRequired
};
AdminRecurringSpaceBookingModal.defaultProps = {
  site: {},
  originalRecurringSpaceBooking: {}
};
var AdminRecurringSpaceBookingModal$1 = MultiPageModal(AdminRecurringSpaceBookingModal, {
  height: '90vh',
  maxHeight: '700px',
  maxWidth: '550px'
});

/** @jsx jsx */
const css$14 = {
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  error: theme => ({
    color: theme.colors.error,
    marginTop: theme.layout.baseline / 2,
    marginBottom: theme.layout.baseline / 2,
    fontSize: theme.font.scale.small,
    minHeight: theme.font.scale.small,
    [theme.helpers.mq('s')]: {
      fontSize: theme.font.scale.default,
      minHeight: theme.font.scale.default
    }
  }),
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: theme => ({
    flexGrow: 1,
    maxWidth: 'initial',
    marginLeft: theme.layout.baseline,
    '&:first-of-type': {
      marginLeft: 0
    }
  })
};
const PasswordUpdateModal = _ref => {
  let {
    title,
    confirmText,
    confirmButtonState,
    cancelText,
    closeModal,
    onConfirmUpdate
  } = _ref;
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = async () => {
    try {
      if (!newPassword || !confirmPassword) {
        setError('Please fill out both new password fields.');
        return;
      }
      if (newPassword !== confirmPassword) {
        setError('New passwords do not match.');
        return;
      }
      onConfirmUpdate(newPassword);
      closeModal();
    } catch (err) {
      console.log('handleSubmit -> error', err);
    }
  };
  return jsx(Modal, {
    title: title,
    isOpen: true,
    closeModal: closeModal,
    ariaLabel: title,
    height: "50vh"
  }, jsx("div", {
    css: css$14.container
  }, jsx(InputField, {
    type: "password",
    name: "New Password",
    value: newPassword,
    placeholder: "New Password",
    onChange: state => {
      setNewPassword(state);
      setError('');
    },
    required: true
  }), jsx(InputField, {
    type: "password",
    name: "Confirm Password",
    value: confirmPassword,
    placeholder: "Confirm New Password",
    onChange: state => {
      setConfirmPassword(state);
      setError('');
    },
    required: true
  }), error && jsx("p", {
    css: css$14.error
  }, error), jsx("div", {
    css: css$14.buttonContainer
  }, jsx(Button, {
    styles: css$14.actionButton,
    state: "ghost",
    onClick: closeModal,
    actionWillUnmountComponent: true
  }, cancelText), jsx(Button, {
    state: confirmButtonState,
    styles: css$14.actionButton,
    onClick: handleSubmit
  }, confirmText))));
};
PasswordUpdateModal.propTypes = {
  title: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  confirmButtonState: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  onConfirmDeletion: PropTypes.func.isRequired
};
const types = {
  information: 'information',
  cancellation: 'cancellation',
  recurringCancellation: 'recurringCancellation',
  recurringStartEndDates: 'recurringStartEndDates',
  rebookingInformation: 'rebookingInformation',
  confirmation: 'confirmation',
  mobileMenu: 'mobileMenu',
  spaceBooking: 'spaceBooking',
  schoolBooking: 'schoolBooking',
  schoolBookingBulk: 'schoolBookingBulk',
  recurringSpaceBooking: 'recurringSpaceBooking',
  bookingFees: 'bookingFees',
  adminSpaceBooking: 'adminSpaceBooking',
  bankHolidays: 'bankHolidays',
  invoiceContact: 'invoiceContactModal',
  faq: 'faq',
  partner: 'partner',
  passwordDeletionModal: 'passwordDeletionModal',
  passwordUpdateModal: 'passwordUpdateModal',
  spaceRateModal: 'spaceRateModal',
  adminRecurringSpaceBooking: 'adminRecurringSpaceBooking'
};
const ModalProvider = _ref => {
  let {
    children
  } = _ref;
  useEffect(() => ReactModal.setAppElement('#root'), []);
  const [type, setType] = useState(null);
  const [props, setProps] = useState({});
  const openModal = modalOptions => {
    setType(modalOptions.type);
    setProps(modalOptions.props);
  };
  const closeModal = () => {
    // eslint-disable-next-line react/prop-types
    if (props.closeAction) props.closeAction();
    setType(null);
    setProps({});
  };
  let modal;
  switch (type) {
    case types.information:
      modal = /*#__PURE__*/React.createElement(ModalInformation, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.cancellation:
      modal = /*#__PURE__*/React.createElement(ModalCancellation, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.recurringCancellation:
      modal = /*#__PURE__*/React.createElement(RecurringCancellationModal$1, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.recurringStartEndDates:
      modal = /*#__PURE__*/React.createElement(RecurringStartEndDatesModal$1, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.rebookingInformation:
      modal = /*#__PURE__*/React.createElement(RebookingInformationModal$1, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.confirmation:
      modal = /*#__PURE__*/React.createElement(ModalConfirmation, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.mobileMenu:
      modal = /*#__PURE__*/React.createElement(MobileMenu, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.spaceBooking:
      modal = /*#__PURE__*/React.createElement(SpaceBookingModal, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.recurringSpaceBooking:
      modal = /*#__PURE__*/React.createElement(RecurringSpaceBookingModal$1, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.adminSpaceBooking:
      modal = /*#__PURE__*/React.createElement(AdminSpaceBookingModal$1, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.bookingFees:
      modal = /*#__PURE__*/React.createElement(BookingFeesModal, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.bankHolidays:
      modal = /*#__PURE__*/React.createElement(BankHolidaysModal, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.invoiceContact:
      modal = /*#__PURE__*/React.createElement(InvoiceContactModal, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.schoolBooking:
      modal = /*#__PURE__*/React.createElement(SchoolBookingModal, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.schoolBookingBulk:
      modal = /*#__PURE__*/React.createElement(SchoolBookingBulkModal, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.faq:
      modal = /*#__PURE__*/React.createElement(FaqModal, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.partner:
      modal = /*#__PURE__*/React.createElement(PartnerModal, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.passwordDeletionModal:
      modal = /*#__PURE__*/React.createElement(PasswordDeletionModal, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.passwordUpdateModal:
      modal = /*#__PURE__*/React.createElement(PasswordUpdateModal, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.spaceRateModal:
      modal = /*#__PURE__*/React.createElement(SpaceRateModal, _extends({
        closeModal: closeModal
      }, props));
      break;
    case types.adminRecurringSpaceBooking:
      modal = /*#__PURE__*/React.createElement(AdminRecurringSpaceBookingModal$1, _extends({
        closeModal: closeModal
      }, props));
      break;
    default:
      modal = null;
      break;
  }
  return /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: {
      openModal,
      closeModal,
      types
    }
  }, children, modal);
};
ModalProvider.propTypes = {
  children: PropTypes.node.isRequired
};
const {
  Modernizr
} = window;
const useDeviceType = () => {
  const [isMobile, setIsMobile] = useState(null);
  const detectDevice = () => {
    if (Modernizr && Modernizr.mq) {
      setIsMobile(!Modernizr.mq(`(min-width: ${theme.grid.breakpoints.s}px)`));
    }
  };
  useEffect(() => {
    detectDevice();
    const throttled = throttle(detectDevice, 200);
    window.addEventListener('resize', throttled);
    return () => {
      throttled.cancel();
      window.removeEventListener('resize', throttled);
    };
  }, []);
  return {
    isMobile
  };
};
const {
  Modernizr: Modernizr$1
} = window;
const useBrowserType = () => {
  const [supportsDatePicker] = useState(Modernizr$1.inputtypes.date || null);
  return {
    supportsDatePicker
  };
};
const DeviceProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    isMobile
  } = useDeviceType();
  const {
    supportsDatePicker
  } = useBrowserType();
  return /*#__PURE__*/React.createElement(DeviceContext.Provider, {
    value: {
      isMobile,
      supportsDatePicker
    }
  }, children);
};
DeviceProvider.propTypes = {
  children: PropTypes.node.isRequired
};
const Sidebar = _ref => {
  let {
    links,
    user
  } = _ref;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Contact, {
    name: user.name,
    email: user.email
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: 3
  }), /*#__PURE__*/React.createElement(LinkList, {
    vertical: true,
    withDivider: true,
    items: links,
    isNav: true
  }));
};
Sidebar.propTypes = {
  links: PropTypes.arrayOf(PropTypes.any).isRequired,
  user: PropTypes.objectOf(PropTypes.any).isRequired
};

/** @jsx jsx */
const css$15 = {
  details: {
    width: '40ch'
  },
  summary: theme => ({
    '&:hover': {
      cursor: 'pointer',
      color: theme.colors.secondary
    }
  }),
  content: {
    marginTop: 4
  }
};
const CellDetails = _ref => {
  let {
    cell: {
      value
    }
  } = _ref;
  if (!value || value.length === 0) {
    return null;
  }
  if (value.length < 80) {
    return jsx("span", null, value);
  }
  return jsx("details", {
    css: css$15.details
  }, jsx("summary", {
    css: css$15.summary
  }, "Show details"), jsx("div", {
    css: css$15.content
  }, value));
};
CellDetails.propTypes = {
  cell: PropTypes.objectOf(PropTypes.any).isRequired
};
const CellDate = _ref => {
  let {
    cell: {
      value
    }
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, formatToHoursMinutes(value));
};
CellDate.propTypes = {
  cell: PropTypes.objectOf(PropTypes.any).isRequired
};
const CellDate$1 = _ref => {
  let {
    cell: {
      value
    }
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, ukDateFromDatetime(value));
};
CellDate$1.propTypes = {
  cell: PropTypes.objectOf(PropTypes.any).isRequired
};
const columns$1 = () => [{
  Header: 'User',
  accessor: 'userId',
  Cell: _ref => {
    let {
      cell: {
        value,
        row: {
          original: {
            userRole
          }
        }
      }
    } = _ref;
    return userRole === 'customer' ? 'Customer' : value;
  }
}, {
  Header: 'Date',
  accessor: 'date',
  Cell: CellDate$1
}, {
  Header: 'Time',
  accessor: 'time',
  Cell: CellDate
}, {
  Header: 'Action',
  accessor: 'name'
}, {
  Header: 'Details',
  accessor: 'details',
  Cell: CellDetails
}];
const ActionsTable = _ref2 => {
  let {
    actions
  } = _ref2;
  return /*#__PURE__*/React.createElement(Table, {
    columns: columns$1,
    data: actions,
    stripedRows: true
  });
};
ActionsTable.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object).isRequired
};
const CellBoolean = _ref => {
  let {
    cell: {
      value
    }
  } = _ref;
  const theme = useTheme();
  return value ? /*#__PURE__*/React.createElement(Icon, {
    name: "tick",
    color: theme.colors.secondary,
    styles: {}
  }) : /*#__PURE__*/React.createElement(Icon, {
    name: "cross",
    color: theme.colors.errorLight,
    styles: {}
  });
};
CellBoolean.propTypes = {
  cell: PropTypes.objectOf(PropTypes.any).isRequired
};
const CellNullable = _ref => {
  let {
    cell: {
      value
    }
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, value || '-');
};
CellNullable.propTypes = {
  cell: PropTypes.objectOf(PropTypes.any).isRequired
};
const FilterSelect = _ref => {
  let {
    column: {
      filterValue,
      setFilter,
      id: columnId,
      preFilteredRows
    },
    options: predefinedOptions,
    size,
    sortValues,
    transformValue,
    isSearchable
  } = _ref;
  const options = useMemo(() => {
    if (predefinedOptions) {
      return predefinedOptions;
    }
    const set = new Set();
    preFilteredRows.map(row => set.add(row.values[columnId]));
    const values = [...set.values()];
    const sortedValues = sortValues ? values.sort(sortValues) : values.sort();
    return sortedValues.map(value => ({
      id: value,
      name: transformValue ? transformValue(value) : capitalise(value)
    }));
  }, [predefinedOptions, preFilteredRows, sortValues, columnId, transformValue]);
  const value = options.find(_ref2 => {
    let {
      id
    } = _ref2;
    return id === filterValue;
  });
  return /*#__PURE__*/React.createElement(Select, {
    name: `table-filter-${columnId}`,
    size: size,
    placeholder: "All",
    options: options,
    value: value,
    onChange: newValue => newValue ? setFilter(newValue.id) : setFilter(undefined),
    isSearchable: isSearchable,
    isClearable: true
  });
};
FilterSelect.propTypes = {
  column: PropTypes.objectOf(PropTypes.any).isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
  sortValues: PropTypes.func,
  transformValue: PropTypes.func,
  size: PropTypes.string,
  isSearchable: PropTypes.bool
};
FilterSelect.defaultProps = {
  options: null,
  sortValues: null,
  transformValue: null,
  size: 'medium',
  isSearchable: false
};
const options$1 = [{
  id: 'true',
  name: '✅'
}, {
  id: 'false',
  name: '❌'
}];
const FilterBoolean = _ref => {
  let {
    column
  } = _ref;
  return /*#__PURE__*/React.createElement(FilterSelect, {
    column: column,
    options: options$1,
    size: "small"
  });
};
FilterBoolean.propTypes = {
  column: PropTypes.objectOf(PropTypes.any).isRequired
};
const columns$2 = () => [{
  Header: 'Name',
  accessor: 'name'
}, {
  Header: 'Date',
  accessor: 'date',
  Cell: CellDate$1,
  disableFilters: true
}, {
  Header: 'Operational',
  accessor: 'operational',
  Cell: CellBoolean,
  Filter: FilterBoolean
}, {
  Header: 'Daytime Premium Multiplier',
  accessor: 'daytimePremiumMultiplier',
  disableFilters: true,
  Cell: CellNullable
}, {
  Header: 'Evening Premium Multiplier',
  accessor: 'eveningPremiumMultiplier',
  disableFilters: true,
  Cell: CellNullable
}, {
  Header: 'Year',
  accessor: 'year.name',
  Filter: FilterSelect
}];
const BankHolidaysTable = _ref => {
  let {
    bankHolidays,
    onEdit,
    onDelete
  } = _ref;
  return /*#__PURE__*/React.createElement(Table, {
    columns: columns$2,
    hiddenColumns: ['year.name'],
    data: bankHolidays,
    onEdit: onEdit,
    onDelete: onDelete,
    sortable: true,
    filterable: true
  });
};
BankHolidaysTable.propTypes = {
  bankHolidays: PropTypes.arrayOf(PropTypes.object).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};
const columns$3 = () => [{
  Header: 'Fee',
  accessor: 'name'
}, {
  Header: 'Amount',
  accessor: 'amount',
  Cell: _ref => {
    let {
      cell: {
        value
      }
    } = _ref;
    return `£${value}`;
  }
}];
const BookingFeesTable = _ref2 => {
  let {
    fees,
    updateFee,
    removeFee
  } = _ref2;
  return /*#__PURE__*/React.createElement(Table, {
    columns: columns$3,
    data: fees,
    onEdit: updateFee,
    onDelete: removeFee
  });
};
BookingFeesTable.propTypes = {
  fees: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateFee: PropTypes.func.isRequired,
  removeFee: PropTypes.func.isRequired
};
const CellStatus = _ref => {
  let {
    cell: {
      value
    }
  } = _ref;
  return /*#__PURE__*/React.createElement(AdminBookingStatus, {
    state: value,
    size: "small"
  });
};
CellStatus.propTypes = {
  cell: PropTypes.objectOf(PropTypes.any).isRequired
};
const FilterSchools = _ref => {
  let {
    column
  } = _ref;
  const schools = useSchools();
  return /*#__PURE__*/React.createElement(FilterSelect, {
    column: column,
    options: schools,
    isSearchable: true,
    isClearable: true
  });
};
FilterSchools.propTypes = {
  column: PropTypes.objectOf(PropTypes.any).isRequired
};
const FilterCustomers = _ref => {
  let {
    column
  } = _ref;
  const customers = useCustomers();
  return /*#__PURE__*/React.createElement(FilterSelect, {
    column: column,
    options: customers,
    isSearchable: true,
    isClearable: true
  });
};
FilterCustomers.propTypes = {
  column: PropTypes.objectOf(PropTypes.any).isRequired
};
const statusOptions = [{
  id: 'prospective',
  name: 'Prospective'
}, {
  id: 'pending',
  name: 'Pending'
}, {
  id: 'confirmed',
  name: 'Confirmed'
}, {
  id: 'amending',
  name: 'Amending'
}, {
  id: 'cancelled',
  name: 'Cancelled'
}];
const RecurringBookingStateFilter = _ref => {
  let {
    column
  } = _ref;
  return /*#__PURE__*/React.createElement(FilterSelect, {
    column: column,
    options: statusOptions,
    size: "small"
  });
};
RecurringBookingStateFilter.propTypes = {
  column: PropTypes.objectOf(PropTypes.any).isRequired
};
const columns$4 = _ref => {
  let {
    includeCustomer,
    includeOrganisation,
    includeRebook,
    includeReadyToRebook,
    includeInvitedToRebook
  } = _ref;
  return () => [...(includeCustomer ? [{
    Header: 'Customer',
    accessor: 'customerId',
    Cell: _ref2 => {
      let {
        row: {
          original: {
            customer: {
              name
            }
          }
        }
      } = _ref2;
      return name;
    },
    Filter: FilterCustomers
  }] : []), ...(includeOrganisation ? [{
    Header: 'Organisation',
    accessor: 'customerId',
    Cell: _ref3 => {
      let {
        row: {
          original: {
            customer: {
              organisation
            }
          }
        }
      } = _ref3;
      return organisation;
    },
    disableFilters: true
  }] : []), {
    Header: 'School',
    accessor: 'schoolId',
    Cell: _ref4 => {
      let {
        cell: {
          value
        }
      } = _ref4;
      return value.toUpperCase();
    },
    Filter: FilterSchools
  }, {
    Header: 'Repeats',
    accessor: 'recurrence',
    Filter: FilterSelect
  }, {
    Header: 'Start date',
    accessor: 'startDate',
    Cell: CellDate$1,
    disableFilters: true
  }, {
    Header: 'End date',
    accessor: 'endDate',
    Cell: CellDate$1,
    disableFilters: true
  }, ...(includeRebook ? [{
    Header: 'Rebook',
    accessor: 'rebook',
    Cell: CellBoolean,
    Filter: FilterBoolean,
    filter: boolean
  }] : []), ...(includeReadyToRebook ? [{
    Header: 'Ready to rebook',
    accessor: 'readyToRebook',
    Cell: CellBoolean,
    Filter: FilterBoolean,
    filter: boolean
  }] : []), ...(includeInvitedToRebook ? [{
    Header: 'Invited to rebook',
    accessor: 'invitedToRebook',
    Cell: CellBoolean,
    Filter: FilterBoolean,
    filter: boolean
  }] : []), {
    Header: 'Status',
    accessor: 'state.id',
    Cell: CellStatus,
    Filter: RecurringBookingStateFilter
  }];
};
const RecurringBookingsTable = _ref5 => {
  let {
    recurringBookings,
    includeRebook,
    includeReadyToRebook,
    includeInvitedToRebook,
    includeCustomer,
    includeOrganisation,
    refreshData,
    setSelectedBookings,
    setPage,
    setRowsPerPage,
    totalCount,
    pageNumber,
    itemsPerPage,
    setQueryParameters,
    serverPagination
  } = _ref5;
  return /*#__PURE__*/React.createElement(Table, {
    title: "Recurring Bookings",
    columns: columns$4({
      includeRebook,
      includeReadyToRebook,
      includeInvitedToRebook,
      includeCustomer,
      includeOrganisation
    }),
    data: recurringBookings,
    onRowClick: _ref6 => {
      let {
        id
      } = _ref6;
      return window.open(`/recurring-bookings/${id}`, '_blank');
    },
    refreshData: refreshData,
    filterable: true,
    paginated: true,
    sortable: true,
    selectable: !!setSelectedBookings,
    setSelected: setSelectedBookings,
    setPage: setPage,
    setRowsPerPage: setRowsPerPage,
    totalCount: totalCount,
    pageNumber: pageNumber,
    itemsPerPage: itemsPerPage,
    setQueryParameters: setQueryParameters,
    serverPagination: serverPagination
  });
};
RecurringBookingsTable.propTypes = {
  recurringBookings: PropTypes.arrayOf(PropTypes.object).isRequired,
  refreshData: PropTypes.func,
  setSelectedBookings: PropTypes.func,
  includeRebook: PropTypes.bool,
  includeReadyToRebook: PropTypes.bool,
  includeInvitedToRebook: PropTypes.bool,
  includeCustomer: PropTypes.bool,
  includeOrganisation: PropTypes.bool,
  setPage: PropTypes.func,
  setRowsPerPage: PropTypes.func,
  totalCount: PropTypes.number,
  pageNumber: PropTypes.number,
  itemsPerPage: PropTypes.number,
  setQueryParameters: PropTypes.func,
  serverPaginated: PropTypes.bool
};
RecurringBookingsTable.defaultProps = {
  refreshData: null,
  setSelectedBookings: null,
  includeCustomer: true,
  includeOrganisation: false,
  includeRebook: false,
  includeReadyToRebook: false,
  includeInvitedToRebook: false,
  setPage: null,
  setRowsPerPage: null,
  totalCount: null,
  pageNumber: null,
  itemsPerPage: null,
  setQueryParameters: null,
  serverPaginated: false
};

/** @jsx jsx */
const css$16 = {
  time: {
    whiteSpace: 'nowrap'
  }
};
const CellTimes = _ref => {
  let {
    cell: {
      row: {
        original: {
          startTime,
          endTime
        }
      }
    }
  } = _ref;
  return jsx("div", {
    css: css$16.time
  }, `${startTime} - ${endTime}`);
};
CellTimes.propTypes = {
  cell: PropTypes.objectOf(PropTypes.any).isRequired
};
const columns$5 = () => [{
  Header: 'Space',
  accessor: 'space.name'
}, {
  Header: 'Times',
  accessor: 'startTime',
  Cell: CellTimes
}, {
  Header: 'Your hourly rate',
  accessor: 'space',
  Cell: _ref => {
    let {
      cell: {
        row: {
          original: {
            totalDiscount,
            space: {
              hourlyRate
            }
          }
        }
      }
    } = _ref;
    return `£${getDiscountedHourlyRate({
      hourlyRate,
      spaceDiscount: totalDiscount
    })}`;
  },
  hideOnMobile: true
}];
const RecurringSpaceBookingsTable = _ref2 => {
  let {
    spaceBookings,
    updateSpace,
    cancelSpace
  } = _ref2;
  const spaceBookingsWithDisabled = spaceBookings.map(spaceBooking => ({
    ...spaceBooking,
    ...(spaceBooking.state.id === 'cancelled' && {
      disabled: true,
      editable: false
    })
  }));
  const uncancelledSpaces = spaceBookingsWithDisabled.filter(spaceBooking => spaceBooking.state.id !== 'cancelled');
  return /*#__PURE__*/React.createElement(Table, _extends({
    title: "Spaces",
    columns: columns$5,
    data: spaceBookingsWithDisabled,
    onEdit: updateSpace
  }, uncancelledSpaces.length > 1 && {
    onDelete: cancelSpace
  }, {
    isResponsive: true
  }));
};
RecurringSpaceBookingsTable.propTypes = {
  spaceBookings: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateSpace: PropTypes.func,
  cancelSpace: PropTypes.func
};
RecurringSpaceBookingsTable.defaultProps = {
  updateSpace: null,
  cancelSpace: null
};
const columns$6 = () => [{
  Header: 'Space',
  accessor: 'space.name'
}, {
  Header: 'Times',
  accessor: 'startTime',
  Cell: CellTimes
},
// {
//     Header: 'Discount',
//     accessor: 'discount',
//     Cell: ({ cell: { value } }) => {
//         const discount = decodeDiscount(value);
//         return parseFloat(value) ? `${discount}%` : '-';
//     }
// },
{
  Header: /*#__PURE__*/React.createElement("span", {
    title: "This is net amount, before any VAT or other fees"
  }, "Hourly Rate"),
  accessor: 'space',
  Cell: _ref => {
    let {
      cell: {
        row: {
          original: {
            totalDiscount,
            space: {
              hourlyRate
            },
            additionalMinimumSpent
          }
        }
      }
    } = _ref;
    return `£${getDiscountedHourlyRate({
      hourlyRate,
      additionalMinimumSpent,
      spaceDiscount: totalDiscount
    })}`;
  }
}];
const SpaceBookingsTable = _ref2 => {
  let {
    spaceBookings,
    updateSpace,
    cancelSpace,
    focusable,
    additionalMinimumSpent
  } = _ref2;
  const spaceBookingsWithDisabled = spaceBookings.map(spaceBooking => ({
    ...spaceBooking,
    additionalMinimumSpent,
    ...(spaceBooking.state.id === 'cancelled' && {
      disabled: true,
      editable: false,
      additionalMinimumSpent: 0
    })
  }));
  const uncancelledSpaces = spaceBookingsWithDisabled.filter(spaceBooking => spaceBooking.state.id !== 'cancelled');
  return /*#__PURE__*/React.createElement(Table, _extends({
    title: "Spaces",
    columns: columns$6,
    data: spaceBookingsWithDisabled,
    onEdit: updateSpace
  }, uncancelledSpaces.length > 1 && {
    onDelete: cancelSpace
  }, {
    isResponsive: true,
    focusable: focusable
  }));
};
SpaceBookingsTable.propTypes = {
  spaceBookings: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateSpace: PropTypes.func,
  cancelSpace: PropTypes.func,
  focusable: PropTypes.bool,
  additionalMinimumSpent: PropTypes.string.isRequired
};
SpaceBookingsTable.defaultProps = {
  updateSpace: null,
  cancelSpace: null,
  focusable: true
};
const columns$7 = () => [{
  Header: 'Space',
  accessor: 'space.name'
}, {
  Header: 'Times',
  accessor: 'startTime',
  Cell: CellTimes
}, {
  Header: 'Discount',
  accessor: 'discount',
  Cell: _ref => {
    let {
      cell: {
        value
      }
    } = _ref;
    const discount = decodeDiscount(value);
    return parseFloat(value) ? `${discount}%` : '-';
  }
}, {
  Header: 'Hourly Rate',
  accessor: 'space',
  Cell: _ref2 => {
    let {
      cell: {
        row: {
          original: {
            totalDiscount,
            space: {
              hourlyRate
            },
            additionalMinimumSpent
          }
        }
      }
    } = _ref2;
    return `£${getDiscountedHourlyRate({
      hourlyRate,
      additionalMinimumSpent,
      spaceDiscount: totalDiscount
    })}`;
  }
}, {
  accessor: 'state',
  Cell: _ref3 => {
    let {
      cell: {
        row: {
          original: {
            state: {
              id
            }
          }
        }
      }
    } = _ref3;
    return id === 'unreserved' && /*#__PURE__*/React.createElement(AdminBookingStatus, {
      state: id,
      size: "small"
    });
  }
}];
const AdminSpaceBookingsTable = _ref4 => {
  let {
    spaceBookings,
    updateSpace,
    cancelSpace,
    additionalMinimumSpent
  } = _ref4;
  const spaceBookingsWithDisabled = spaceBookings.map(spaceBooking => ({
    ...spaceBooking,
    additionalMinimumSpent,
    ...(spaceBooking.state.id === 'cancelled' && {
      disabled: true,
      editable: false,
      additionalMinimumSpent: 0
    })
  }));
  return /*#__PURE__*/React.createElement(Table, {
    columns: columns$7,
    data: spaceBookingsWithDisabled,
    onEdit: updateSpace,
    onDelete: cancelSpace
  });
};
AdminSpaceBookingsTable.propTypes = {
  spaceBookings: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateSpace: PropTypes.func.isRequired,
  cancelSpace: PropTypes.func.isRequired,
  additionalMinimumSpent: PropTypes.string.isRequired
};
const CellReservedStatus = _ref => {
  let {
    row: {
      original
    },
    cell: {
      value: isConfirmable
    }
  } = _ref;
  const {
    state: {
      id: stateId
    }
  } = original;
  let state;
  if (stateId === 'cancelled') {
    state = 'cancelled';
  } else {
    state = isConfirmable ? 'reserved' : 'unreserved';
  }
  return /*#__PURE__*/React.createElement(AdminBookingStatus, {
    state: state,
    size: "small"
  });
};
CellReservedStatus.propTypes = {
  row: PropTypes.objectOf(PropTypes.any).isRequired,
  cell: PropTypes.objectOf(PropTypes.any).isRequired,
  value: PropTypes.bool.isRequired
};
const columns$8 = () => [{
  Header: 'Date',
  accessor: 'date',
  Cell: CellDate$1,
  Filter: FilterSelect
}, {
  Header: 'State',
  accessor: 'state.id',
  Cell: CellStatus,
  Filter: FilterSelect
}, {
  Header: 'Spaces Reserved',
  accessor: 'isConfirmable',
  Cell: CellReservedStatus,
  disableFilters: true
}, {
  Header: 'Exception',
  accessor: 'isException',
  Cell: CellBoolean,
  Filter: FilterBoolean
}];
const RecurringBookingBookingsTable = _ref2 => {
  let {
    title,
    bookings,
    setSelectedBookings,
    selectedAction,
    selectedActionLabel,
    onRowClick
  } = _ref2;
  return /*#__PURE__*/React.createElement(Table, {
    title: title,
    columns: columns$8,
    data: bookings,
    onRowClick: onRowClick,
    filterable: true,
    sortable: true,
    paginated: true,
    selectable: !!setSelectedBookings,
    setSelected: setSelectedBookings,
    selectedAction: selectedAction,
    selectedActionLabel: selectedActionLabel
  });
};
RecurringBookingBookingsTable.propTypes = {
  bookings: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string,
  setSelectedBookings: PropTypes.func,
  selectedAction: PropTypes.func,
  selectedActionLabel: PropTypes.string,
  onRowClick: PropTypes.func
};
RecurringBookingBookingsTable.defaultProps = {
  title: '',
  setSelectedBookings: null,
  selectedAction: null,
  selectedActionLabel: '',
  onRowClick: null
};
const viewBookingsOnDate = (schoolId, date) => window.open(`/bookings?schoolId=${schoolId}&fromDate=${date}&toDate=${date}`, '_blank');
const CellConfirmedStatus = _ref => {
  let {
    row: {
      original
    },
    cell: {
      value
    }
  } = _ref;
  const {
    space: {
      schoolId
    },
    date
  } = original;
  const onClick = value ? () => viewBookingsOnDate(schoolId, date) : null;
  return /*#__PURE__*/React.createElement(AdminBookingStatus, {
    state: value ? 'confirmed' : 'unconfirmed',
    onClick: onClick,
    size: "small"
  });
};
CellConfirmedStatus.propTypes = {
  row: PropTypes.objectOf(PropTypes.any).isRequired,
  cell: PropTypes.objectOf(PropTypes.any).isRequired,
  value: PropTypes.bool.isRequired
};
const columns$9 = () => [{
  Header: 'Space',
  accessor: 'space.name',
  Filter: FilterSelect
}, {
  Header: 'Date',
  accessor: 'date',
  Cell: CellDate$1,
  disableFilters: true
}, {
  Header: 'Start Time',
  accessor: 'startTime',
  Cell: CellDate,
  disableFilters: true
}, {
  Header: 'End Time',
  accessor: 'endTime',
  Cell: CellDate,
  disableFilters: true
}, {
  Header: 'Confirmed',
  accessor: 'confirmed',
  Cell: CellConfirmedStatus,
  Filter: FilterBoolean
}, {
  Header: 'Created on',
  accessor: 'created',
  Cell: CellDate$1,
  disableFilters: true
}];
const SchoolBookingsTable = _ref2 => {
  let {
    bookings,
    createBooking,
    editBooking,
    deleteBooking
  } = _ref2;
  return /*#__PURE__*/React.createElement(Table, {
    columns: columns$9,
    data: bookings,
    onCreate: createBooking,
    onEdit: editBooking,
    onDelete: deleteBooking,
    filterable: true,
    sortable: true,
    paginated: true
  });
};
SchoolBookingsTable.propTypes = {
  bookings: PropTypes.arrayOf(PropTypes.object).isRequired,
  createBooking: PropTypes.func.isRequired,
  editBooking: PropTypes.func.isRequired,
  deleteBooking: PropTypes.func.isRequired
};
const columns$a = () => [{
  Header: 'Hourly Rate',
  accessor: 'rate',
  Cell: _ref => {
    let {
      cell: {
        row: {
          original: {
            rate
          }
        }
      }
    } = _ref;
    return `£${rate}`;
  }
}, {
  Header: 'Applies From',
  accessor: 'startDate',
  Cell: CellDate$1
}];
const SpaceRatesTable = _ref2 => {
  let {
    spaceRates
  } = _ref2;
  return /*#__PURE__*/React.createElement(Table, {
    title: "Pricing history",
    columns: columns$a,
    data: spaceRates
  });
};
SpaceRatesTable.propTypes = {
  spaceRates: PropTypes.arrayOf(PropTypes.object).isRequired
};
const columns$b = () => [{
  Header: 'Start Year',
  accessor: 'id'
}, {
  Header: 'Start Date',
  accessor: 'startDate',
  Cell: CellDate$1
}, {
  Header: 'End Date',
  accessor: 'endDate',
  Cell: CellDate$1
}, {
  Header: 'Publicly Bookable',
  accessor: 'publiclyBookable',
  Cell: CellBoolean
}];
const YearsTable = _ref => {
  let {
    years
  } = _ref;
  return /*#__PURE__*/React.createElement(Table, {
    columns: columns$b,
    data: years,
    onRowClick: _ref2 => {
      let {
        id
      } = _ref2;
      return window.open(`/years/${id}`, '_blank');
    }
  });
};
YearsTable.propTypes = {
  years: PropTypes.arrayOf(PropTypes.object).isRequired
};
class S3Services {
  constructor(s3Config) {
    const {
      bucketName,
      region,
      accessKeyId,
      secretAccessKey
    } = s3Config;
    this.config = {
      bucketName,
      region,
      accessKeyId,
      secretAccessKey
    };
  }
  uploadFile(file) {
    return new Promise((resolve, reject) => {
      const configConst = this.config;
      S3FileUpload.uploadFile(file, configConst).then(data => resolve(data)).catch(err => reject(err));
    });
  }
}
export { ActionsTable, ActivityPicker, AdminBookingStatus, AdminSpaceBookingsTable, AgeGroupsPicker, Agenda, AgendaEvent, Auth, AuthCallback, BankHolidaysTable, Banner, BookingFeesTable, BookingStatus, BookingTypePicker, Button, CancellationPicker, Card, Checkbox, ClashesTable, Column, Contact, Container, DatePicker, DeviceContext, DeviceProvider, DiscountField, Divider, ErrorBoundary, Footer, Header, Heading, Icon, IconButton, Image, InlineError, InputField, InvoiceContactPicker, Label, Link, LinkList, Loading, MceEditor, Modal, ModalContext, ModalProvider, MultiSpacePicker, NotFoundError, NumberField, Placeholder, Property, ProtectedRoute, RecurringBookingBookingsTable, RecurringBookingsTable, RecurringSpaceBookingsTable, RichTextEditor, Row, S3Services, SchoolBookingsTable, SchoolSitePicker, SearchFilters$1 as SearchFilters, Select, Sidebar, SitePicker, SpaceBooker, SpaceBookingsTable, SpacePicker, SpaceRatesTable, SpaceTypePicker, Spacer, Status, TextArea, UserConsumer, UserContext, YearPicker, YearsTable, withAuth };